import {
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  printStackTrace18lnx7a39cni as printStackTrace,
  CancellationException3b36o9qz53rgr as CancellationException,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz6toho1mmc7plk as Duration__hashCode_impl_u4exz6,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  constructCallableReference23y65rf941mch as constructCallableReference,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toString1pkumu07cwy4m as toString,
  toHexString5bhtjxqec7ow as toHexString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  sorted354mfsiv4s7x5 as sorted,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  RuntimeException1r3t0zl97011n as RuntimeException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Long2qws0ah9gnpki as Long,
  compare2uud5j30pw5xc as compare,
  fromInt1lka3ktyu79a4 as fromInt,
  add85si75olwt6n as add,
  subtract16cg4lfi29fq9 as subtract,
  DurationUnit_MICROSECONDS_getInstance2moeotkerjghe as DurationUnit_MICROSECONDS_getInstance,
  numberToLong345n6tb1n1i71 as numberToLong,
  multiply18i3gv3wlmcjg as multiply,
  divide3tol6kxdi8xn6 as divide,
  toNumberlmbpvqo27r53 as toNumber,
  convertToIntofdoxh9bstof as convertToInt,
  toDurationba1nlt78o6vu as toDuration_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  toInt2q8uldh7sc951 as toInt,
  getOrNullef5jbxih7r4f as getOrNull,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr1amknydye3n5l as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  _UByteArray___init__impl__ip4y9n15i9if485vlfd as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hvbbj411cc05mf as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  Monotonic_instance2att21stfwfpk as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs593ou6p5l5hu as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  copyOf39s58md6y6rn6 as copyOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  equalsLong28bsrfhwvd686 as equalsLong,
  println2shhhgwwt4c61 as println,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  toShort36kaw0zjdq3ex as toShort,
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
  UBytep4j7r1t64gz1 as UByte,
  UByte__hashCode_impl_mmczcb2cee63ohbo52b as UByte__hashCode_impl_mmczcb,
  createThis2j2avj17cvnv2 as createThis,
  fill3lmv1pckd4inv as fill,
  fill34ox8qmmmh3u3 as fill_0,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  _UInt___init__impl__l7qpdl2rn8hu5x5mgv2 as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getOrNull1d60i0672n7ns as getOrNull_0,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  boxApply1qmzdb3dh90hg as boxApply,
  KProperty1ca4yb4wlo496 as KProperty1,
  Duration__toString_impl_8d916b1rke7yypzm7mk as Duration__toString_impl_8d916b,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  get_niceStr3crhxydmlnaoj as get_niceStr,
  extract2vhru1ihy4ogl as extract,
  hasFlagsibfubl68mj8u as hasFlags,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  withContextqz5k6d9p9xx5 as withContext,
  delayvyed5wvki0ic as delay,
  yieldyvh2mab0488 as yield_0,
  delay3e2ei0hoxjoud as delay_0,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo3v2pxuza3qdby as readBytesUpTo,
  readStream37xep802rz21z as readStream,
  toSyncOrNull2d7etdx5kh7ns as toSyncOrNull,
  readBytesUpToeg5gy13toqtd as readBytesUpTo_0,
  openSync2m3qn99fqytu0 as openSync,
  readString20u8kjncp0xlx as readString,
  readBytesExact9lk5ofbmnwn5 as readBytesExact,
  readString2gn2js5u0onhc as readString_0,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readS16LE5ndf91ig7ujq as readS16LE,
  readS32LE1s59z1zzhuc7p as readS32LE,
  readU32LE1krwiht3byo6m as readU32LE,
  MemorySyncStreamw5bwb9yy0cam as MemorySyncStream,
  toAsyncc87ncfb6nti7 as toAsync,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  _UByteArrayInt___init__impl__xif7bu20fs1loq9z3ij as _UByteArrayInt___init__impl__xif7bu,
  _UByteArrayInt___get_bytes__impl__pj0ilcf0l2x8xq7gcj as _UByteArrayInt___get_bytes__impl__pj0ilc,
  UByteArrayInt__get_impl_px6q8a35txexjj6o4n0 as UByteArrayInt__get_impl_px6q8a,
  getU83agrw8yj0shar as getU8,
  indexOf1wbggs5i7ilsw as indexOf,
  _UByteArrayInt___init__impl__xif7bu1o76z3u88qyf8 as _UByteArrayInt___init__impl__xif7bu_0,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___init__impl__xif7bu22xrgtz1pdtsf as _UByteArrayInt___init__impl__xif7bu_1,
  UByteArrayInt__set_impl_gn453221vabkkeeuf12 as UByteArrayInt__set_impl_gn4532,
  arraycopy52dxe7vhzf14 as arraycopy,
  arraycopy3n78tfzvkl4kg as arraycopy_0,
  UByteArrayInt__set_impl_gn453226wrap3736y9v as UByteArrayInt__set_impl_gn4532_0,
  UByteArrayInt__fill$default_impl_mdydxi3r6vmt78bnj2k as UByteArrayInt__fill$default_impl_mdydxi,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS24LE1b229asvs5i3l as getS24LE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  Charsets_instance36f67kdzeu1kr as Charsets_instance,
  readStringzinkjpjt71hyo as readStringz,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  binarySearch1lxbagta5e4q4 as binarySearch,
  _BSearchResult___get_nearIndex__impl__s8nq4314o583ijf6vjx as _BSearchResult___get_nearIndex__impl__s8nq43,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  ByteArrayDeque2dezgzzyyl6zm as ByteArrayDeque,
  ShortArrayDeque13dn2tr6asm80 as ShortArrayDeque,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  _AudioSampleArray___init__impl__qpxoq02v35zbbobd74i as _AudioSampleArray___init__impl__qpxoq0,
  _AudioSample___init__impl__s54gd528mhgozdh1bqj as _AudioSample___init__impl__s54gd5,
  AudioSampleArray__set_impl_tqgfwk1pug7fxkhzjb as AudioSampleArray__set_impl_tqgfwk,
  _AudioSample___get_short__impl__uk8ygu1ahnse94tkd3h as _AudioSample___get_short__impl__uk8ygu,
  AudioSampleArray__asShortArray_impl_iyd0md3ucruvh93ttmk as AudioSampleArray__asShortArray_impl_iyd0md,
  AudioSampleArray__get_impl_w0l0xcb5gy68blt832 as AudioSampleArray__get_impl_w0l0xc,
  _AudioSampleArray___get_size__impl__8l8tm833qpwjtzx85jt as _AudioSampleArray___get_size__impl__8l8tm8,
  AudioSampleArray262uyoodhuuvf as AudioSampleArray,
  AudioSamples3pmkh9en9mrjs as AudioSamples,
  AudioData3ewbxcbopprh8 as AudioData,
  ReadonlySoundProps270enpa6r4amt as ReadonlySoundProps,
  SoundProps3stqh6vq4ra4p as SoundProps,
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  Companion_getInstance1rxbh6e5ak2m2 as Companion_getInstance_1,
  AudioSampleArray__fill$default_impl_gh9lh03uipedjkshpvd as AudioSampleArray__fill$default_impl_gh9lh0,
  Companion_instance2dqi4vf5r525o as Companion_instance,
} from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getUnderlyingUnscapedFilenlplw797lms5 as getUnderlyingUnscapedFile,
  get_baseName2yf63efofm8te as get_baseName,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { Companion_getInstance1smdz541y8yio as Companion_getInstance_2 } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  onCancel134048q5p9j85 as onCancel,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  nkm(formats) {
    return (new AudioFormats()).rkm(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.text.trim' call
      var this_0 = item.toLowerCase();
      var tmp$ret$2 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.d2(tmp$ret$2);
    }
    tmp.skm_1 = toSet(destination);
  }
  g81() {
    return this.skm_1;
  }
  *tkm(data, props, $completion) {
    return null;
  }
  *ukm(data, props, $completion) {
    return null;
  }
  *xkm(data, props, $completion) {
    var tmp;
    if (!(props.jkn_1 == null)) {
      tmp = yield* withContext(props.jkn_1, AudioFormat$decodeStream$slambda(this, data, props), $completion);
    } else {
      tmp = yield* this.ukm(data, props, $completion);
    }
    return tmp;
  }
  *ykm(data, props, $completion) {
    var tmp0_elvis_lhs = yield* this.xkm(data, props, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "Can't decode audio stream [" + this.toString() + '] ' + toHexString(yield* readBytesUpTo(data.ub9(), 8, $completion));
      throw IllegalStateException.o(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  h1() {
    return 'AudioFormat';
  }
  toString() {
    return this.h1() + '(' + toString(sorted(this.g81())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.pkm_1 = ArrayList.p2();
    this.qkm_1 = null;
  }
  g81() {
    if (this.qkm_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      var tmp0 = this.pkm_1;
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.p2();
      var _iterator__ex2g4s = tmp0.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        var list = element.g81();
        addAll(destination, list);
      }
      tmp.qkm_1 = toSet(destination);
    }
    return ensureNotNull(this.qkm_1);
  }
  rkm(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.pkm_1;
    addAll_0(this_1, formats);
    return this_0;
  }
  *tkm(data, props, $completion) {
    var _iterator__ex2g4s = this.pkm_1.p1();
    $l$loop: while (_iterator__ex2g4s.q1()) {
      var format = _iterator__ex2g4s.r1();
      try {
        var tmp0_elvis_lhs = yield* format.tkm(data.ub9(), props, $completion);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      } catch ($p) {
        if ($p instanceof CancellationException) {
          var e = $p;
          throw e;
        } else {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
      }
    }
    return null;
  }
  *ukm(data, props, $completion) {
    var _iterator__ex2g4s = this.pkm_1.p1();
    $l$loop_0: while (_iterator__ex2g4s.q1()) {
      var format = _iterator__ex2g4s.r1();
      try {
        if ((yield* format.tkm(data.ub9(), Companion_getInstance_4().wkm_1, $completion)) == null)
          continue $l$loop_0;
        var tmp0_elvis_lhs = yield* format.xkm(data.ub9(), props, $completion);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    return null;
  }
}
class Info {
  constructor(duration, channels, decodingTime) {
    var tmp;
    if (duration === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = duration;
    }
    duration = tmp;
    channels = channels === VOID ? 2 : channels;
    decodingTime = decodingTime === VOID ? null : decodingTime;
    this.zkm_1 = new Mixin();
    this.akn_1 = duration;
    this.bkn_1 = channels;
    this.ckn_1 = decodingTime;
  }
  o9u(_set____db54di) {
    this.zkm_1.o9u(_set____db54di);
  }
  p9u() {
    return this.zkm_1.p9u();
  }
  dkn() {
    var tmp0_elvis_lhs = this.akn_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'Info(duration=' + get_niceStr(get_milliseconds(this.dkn())) + 'ms, channels=' + this.bkn_1 + ')';
  }
  hashCode() {
    var tmp;
    var tmp_0 = this.akn_1;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = 0;
    } else {
      tmp = Duration__hashCode_impl_u4exz6(this.akn_1);
    }
    var result = tmp;
    result = imul(result, 31) + this.bkn_1 | 0;
    var tmp_1 = imul(result, 31);
    var tmp_2;
    var tmp_3 = this.ckn_1;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      tmp_2 = 0;
    } else {
      tmp_2 = Duration__hashCode_impl_u4exz6(this.ckn_1);
    }
    result = tmp_1 + tmp_2 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    var tmp = this.akn_1;
    var tmp_0 = tmp == null ? null : new Duration(tmp);
    var tmp_1 = tmp0_other_with_cast.akn_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Duration(tmp_1)))
      return false;
    if (!(this.bkn_1 === tmp0_other_with_cast.bkn_1))
      return false;
    var tmp_2 = this.ckn_1;
    var tmp_3 = tmp_2 == null ? null : new Duration(tmp_2);
    var tmp_4 = tmp0_other_with_cast.ckn_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new Duration(tmp_4)))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.vkm_1 = new AudioDecodingProps();
    this.wkm_1 = new AudioDecodingProps(false, false);
  }
}
class AudioDecodingProps {
  constructor(exactTimings, readInMemory, formats, maxSamples, dispatcher) {
    Companion_getInstance_4();
    exactTimings = exactTimings === VOID ? null : exactTimings;
    readInMemory = readInMemory === VOID ? true : readInMemory;
    formats = formats === VOID ? null : formats;
    maxSamples = maxSamples === VOID ? 39690000 : maxSamples;
    dispatcher = dispatcher === VOID ? null : dispatcher;
    this.ekn_1 = new Mixin();
    this.fkn_1 = exactTimings;
    this.gkn_1 = readInMemory;
    this.hkn_1 = formats;
    this.ikn_1 = maxSamples;
    this.jkn_1 = dispatcher;
  }
  o9u(_set____db54di) {
    this.ekn_1.o9u(_set____db54di);
  }
  p9u() {
    return this.ekn_1.p9u();
  }
  toString() {
    return 'AudioDecodingProps(exactTimings=' + this.fkn_1 + ', readInMemory=' + this.gkn_1 + ', formats=' + toString_0(this.hkn_1) + ', maxSamples=' + this.ikn_1 + ', dispatcher=' + toString_0(this.jkn_1) + ')';
  }
  hashCode() {
    var result = this.fkn_1 == null ? 0 : getBooleanHashCode(this.fkn_1);
    result = imul(result, 31) + getBooleanHashCode(this.gkn_1) | 0;
    result = imul(result, 31) + (this.hkn_1 == null ? 0 : hashCode(this.hkn_1)) | 0;
    result = imul(result, 31) + this.ikn_1 | 0;
    result = imul(result, 31) + (this.jkn_1 == null ? 0 : hashCode(this.jkn_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioDecodingProps ? other : THROW_CCE();
    if (!(this.fkn_1 == tmp0_other_with_cast.fkn_1))
      return false;
    if (!(this.gkn_1 === tmp0_other_with_cast.gkn_1))
      return false;
    if (!equals(this.hkn_1, tmp0_other_with_cast.hkn_1))
      return false;
    if (!(this.ikn_1 === tmp0_other_with_cast.ikn_1))
      return false;
    if (!equals(this.jkn_1, tmp0_other_with_cast.jkn_1))
      return false;
    return true;
  }
}
class InvalidAudioFormatException extends RuntimeException {
  constructor(message) {
    return new.target.nkn(message);
  }
  static nkn(message) {
    var $this = this.xb(message);
    captureStack($this, $this.mkn_1);
    return $this;
  }
}
class MP3Base extends AudioFormat {
  constructor() {
    super(['mp3']);
  }
  *tkm(data, props, $completion) {
    try {
      var header = yield* readBytesExact(data, 4, $completion);
      // Inline function 'kotlin.collections.toUByteArray' call
      // Inline function 'kotlin.collections.copyOf' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = header.slice();
      var tmp$ret$0 = _UByteArray___init__impl__ip4y9n(tmp$ret$1);
      // Inline function 'kotlin.UByte.toInt' call
      var this_0 = UByteArray__get_impl_t5f3hv(tmp$ret$0, 0);
      var h0 = _UByte___get_data__impl__jof9qr(this_0) & 255;
      // Inline function 'kotlin.collections.toUByteArray' call
      // Inline function 'kotlin.collections.copyOf' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$5 = header.slice();
      var tmp$ret$4 = _UByteArray___init__impl__ip4y9n(tmp$ret$5);
      // Inline function 'kotlin.UByte.toInt' call
      var this_1 = UByteArray__get_impl_t5f3hv(tmp$ret$4, 1);
      var h1 = _UByte___get_data__impl__jof9qr(this_1) & 255;
      // Inline function 'kotlin.collections.toUByteArray' call
      // Inline function 'kotlin.collections.copyOf' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$9 = header.slice();
      var tmp$ret$8 = _UByteArray___init__impl__ip4y9n(tmp$ret$9);
      // Inline function 'kotlin.UByte.toInt' call
      var this_2 = UByteArray__get_impl_t5f3hv(tmp$ret$8, 2);
      var h2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
      var isId3 = readStringz(header, 0, 3) === 'ID3';
      var tmp;
      var tmp_0;
      var tmp_1;
      if (h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226)) {
        // Inline function 'korlibs.memory.extract2' call
        tmp_1 = !(((h1 >>> 1 | 0) & 3) === 0);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'korlibs.memory.extract4' call
        tmp_0 = !(((h2 >>> 4 | 0) & 15) === 15);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'korlibs.memory.extract2' call
        tmp = !(((h2 >>> 2 | 0) & 3) === 3);
      } else {
        tmp = false;
      }
      var isSync = tmp;
      if (!isId3 && !isSync)
        return null;
      var parser = new Parser(data, yield* data.pb8($completion));
      // Inline function 'kotlin.time.measureTimedValue' call
      // Inline function 'kotlin.time.measureTimedValue' call
      var mark = Monotonic_instance.ck();
      var tmp2_subject = props.fkn_1;
      var result = new Duration(tmp2_subject == null ? (yield* parser.rko($completion)).ik_1 : tmp2_subject === true ? (yield* parser.rko($completion)).ik_1 : (yield* parser.qko($completion)).ik_1);
      var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
      var duration = _destruct__k2r9zo.jm().ik_1;
      var decodingTime = _destruct__k2r9zo.nw();
      var tmp3_safe_receiver = parser.dko_1;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.ykn_1;
      var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.skn_1;
      return new Info(duration, tmp0_elvis_lhs == null ? 2 : tmp0_elvis_lhs, decodingTime);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        return null;
      } else {
        throw $p;
      }
    }
  }
}
class MP3 extends MP3Base {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_1 extends MP3 {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = to(item.rkn_1, item);
      destination.d2(tmp$ret$2);
    }
    tmp.tkn_1 = toMap(destination);
  }
}
class ChannelMode extends Enum {
  constructor(name, ordinal, id, channels) {
    super(name, ordinal);
    this.rkn_1 = id;
    this.skn_1 = channels;
  }
}
class Mp3Info {
  constructor(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this.ukn_1 = version;
    this.vkn_1 = layer;
    this.wkn_1 = bitrate;
    this.xkn_1 = samplingRate;
    this.ykn_1 = channelMode;
    this.zkn_1 = frameSize;
    this.ako_1 = samples;
  }
  toString() {
    return 'Mp3Info(version=' + this.ukn_1 + ', layer=' + this.vkn_1 + ', bitrate=' + this.wkn_1 + ', samplingRate=' + this.xkn_1 + ', channelMode=' + this.ykn_1.toString() + ', frameSize=' + this.zkn_1 + ', samples=' + this.ako_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ukn_1);
    result = imul(result, 31) + this.vkn_1 | 0;
    result = imul(result, 31) + this.wkn_1 | 0;
    result = imul(result, 31) + this.xkn_1 | 0;
    result = imul(result, 31) + this.ykn_1.hashCode() | 0;
    result = imul(result, 31) + this.zkn_1 | 0;
    result = imul(result, 31) + this.ako_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this.ukn_1 === tmp0_other_with_cast.ukn_1))
      return false;
    if (!(this.vkn_1 === tmp0_other_with_cast.vkn_1))
      return false;
    if (!(this.wkn_1 === tmp0_other_with_cast.wkn_1))
      return false;
    if (!(this.xkn_1 === tmp0_other_with_cast.xkn_1))
      return false;
    if (!this.ykn_1.equals(tmp0_other_with_cast.ykn_1))
      return false;
    if (!(this.zkn_1 === tmp0_other_with_cast.zkn_1))
      return false;
    if (!(this.ako_1 === tmp0_other_with_cast.ako_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.eko_1 = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.fko_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.kko(1, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$4 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp$ret$4);
    var tmp_4 = this.kko(1, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$5 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp$ret$5);
    var tmp_6 = this.kko(1, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$6 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp$ret$6);
    var tmp_8 = this.kko(2, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$7 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp$ret$7);
    var tmp_10 = this.kko(2, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$8 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp$ret$8);
    var tmp_12 = this.kko(2, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$9 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1.gko_1 = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp$ret$9)]);
    var tmp_13 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$10 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp$ret$10);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$11 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp$ret$11);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$12 = new Int32Array([11025, 12000, 8000]);
    tmp_13.hko_1 = mapOf([tmp_14, tmp_15, to('2.5', tmp$ret$12)]);
    this.iko_1 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  kko(version, layer) {
    return imul(version, 10) + layer | 0;
  }
  jko(f4) {
    var b0 = UByteArrayInt__get_impl_px6q8a(f4, 0);
    var b1 = UByteArrayInt__get_impl_px6q8a(f4, 1);
    var b2 = UByteArrayInt__get_impl_px6q8a(f4, 2);
    var b3 = UByteArrayInt__get_impl_px6q8a(f4, 3);
    if (!(b0 === 255)) {
      get_invalidOp();
    }
    var version = this.eko_1[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this.fko_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.kko(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp6_safe_receiver = this.gko_1.w4(bitrate_key);
    var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : getOrNull(tmp6_safe_receiver, bitrate_idx);
    var bitrate = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp7_safe_receiver = this.hko_1.w4(version);
    var tmp1_elvis_lhs = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, extract(b2, 2, 2));
    var sample_rate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_6().tkn_1.w4(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp8_safe_receiver = this.iko_1.w4(simple_version);
    var tmp2_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.w4(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
  }
}
class SeekingTable {
  constructor(microseconds, filePositions) {
    this.lko_1 = microseconds;
    this.mko_1 = filePositions;
  }
  nko() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.lko_1.u2(this.lko_1.s2() - 1 | 0);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  oko(rate) {
    return numberToLong(get_seconds(this.nko()) * rate);
  }
  pko(time) {
    // Inline function 'korlibs.time.microseconds' call
    var searchMicro = toNumber(_Duration___get_inWholeNanoseconds__impl__r5x4mr(time)) / 1000.0;
    var result = binarySearch(this.lko_1, searchMicro);
    return numberToLong(this.mko_1.u2(_BSearchResult___get_nearIndex__impl__s8nq43(result)));
  }
}
class Parser {
  constructor(data, dataLength) {
    Companion_getInstance_7();
    this.bko_1 = data;
    this.cko_1 = dataLength;
    this.dko_1 = null;
  }
  *qko($completion) {
    return yield* /*#__NOINLINE__*/_getDuration(this, true, VOID, $completion);
  }
  *rko($completion) {
    return yield* /*#__NOINLINE__*/_getDuration(this, false, VOID, $completion);
  }
  *sko($completion) {
    var times = DoubleArrayList.ga3();
    var filePositions = DoubleArrayList.ga3();
    yield* /*#__NOINLINE__*/_getDuration(this, false, MP3Base$Parser$getSeekingTable$lambda(times, filePositions), $completion);
    return new SeekingTable(times, filePositions);
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_8();
    super(['mp3']);
    this.uko_1 = Minimp3AudioFormat_getInstance();
  }
  *tkm(data, props, $completion) {
    return yield* this.uko_1.tkm(data, props, $completion);
  }
  *ukm(data, props, $completion) {
    return yield* this.uko_1.xkm(data, props, $completion);
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_4 extends MP3Decoder {
  constructor() {
    Companion_instance_5 = null;
    super();
    Companion_instance_5 = this;
  }
}
class MiniMp3Program {
  constructor() {
    Companion_getInstance_10();
    this.okp_1 = new Int32Array(3);
    this.pkp_1 = new Float32Array(9);
    this.qkp_1 = new Float32Array(9);
    this.rkp_1 = new Float32Array(4);
    this.skp_1 = new Float32Array(4);
    this.tkp_1 = Mp3Scratch.skv();
    this.ukp_1 = new Bs();
  }
  ukq(dst, src, size) {
    arraycopy(src.bkw_1, src.ckw_1, dst.bkw_1, dst.ckw_1, size);
  }
  vkq(dst, src, size) {
    arraycopy_0(src.xkv_1, src.ykv_1, dst.xkv_1, dst.ykv_1, size);
  }
  wkq(bs, data, bytes) {
    bs.hkv_1 = data;
    bs.ikv_1 = 0;
    bs.jkv_1 = imul(bytes, 8);
  }
  xkq(bs, n) {
    var cache = 0;
    var s = bs.ikv_1 & 7;
    var shl = n + s | 0;
    var p = bs.hkv_1.wkv(bs.ikv_1 >>> 3 | 0);
    bs.ikv_1 = bs.ikv_1 + n | 0;
    if (bs.ikv_1 > bs.jkv_1)
      return 0;
    var next = p.k3() & (255 >>> s | 0);
    p = p.vkv();
    $l$loop: while (true) {
      shl = shl - 8 | 0;
      if (shl <= 0)
        break $l$loop;
      cache = cache | next << shl;
      next = p.k3();
      p = p.vkv();
    }
    return cache | (next >>> (-shl | 0) | 0);
  }
  ykq(h) {
    var h0 = h.u2(0);
    var h1 = h.u2(1);
    var h2 = h.u2(2);
    return h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226) && !((h1 >> 1 & 3) === 0) && !(h2 >> 4 === 15) && !((h2 >> 2 & 3) === 3);
  }
  zkq(h1, h2) {
    return toInt_0(this, this.ykq(h2) && ((h1.u2(1) ^ h2.u2(1)) & 254) === 0 && ((h1.u2(2) ^ h2.u2(2)) & 12) === 0 && (toInt_0(this, (h1.u2(2) & 240) === 0) ^ toInt_0(this, (h2.u2(2) & 240) === 0)) === 0);
  }
  akr(h) {
    return imul(2, UByteArrayInt__get_impl_px6q8a(Companion_getInstance_10().kku_1[toInt_0(this, !((h.u2(1) & 8) === 0))][(h.u2(1) >> 1 & 3) - 1 | 0].ab2_1, h.u2(2) >> 4));
  }
  bkr(h) {
    var g_hz = Companion_getInstance_10().jku_1;
    return g_hz[h.u2(2) >> 2 & 3] >> toInt_0(this, (h.u2(1) & 8) === 0) >> toInt_0(this, (h.u2(1) & 16) === 0);
  }
  ckr(h) {
    return (h.u2(1) & 6) === 6 ? 384 : 1152 >> toInt_0(this, (h.u2(1) & 14) === 2);
  }
  dkr(h, free_format_size) {
    var frame_bytes = imul(imul(this.ckr(h), this.akr(h)), 125) / this.bkr(h) | 0;
    if ((h.u2(1) & 6) === 6) {
      frame_bytes = frame_bytes & -4;
    }
    return !(frame_bytes === 0) ? frame_bytes : free_format_size;
  }
  ekr(h) {
    return !((h.u2(2) & 2) === 0) ? (h.u2(1) & 6) === 6 ? 4 : 1 : 0;
  }
  fkr(hdr, sci) {
    var alloc = Companion_getInstance_10().yku_1;
    var mode = hdr.u2(3) >> 6 & 3;
    var nbands;
    var stereo_bands;
    switch (mode) {
      case 3:
        stereo_bands = 0;
        break;
      case 1:
        stereo_bands = ((hdr.u2(3) >> 4 & 3) << 2) + 4 | 0;
        break;
      default:
        stereo_bands = 32;
        break;
    }
    if ((hdr.u2(1) & 6) === 6) {
      alloc = Companion_getInstance_10().yku_1;
      nbands = 32;
    } else if ((hdr.u2(1) & 8) === 0) {
      alloc = Companion_getInstance_10().zku_1;
      nbands = 30;
    } else {
      var sample_rate_idx = hdr.u2(2) >> 2 & 3;
      var kbps = this.akr(hdr) >> toInt_0(this, !(mode === 3));
      if (kbps === 0)
        kbps = 192;
      alloc = Companion_getInstance_10().akv_1;
      nbands = 27;
      if (kbps < 56) {
        alloc = Companion_getInstance_10().bkv_1;
        nbands = sample_rate_idx === 2 ? 12 : 8;
      } else if (kbps >= 96 && !(sample_rate_idx === 1)) {
        nbands = 30;
      }
    }
    sci.bkx_1 = nbands;
    sci.ckx_1 = stereo_bands > nbands ? nbands : stereo_bands;
    return alloc;
  }
  gkr(bs, pba, scfcod, bands, scf) {
    var scfOffset = 0;
    var g_deq_L12 = Companion_getInstance_10().iku_1;
    var inductionVariable = 0;
    if (inductionVariable < bands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s = 0.0;
        var ba = UByteArrayInt__get_impl_px6q8a(pba, i);
        var mask = !(ba === 0) ? 4 + (19 >> UByteArrayInt__get_impl_px6q8a(scfcod, i) & 3) | 0 : 0;
        var m = 4;
        while (!(m === 0)) {
          if (!((mask & m) === 0)) {
            var b = this.xkq(bs, 6);
            s = g_deq_L12[(imul(ba, 3) - 6 | 0) + (b % 3 | 0) | 0] * (2097152 >> (b / 3 | 0));
          }
          scf.ekw(scfOffset, s);
          m = m >> 1;
          scfOffset = scfOffset + 1 | 0;
        }
      }
       while (inductionVariable < bands);
  }
  hkr(hdr, bs, sci) {
    var g_bitalloc_code_tab = new UByteArrayIntPtr(Companion_getInstance_10().tku_1);
    var subband_alloc = this.fkr(hdr, sci);
    var subband_alloc_n = 0;
    var k = 0;
    var ba_bits = 0;
    var ba_code_tab = g_bitalloc_code_tab;
    var inductionVariable = 0;
    var last = sci.bkx_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ba = 0;
        if (i === k) {
          var tmp = k;
          // Inline function 'kotlin.UByte.toInt' call
          var this_0 = subband_alloc[subband_alloc_n].fkv_1;
          k = tmp + (_UByte___get_data__impl__jof9qr(this_0) & 255) | 0;
          // Inline function 'kotlin.UByte.toInt' call
          var this_1 = subband_alloc[subband_alloc_n].ekv_1;
          ba_bits = _UByte___get_data__impl__jof9qr(this_1) & 255;
          // Inline function 'kotlin.UByte.toInt' call
          var this_2 = subband_alloc[subband_alloc_n].dkv_1;
          var tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
          ba_code_tab = g_bitalloc_code_tab.wkv(tmp$ret$2);
          subband_alloc_n = subband_alloc_n + 1 | 0;
        }
        ba = ba_code_tab.u2(this.xkq(bs, ba_bits));
        UByteArrayInt__set_impl_gn4532(sci.dkx_1, imul(2, i), ba);
        if (i < sci.ckx_1) {
          ba = ba_code_tab.u2(this.xkq(bs, ba_bits));
        }
        UByteArrayInt__set_impl_gn4532(sci.dkx_1, imul(2, i) + 1 | 0, !(sci.ckx_1 === 0) ? ba : 0);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = imul(2, sci.bkx_1);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.ekx_1, i_0, !(UByteArrayInt__get_impl_px6q8a(sci.dkx_1, i_0) === 0) ? (hdr.u2(1) & 6) === 6 ? 2 : this.xkq(bs, 2) : 6);
      }
       while (inductionVariable_0 < last_0);
    this.gkr(bs, sci.dkx_1, sci.ekx_1, imul(sci.bkx_1, 2), new FloatArrayPtr(sci.akx_1));
    var inductionVariable_1 = sci.ckx_1;
    var last_1 = sci.bkx_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.dkx_1, imul(2, i_1) + 1 | 0, 0);
      }
       while (inductionVariable_1 < last_1);
  }
  ikr(grbuf, bs, sci, group_size) {
    var choff = 576;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dst = grbuf.wkv(imul(group_size, j));
        var inductionVariable_0 = 0;
        var last = imul(2, sci.bkx_1);
        if (inductionVariable_0 < last)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ba = UByteArrayInt__get_impl_px6q8a(sci.dkx_1, i);
            if (!(ba === 0)) {
              if (ba < 17) {
                var half = (1 << (ba - 1 | 0)) - 1 | 0;
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < group_size)
                  do {
                    var k = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    dst.ekw(k, this.xkq(bs, ba) - half | 0);
                  }
                   while (inductionVariable_1 < group_size);
              } else {
                var mod = (2 << (ba - 17 | 0)) + 1 | 0;
                var code = this.xkq(bs, (mod + 2 | 0) - (mod >> 3) | 0);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < group_size)
                  do {
                    var k_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    dst.ekw(k_0, (code % mod | 0) - (mod / 2 | 0) | 0);
                    code = code / mod | 0;
                  }
                   while (inductionVariable_2 < group_size);
              }
            }
            dst = dst.wkv(choff);
            choff = 18 - choff | 0;
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < 4);
    return imul(group_size, 4);
  }
  jkr(sci, scf, dst) {
    var scf_0 = scf;
    var dst_0 = dst;
    this.ukq(dst_0.wkv(576).wkv(imul(sci.ckx_1, 18)), dst_0.wkv(imul(sci.ckx_1, 18)), imul(sci.bkx_1 - sci.ckx_1 | 0, 18));
    var inductionVariable = 0;
    var last = sci.bkx_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 12)
          do {
            var k = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            dst_0.ekw(k + 0 | 0, dst_0.u2(k + 0 | 0) * scf_0.u2(0));
            dst_0.ekw(k + 576 | 0, dst_0.u2(k + 576 | 0) * scf_0.u2(3));
          }
           while (inductionVariable_0 < 12);
        dst_0 = dst_0.wkv(18);
        scf_0 = scf_0.wkv(6);
      }
       while (inductionVariable < last);
  }
  kkr(bs, gr, hdr) {
    var gr_0 = gr;
    var g_scf_long = Companion_getInstance_10().uku_1;
    var g_scf_short = Companion_getInstance_10().vku_1;
    var g_scf_mixed = Companion_getInstance_10().wku_1;
    var tables;
    var scfsi = 0;
    var main_data_begin;
    var part_23_sum = 0;
    var sr_idx = (hdr.u2(2) >> 2 & 3) + imul((hdr.u2(1) >> 3 & 1) + (hdr.u2(1) >> 4 & 1) | 0, 3) | 0;
    sr_idx = sr_idx - toInt_0(this, !(sr_idx === 0)) | 0;
    var gr_count = (hdr.u2(3) & 192) === 192 ? 1 : 2;
    if (!((hdr.u2(1) & 8) === 0)) {
      gr_count = imul(gr_count, 2);
      main_data_begin = this.xkq(bs, 9);
      scfsi = this.xkq(bs, 7 + gr_count | 0);
    } else {
      main_data_begin = this.xkq(bs, 8 + gr_count | 0) >> gr_count;
    }
    $l$1: do {
      $l$0: do {
        if ((hdr.u2(3) & 192) === 192) {
          scfsi = scfsi << 4;
        }
        gr_0.k3().lkw_1 = this.xkq(bs, 12);
        part_23_sum = part_23_sum + gr_0.k3().lkw_1 | 0;
        gr_0.k3().mkw_1 = this.xkq(bs, 9);
        if (gr_0.k3().mkw_1 > 288)
          return -1;
        gr_0.k3().okw_1 = this.xkq(bs, 8);
        gr_0.k3().nkw_1 = this.xkq(bs, !((hdr.u2(1) & 8) === 0) ? 4 : 9);
        gr_0.k3().kkw_1 = new UByteArrayIntPtr(g_scf_long[sr_idx].ab2_1);
        gr_0.k3().rkw_1 = 22;
        gr_0.k3().skw_1 = 0;
        if (!(this.xkq(bs, 1) === 0)) {
          gr_0.k3().pkw_1 = this.xkq(bs, 2);
          if (gr_0.k3().pkw_1 === 0)
            return -1;
          gr_0.k3().qkw_1 = this.xkq(bs, 1);
          UByteArrayInt__set_impl_gn4532_0(gr_0.k3().ukw_1, 0, _UByte___init__impl__g9hnc4(7));
          UByteArrayInt__set_impl_gn4532(gr_0.k3().ukw_1, 1, 255);
          if (gr_0.k3().pkw_1 === 2) {
            scfsi = scfsi & 3855;
            if (gr_0.k3().qkw_1 === 0) {
              UByteArrayInt__set_impl_gn4532(gr_0.k3().ukw_1, 0, 8);
              gr_0.k3().kkw_1 = new UByteArrayIntPtr(g_scf_short[sr_idx].ab2_1);
              gr_0.k3().rkw_1 = 0;
              gr_0.k3().skw_1 = 39;
            } else {
              gr_0.k3().kkw_1 = new UByteArrayIntPtr(g_scf_mixed[sr_idx].ab2_1);
              gr_0.k3().rkw_1 = !((hdr.u2(1) & 8) === 0) ? 8 : 6;
              gr_0.k3().skw_1 = 30;
            }
          }
          tables = this.xkq(bs, 10);
          tables = tables << 5;
          UByteArrayInt__set_impl_gn4532(gr_0.k3().vkw_1, 0, this.xkq(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.k3().vkw_1, 1, this.xkq(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.k3().vkw_1, 2, this.xkq(bs, 3));
        } else {
          gr_0.k3().pkw_1 = 0;
          gr_0.k3().qkw_1 = 0;
          tables = this.xkq(bs, 15);
          UByteArrayInt__set_impl_gn4532(gr_0.k3().ukw_1, 0, this.xkq(bs, 4));
          UByteArrayInt__set_impl_gn4532(gr_0.k3().ukw_1, 1, this.xkq(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.k3().ukw_1, 2, 255);
        }
        UByteArrayInt__set_impl_gn4532(gr_0.k3().tkw_1, 0, tables >> 10);
        UByteArrayInt__set_impl_gn4532(gr_0.k3().tkw_1, 1, tables >> 5 & 31);
        UByteArrayInt__set_impl_gn4532(gr_0.k3().tkw_1, 2, tables & 31);
        gr_0.k3().wkw_1 = !((hdr.u2(1) & 8) === 0) ? this.xkq(bs, 1) : toInt_0(this, gr_0.k3().nkw_1 >= 500);
        gr_0.k3().xkw_1 = this.xkq(bs, 1);
        gr_0.k3().ykw_1 = this.xkq(bs, 1);
        gr_0.k3().zkw_1 = scfsi >> 12 & 15;
        scfsi = scfsi << 4;
        gr_0 = gr_0.vkv();
      }
       while (false);
      gr_count = gr_count - 1 | 0;
    }
     while (!(gr_count === 0));
    if ((part_23_sum + bs.ikv_1 | 0) > (bs.jkv_1 + imul(main_data_begin, 8) | 0))
      return -1;
    return main_data_begin;
  }
  lkr(scf, ist_pos, scf_size, scf_count, bitbuf, scfsi) {
    var scf_0 = scf;
    var ist_pos_0 = new UByteArrayIntPtr(ist_pos);
    var scfsi_0 = scfsi;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (scf_count.u2(i) === 0)
          break $l$loop;
        var cnt = scf_count.u2(i);
        if (!((scfsi_0 & 8) === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < cnt)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              scf_0.s7x(n, ist_pos_0.u2(n));
            }
             while (inductionVariable_0 < cnt);
        } else {
          var bits = UByteArrayInt__get_impl_px6q8a(scf_size, i);
          if (bits === 0) {
            scf_0.akw(_UByte___init__impl__g9hnc4(0), 0, cnt);
            ist_pos_0.akw(_UByte___init__impl__g9hnc4(0), 0, cnt);
          } else {
            var max_scf = convertToInt(scfsi_0 < 0 ? fromInt((1 << bits) - 1 | 0) : new Long(-1, -1));
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < cnt)
              do {
                var k = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var s = this.xkq(bitbuf, bits);
                ist_pos_0.s7x(k, convertToInt(s === max_scf ? new Long(-1, -1) : fromInt(s)));
                scf_0.s7x(k, s);
              }
               while (inductionVariable_1 < cnt);
          }
        }
        ist_pos_0 = ist_pos_0.wkv(cnt);
        scf_0 = scf_0.wkv(cnt);
        scfsi_0 = imul(scfsi_0, 2);
      }
       while (inductionVariable < 4);
    scf_0.s7x(0, 0);
    scf_0.s7x(1, 0);
    scf_0.s7x(2, 0);
  }
  mkr(y, exp_q2) {
    var y_0 = y;
    var exp_q2_0 = exp_q2;
    var g_expfrac = Companion_getInstance_10().hku_1;
    do {
      var e = 120 > exp_q2_0 ? exp_q2_0 : 120;
      y_0 = y_0 * (g_expfrac[e & 3] * (1073741824 >> (e >> 2)));
      exp_q2_0 = exp_q2_0 - e | 0;
    }
     while (exp_q2_0 > 0);
    return y_0;
  }
  nkr(hdr, ist_pos, bs, gr, scf, ch) {
    var g_scf_partitions = Companion_getInstance_10().xku_1;
    var scf_partition = new UByteArrayIntPtr(g_scf_partitions[toInt_0(this, !(gr.k3().skw_1 === 0)) + toInt_0(this, gr.k3().rkw_1 === 0) | 0].ab2_1);
    var scf_size = _UByteArrayInt___init__impl__xif7bu_1(4);
    var iscf = _UByteArrayInt___init__impl__xif7bu_1(40);
    var scf_shift = gr.k3().xkw_1 + 1 | 0;
    var scfsi = gr.k3().zkw_1;
    if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
      var g_scfc_decode = Companion_getInstance_10().lku_1;
      var part = UByteArrayInt__get_impl_px6q8a(g_scfc_decode, gr.k3().nkw_1);
      UByteArrayInt__set_impl_gn4532(scf_size, 0, part >> 2);
      UByteArrayInt__set_impl_gn4532(scf_size, 1, UByteArrayInt__get_impl_px6q8a(scf_size, 0));
      UByteArrayInt__set_impl_gn4532(scf_size, 2, part & 3);
      UByteArrayInt__set_impl_gn4532(scf_size, 3, UByteArrayInt__get_impl_px6q8a(scf_size, 2));
    } else {
      var g_mod = Companion_getInstance_10().mku_1;
      var ist = toInt_0(this, !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 16) === 0) && !(ch === 0));
      var sfc = gr.k3().nkw_1 >> ist;
      var k = imul(imul(ist, 3), 4);
      while (sfc >= 0) {
        var modprod = 1;
        var inductionVariable = 3;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            UByteArrayInt__set_impl_gn4532(scf_size, i, (sfc / modprod | 0) % UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0) | 0);
            modprod = imul(modprod, UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0));
          }
           while (0 <= inductionVariable);
        sfc = sfc - modprod | 0;
        k = k + 4 | 0;
      }
      scf_partition = scf_partition.wkv(k);
      scfsi = -16;
    }
    this.lkr(new UByteArrayIntPtr(iscf), ist_pos, scf_size, scf_partition, bs, scfsi);
    if (!(gr.k3().skw_1 === 0)) {
      var sh = 3 - scf_shift | 0;
      var progression = step(until(0, gr.k3().skw_1), 3);
      var inductionVariable_0 = progression.n3_1;
      var last = progression.o3_1;
      var step_0 = progression.p3_1;
      if (step_0 > 0 && inductionVariable_0 <= last || (step_0 < 0 && last <= inductionVariable_0))
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          UByteArrayInt__set_impl_gn4532(iscf, (gr.k3().rkw_1 + i_0 | 0) + 0 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.k3().rkw_1 + i_0 | 0) + 0 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.k3().vkw_1, 0) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.k3().rkw_1 + i_0 | 0) + 1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.k3().rkw_1 + i_0 | 0) + 1 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.k3().vkw_1, 1) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.k3().rkw_1 + i_0 | 0) + 2 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.k3().rkw_1 + i_0 | 0) + 2 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.k3().vkw_1, 2) << sh) | 0);
        }
         while (!(i_0 === last));
    } else {
      if (!(gr.k3().wkw_1 === 0)) {
        var g_preamp = Companion_getInstance_10().nku_1;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 10)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(iscf, 11 + i_1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, 11 + i_1 | 0) + UByteArrayInt__get_impl_px6q8a(g_preamp, i_1) | 0);
          }
           while (inductionVariable_1 < 10);
      }
    }
    var gain_exp = (convertToInt(add(numberToLong(gr.k3().okw_1), new Long(-4, -1))) - 210 | 0) - ((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 224) === 96 ? 2 : 0) | 0;
    var gain = this.mkr(2048, convertToInt(subtract(new Long(44, 0), fromInt(gain_exp))));
    var inductionVariable_2 = 0;
    var last_0 = gr.k3().rkw_1 + gr.k3().skw_1 | 0;
    if (inductionVariable_2 < last_0)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        scf.ekw(i_2, this.mkr(gain, UByteArrayInt__get_impl_px6q8a(iscf, i_2) << scf_shift));
      }
       while (inductionVariable_2 < last_0);
  }
  okr(x) {
    var x_0 = x;
    var mult = 256;
    if (x_0 < 129)
      return Companion_getInstance_10().ckv_1[16 + x_0 | 0];
    if (x_0 < 1024) {
      mult = 16;
      x_0 = x_0 << 3;
    }
    var sign = imul(2, x_0) & 64;
    var frac = ((x_0 & 63) - sign | 0) / ((x_0 & -64) + sign | 0);
    return Companion_getInstance_10().ckv_1[16 + ((x_0 + sign | 0) >> 6) | 0] * (1.0 + frac * (4.0 / 3.0 + frac * (2.0 / 9.0))) * mult;
  }
  pkr(dst, bs, gr_info, scf, layer3gr_limit) {
    var dst_0 = dst;
    var scf_0 = scf;
    var tabs = Companion_getInstance_10().oku_1;
    var tab32 = Companion_getInstance_10().pku_1;
    var tab33 = Companion_getInstance_10().qku_1;
    var tabindex = Companion_getInstance_10().rku_1;
    var g_linbits = Companion_getInstance_10().sku_1;
    var one = 0.0;
    var ireg = 0;
    var big_val_cnt = gr_info.k3().mkw_1;
    var sfb = gr_info.k3().kkw_1;
    var bs_next_ptr = bs.hkv_1.wkv(bs.ikv_1 / 8 | 0);
    // Inline function 'kotlin.toUInt' call
    var this_0 = (imul(imul(imul(bs_next_ptr.u2(0), 256) + bs_next_ptr.u2(1) | 0, 256) + bs_next_ptr.u2(2) | 0, 256) + bs_next_ptr.u2(3) | 0) << (bs.ikv_1 & 7);
    var bs_cache = _UInt___init__impl__l7qpdl(this_0);
    var pairs_to_decode = 0;
    var np = 0;
    var bs_sh = (bs.ikv_1 & 7) - 8 | 0;
    bs_next_ptr = bs_next_ptr.wkv(4);
    while (big_val_cnt > 0) {
      var tab_num = UByteArrayInt__get_impl_px6q8a(gr_info.k3().tkw_1, ireg);
      var tmp = gr_info.k3().ukw_1;
      var _unary__edvuaz = ireg;
      ireg = _unary__edvuaz + 1 | 0;
      var sfb_cnt = UByteArrayInt__get_impl_px6q8a(tmp, _unary__edvuaz);
      var codebook = tabindex[tab_num];
      var linbits = UByteArrayInt__get_impl_px6q8a(g_linbits, tab_num);
      if (!(linbits === 0)) {
        $l$3: do {
          $l$2: do {
            np = sfb.k3() / 2 | 0;
            sfb = sfb.vkv();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_0 = scf_0;
            scf_0 = _unary__edvuaz_0.vkv();
            one = _unary__edvuaz_0.k3();
            $l$1: do {
              $l$0: do {
                var w = 5;
                var tmp0 = bs_cache;
                // Inline function 'kotlin.UInt.shr' call
                var bitCount = 32 - w | 0;
                // Inline function 'kotlin.UInt.toInt' call
                var this_1 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0) >>> bitCount | 0);
                var leaf = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_1) | 0];
                while (leaf < 0) {
                  var tmp0_0 = bs_cache;
                  // Inline function 'kotlin.UInt.shl' call
                  var bitCount_0 = w;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_0) << bitCount_0);
                  bs_sh = bs_sh + w | 0;
                  w = leaf & 7;
                  var tmp0_1 = bs_cache;
                  // Inline function 'kotlin.UInt.shr' call
                  var bitCount_1 = 32 - w | 0;
                  // Inline function 'kotlin.UInt.toInt' call
                  var this_2 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_1) >>> bitCount_1 | 0);
                  leaf = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_2) | 0) - (leaf >> 3) | 0];
                }
                var tmp0_2 = bs_cache;
                // Inline function 'kotlin.UInt.shl' call
                var bitCount_2 = leaf >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_2) << bitCount_2);
                bs_sh = bs_sh + (leaf >> 8) | 0;
                var inductionVariable = 0;
                if (inductionVariable < 2)
                  do {
                    var j = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var lsb = leaf & 15;
                    if (lsb === 15) {
                      var tmp_0 = lsb;
                      var tmp0_3 = bs_cache;
                      // Inline function 'kotlin.UInt.shr' call
                      var bitCount_3 = 32 - linbits | 0;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_3) >>> bitCount_3 | 0);
                      lsb = tmp_0 + _UInt___get_data__impl__f0vqqw(this_3) | 0;
                      // Inline function 'kotlin.UInt.shl' call
                      var this_4 = bs_cache;
                      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) << linbits);
                      bs_sh = bs_sh + linbits | 0;
                      while (bs_sh >= 0) {
                        var tmp0_4 = bs_cache;
                        // Inline function 'kotlin.toUInt' call
                        var this_5 = bs_next_ptr.k3() << bs_sh;
                        // Inline function 'kotlin.UInt.or' call
                        var other = _UInt___init__impl__l7qpdl(this_5);
                        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_4) | _UInt___get_data__impl__f0vqqw(other));
                        bs_next_ptr = bs_next_ptr.vkv();
                        bs_sh = bs_sh - 8 | 0;
                      }
                      var tmp_1 = dst_0;
                      var tmp_2 = one * this.okr(lsb);
                      var tmp_3;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_6 = bs_cache;
                      if (_UInt___get_data__impl__f0vqqw(this_6) < 0) {
                        tmp_3 = new Long(-1, -1);
                      } else {
                        tmp_3 = new Long(1, 0);
                      }
                      tmp_1.dkw(tmp_2 * toNumber(tmp_3));
                    } else {
                      var tmp_4 = dst_0;
                      var tmp_5 = Companion_getInstance_10().ckv_1;
                      var tmp_6 = 16 + lsb | 0;
                      // Inline function 'kotlin.UInt.shr' call
                      var this_7 = bs_cache;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_7) >>> 31 | 0);
                      var tmp$ret$14 = _UInt___get_data__impl__f0vqqw(this_8);
                      tmp_4.dkw(tmp_5[tmp_6 - imul(16, tmp$ret$14) | 0] * one);
                    }
                    var tmp0_5 = bs_cache;
                    // Inline function 'kotlin.UInt.shl' call
                    var bitCount_4 = !(lsb === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_5) << bitCount_4);
                    bs_sh = bs_sh + (!(lsb === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.vkv();
                    leaf = leaf >> 4;
                  }
                   while (inductionVariable < 2);
                while (bs_sh >= 0) {
                  var tmp0_6 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_9 = bs_next_ptr.k3() << bs_sh;
                  // Inline function 'kotlin.UInt.or' call
                  var other_0 = _UInt___init__impl__l7qpdl(this_9);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_6) | _UInt___get_data__impl__f0vqqw(other_0));
                  bs_next_ptr = bs_next_ptr.vkv();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_7;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_7 = sfb_cnt >= 0;
          } else {
            tmp_7 = false;
          }
        }
         while (tmp_7);
      } else {
        $l$7: do {
          $l$6: do {
            np = sfb.k3() / 2 | 0;
            sfb = sfb.vkv();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_1 = scf_0;
            scf_0 = _unary__edvuaz_1.vkv();
            one = _unary__edvuaz_1.k3();
            $l$5: do {
              $l$4: do {
                var w_0 = 5;
                var tmp0_7 = bs_cache;
                // Inline function 'kotlin.UInt.shr' call
                var bitCount_5 = 32 - w_0 | 0;
                // Inline function 'kotlin.UInt.toInt' call
                var this_10 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_7) >>> bitCount_5 | 0);
                var leaf_0 = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_10) | 0];
                while (leaf_0 < 0) {
                  var tmp0_8 = bs_cache;
                  // Inline function 'kotlin.UInt.shl' call
                  var bitCount_6 = w_0;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_8) << bitCount_6);
                  bs_sh = bs_sh + w_0 | 0;
                  w_0 = leaf_0 & 7;
                  var tmp0_9 = bs_cache;
                  // Inline function 'kotlin.UInt.shr' call
                  var bitCount_7 = 32 - w_0 | 0;
                  // Inline function 'kotlin.UInt.toInt' call
                  var this_11 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_9) >>> bitCount_7 | 0);
                  leaf_0 = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_11) | 0) - (leaf_0 >> 3) | 0];
                }
                var tmp0_10 = bs_cache;
                // Inline function 'kotlin.UInt.shl' call
                var bitCount_8 = leaf_0 >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_10) << bitCount_8);
                bs_sh = bs_sh + (leaf_0 >> 8) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < 2)
                  do {
                    var j_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var lsb_0 = leaf_0 & 15;
                    var tmp_8 = dst_0;
                    var tmp_9 = Companion_getInstance_10().ckv_1;
                    var tmp_10 = 16 + lsb_0 | 0;
                    // Inline function 'kotlin.UInt.shr' call
                    var this_12 = bs_cache;
                    // Inline function 'kotlin.UInt.toInt' call
                    var this_13 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_12) >>> 31 | 0);
                    var tmp$ret$25 = _UInt___get_data__impl__f0vqqw(this_13);
                    tmp_8.dkw(tmp_9[tmp_10 - imul(16, tmp$ret$25) | 0] * one);
                    var tmp0_11 = bs_cache;
                    // Inline function 'kotlin.UInt.shl' call
                    var bitCount_9 = !(lsb_0 === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_11) << bitCount_9);
                    bs_sh = bs_sh + (!(lsb_0 === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.vkv();
                    leaf_0 = leaf_0 >> 4;
                  }
                   while (inductionVariable_0 < 2);
                while (bs_sh >= 0) {
                  var tmp0_12 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_14 = bs_next_ptr.k3() << bs_sh;
                  // Inline function 'kotlin.UInt.or' call
                  var other_1 = _UInt___init__impl__l7qpdl(this_14);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_12) | _UInt___get_data__impl__f0vqqw(other_1));
                  bs_next_ptr = bs_next_ptr.vkv();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_11;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_11 = sfb_cnt >= 0;
          } else {
            tmp_11 = false;
          }
        }
         while (tmp_11);
      }
    }
    np = 1 - big_val_cnt | 0;
    $l$loop_1: while (true) {
      var codebook_count1 = !(gr_info.k3().ykw_1 === 0) ? tab33 : tab32;
      // Inline function 'kotlin.UInt.shr' call
      var this_15 = bs_cache;
      // Inline function 'kotlin.UInt.toInt' call
      var this_16 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_15) >>> 28 | 0);
      var tmp$ret$30 = _UInt___get_data__impl__f0vqqw(this_16);
      var leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp$ret$30);
      if ((leaf_1 & 8) === 0) {
        var tmp_12 = leaf_1 >> 3;
        // Inline function 'kotlin.UInt.shl' call
        var this_17 = bs_cache;
        var tmp0_13 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_17) << 4);
        // Inline function 'kotlin.UInt.shr' call
        var bitCount_10 = 32 - (leaf_1 & 3) | 0;
        // Inline function 'kotlin.UInt.toInt' call
        var this_18 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_13) >>> bitCount_10 | 0);
        var tmp$ret$33 = _UInt___get_data__impl__f0vqqw(this_18);
        leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp_12 + tmp$ret$33 | 0);
      }
      var tmp0_14 = bs_cache;
      // Inline function 'kotlin.UInt.shl' call
      var bitCount_11 = leaf_1 & 7;
      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_14) << bitCount_11);
      bs_sh = bs_sh + (leaf_1 & 7) | 0;
      if (((imul(bs_next_ptr.zkv(bs.hkv_1), 8) - 24 | 0) + bs_sh | 0) > layer3gr_limit) {
        break $l$loop_1;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.k3() / 2 | 0;
        sfb = sfb.vkv();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_2 = scf_0;
        scf_0 = _unary__edvuaz_2.vkv();
        one = _unary__edvuaz_2.k3();
      }
      if (!((leaf_1 & 128) === 0)) {
        var tmp_13 = dst_0;
        var tmp_14;
        // Inline function 'kotlin.UInt.toInt' call
        var this_19 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_19) < 0) {
          tmp_14 = -one;
        } else {
          tmp_14 = one;
        }
        tmp_13.ekw(0, tmp_14);
        // Inline function 'kotlin.UInt.shl' call
        var this_20 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_20) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 64) === 0)) {
        var tmp_15 = dst_0;
        var tmp_16;
        // Inline function 'kotlin.UInt.toInt' call
        var this_21 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_21) < 0) {
          tmp_16 = -one;
        } else {
          tmp_16 = one;
        }
        tmp_15.ekw(1, tmp_16);
        // Inline function 'kotlin.UInt.shl' call
        var this_22 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_22) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.k3() / 2 | 0;
        sfb = sfb.vkv();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_3 = scf_0;
        scf_0 = _unary__edvuaz_3.vkv();
        one = _unary__edvuaz_3.k3();
      }
      if (!((leaf_1 & 32) === 0)) {
        var tmp_17 = dst_0;
        var tmp_18;
        // Inline function 'kotlin.UInt.toInt' call
        var this_23 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_23) < 0) {
          tmp_18 = -one;
        } else {
          tmp_18 = one;
        }
        tmp_17.ekw(2, tmp_18);
        // Inline function 'kotlin.UInt.shl' call
        var this_24 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_24) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 16) === 0)) {
        var tmp_19 = dst_0;
        var tmp_20;
        // Inline function 'kotlin.UInt.toInt' call
        var this_25 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_25) < 0) {
          tmp_20 = -one;
        } else {
          tmp_20 = one;
        }
        tmp_19.ekw(3, tmp_20);
        // Inline function 'kotlin.UInt.shl' call
        var this_26 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_26) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      while (bs_sh >= 0) {
        var tmp0_15 = bs_cache;
        // Inline function 'kotlin.toUInt' call
        var this_27 = bs_next_ptr.k3() << bs_sh;
        // Inline function 'kotlin.UInt.or' call
        var other_2 = _UInt___init__impl__l7qpdl(this_27);
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_15) | _UInt___get_data__impl__f0vqqw(other_2));
        bs_next_ptr = bs_next_ptr.vkv();
        bs_sh = bs_sh - 8 | 0;
      }
      dst_0 = dst_0.wkv(4);
    }
    bs.ikv_1 = layer3gr_limit;
  }
  qkr(left, n) {
    var right = left.wkv(576);
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = left.u2(i);
        var b = right.u2(i);
        left.ekw(i, a + b);
        right.ekw(i, a - b);
      }
       while (inductionVariable < n);
  }
  rkr(left, n, kl, kr) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        left.ekw(i + 576 | 0, left.u2(i) * kr);
        left.ekw(i, left.u2(i) * kl);
      }
       while (inductionVariable < n);
  }
  skr(right, sfb, nbands, max_band) {
    var right_0 = right;
    max_band[0] = -1;
    max_band[1] = -1;
    max_band[2] = -1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        $l$loop: while (k < sfb.u2(i)) {
          if (!(right_0.u2(k) === 0.0) || !(right_0.u2(k + 1 | 0) === 0.0)) {
            max_band[i % 3 | 0] = i;
            break $l$loop;
          }
          k = k + 2 | 0;
        }
        right_0 = right_0.wkv(sfb.u2(i));
      }
       while (inductionVariable < nbands);
  }
  tkr(left, ist_pos, sfb, hdr, max_band, mpeg2_sh) {
    var left_0 = left;
    var g_pan = Companion_getInstance_10().dku_1;
    var max_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 7 : 64;
    var i = 0;
    while (!(sfb.u2(i) === 0)) {
      var ipos = UByteArrayInt__get_impl_px6q8a(ist_pos, i);
      if (i > max_band[i % 3 | 0] && ipos < max_pos) {
        var kl;
        var kr;
        var s = !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0) ? 1.4142135 : 1.0;
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
          kl = g_pan[imul(2, ipos) + 0 | 0];
          kr = g_pan[imul(2, ipos) + 1 | 0];
        } else {
          kl = 1.0;
          kr = this.mkr(1.0, (ipos + 1 | 0) >> 1 << mpeg2_sh);
          if (!((ipos & 1) === 0)) {
            kl = kr;
            kr = 1.0;
          }
        }
        this.rkr(left_0, sfb.u2(i), kl * s, kr * s);
      } else {
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0)) {
          this.qkr(left_0, sfb.u2(i));
        }
      }
      left_0 = left_0.wkv(sfb.u2(i));
      i = i + 1 | 0;
    }
  }
  ukr(left, ist_pos, gr, hdr) {
    var max_band = this.okp_1;
    var n_sfb = gr.k3().rkw_1 + gr.k3().skw_1 | 0;
    var max_blocks = !(gr.k3().skw_1 === 0) ? 3 : 1;
    this.skr(left.wkv(576), gr.k3().kkw_1, n_sfb, max_band);
    if (!(gr.k3().rkw_1 === 0)) {
      var tmp0 = max_band[0];
      // Inline function 'kotlin.math.max' call
      var b = max_band[1];
      var tmp0_0 = Math.max(tmp0, b);
      // Inline function 'kotlin.math.max' call
      var b_0 = max_band[2];
      var v = Math.max(tmp0_0, b_0);
      max_band[0] = v;
      max_band[1] = v;
      max_band[2] = v;
    }
    var inductionVariable = 0;
    if (inductionVariable < max_blocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var default_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 3 : 0;
        var itop = (n_sfb - max_blocks | 0) + i | 0;
        var prev = itop - max_blocks | 0;
        UByteArrayInt__set_impl_gn4532(ist_pos, itop, max_band[i] >= prev ? default_pos : UByteArrayInt__get_impl_px6q8a(ist_pos, prev));
      }
       while (inductionVariable < max_blocks);
    this.tkr(left, ist_pos, gr.k3().kkw_1, hdr, max_band, gr.u2(1).nkw_1 & 1);
  }
  vkr(grbuf, scratch, sfb) {
    var sfb_0 = sfb;
    var i = 0;
    var len = 0;
    var src = grbuf;
    var dst = scratch;
    $l$loop: while (true) {
      len = sfb_0.k3();
      if (len === 0)
        break $l$loop;
      i = 0;
      while (i < len) {
        var _unary__edvuaz = dst;
        dst = _unary__edvuaz.vkv();
        _unary__edvuaz.dkw(src.u2(imul(0, len)));
        var _unary__edvuaz_0 = dst;
        dst = _unary__edvuaz_0.vkv();
        _unary__edvuaz_0.dkw(src.u2(imul(1, len)));
        var _unary__edvuaz_1 = dst;
        dst = _unary__edvuaz_1.vkv();
        _unary__edvuaz_1.dkw(src.u2(imul(2, len)));
        i = i + 1 | 0;
        src = src.vkv();
      }
      sfb_0 = sfb_0.wkv(3);
      src = src.wkv(imul(2, len));
    }
    this.ukq(grbuf, scratch, dst.fkw(scratch));
  }
  wkr(grbuf, nbands) {
    var grbuf_0 = grbuf;
    var nbands_0 = nbands;
    var g_aa = Companion_getInstance_10().fku_1;
    while (nbands_0 > 0) {
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var u = grbuf_0.u2(18 + i | 0);
          var d = grbuf_0.u2(17 - i | 0);
          grbuf_0.ekw(18 + i | 0, u * g_aa[0][i] - d * g_aa[1][i]);
          grbuf_0.ekw(17 - i | 0, u * g_aa[1][i] + d * g_aa[0][i]);
        }
         while (inductionVariable < 8);
      nbands_0 = nbands_0 - 1 | 0;
      grbuf_0 = grbuf_0.wkv(18);
    }
  }
  xkr(y) {
    var s0 = y[0];
    var s2 = y[2];
    var s4 = y[4];
    var s6 = y[6];
    var s8 = y[8];
    var t0 = s0 + s6 * 0.5;
    s0 = s0 - s6;
    var t4 = (s4 + s2) * 0.9396926;
    var t2 = (s8 + s2) * 0.76604444;
    s6 = (s4 - s8) * 0.17364818;
    s4 = s4 + (s8 - s2);
    s2 = s0 - s4 * 0.5;
    y[4] = s4 + s0;
    s8 = t0 - t2 + s6;
    s0 = t0 - t4 + t2;
    s4 = t0 + t4 - s6;
    var s1 = y[1];
    var s3 = y[3];
    var s5 = y[5];
    var s7 = y[7];
    s3 = s3 * 0.8660254;
    t0 = (s5 + s1) * 0.9848077;
    t4 = (s5 - s7) * 0.34202015;
    t2 = (s1 + s7) * 0.64278764;
    s1 = (s1 - s5 - s7) * 0.8660254;
    s5 = t0 - s3 - t2;
    s7 = t4 - s3 - t0;
    s3 = t4 + s3 - t2;
    y[0] = s4 - s7;
    y[1] = s2 + s1;
    y[2] = s0 - s3;
    y[3] = s8 + s5;
    y[5] = s8 - s5;
    y[6] = s0 + s3;
    y[7] = s2 - s1;
    y[8] = s4 + s7;
  }
  ykr(grbuf, overlap, window_0, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_twid9 = Companion_getInstance_10().aku_1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var co = this.pkp_1;
        var si = this.qkp_1;
        co[0] = -grbuf_0.u2(0);
        si[0] = grbuf_0.u2(17);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            si[8 - imul(2, i) | 0] = grbuf_0.u2(imul(4, i) + 1 | 0) - grbuf_0.u2(imul(4, i) + 2 | 0);
            co[1 + imul(2, i) | 0] = grbuf_0.u2(imul(4, i) + 1 | 0) + grbuf_0.u2(imul(4, i) + 2 | 0);
            si[7 - imul(2, i) | 0] = grbuf_0.u2(imul(4, i) + 4 | 0) - grbuf_0.u2(imul(4, i) + 3 | 0);
            co[2 + imul(2, i) | 0] = -(grbuf_0.u2(imul(4, i) + 3 | 0) + grbuf_0.u2(imul(4, i) + 4 | 0));
          }
           while (inductionVariable_0 < 4);
        this.xkr(co);
        this.xkr(si);
        si[1] = -si[1];
        si[3] = -si[3];
        si[5] = -si[5];
        si[7] = -si[7];
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 9)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var ovl = overlap_0.u2(i_0);
            var sum = co[i_0] * g_twid9[9 + i_0 | 0] + si[i_0] * g_twid9[0 + i_0 | 0];
            overlap_0.ekw(i_0, co[i_0] * g_twid9[0 + i_0 | 0] - si[i_0] * g_twid9[9 + i_0 | 0]);
            grbuf_0.ekw(i_0, ovl * window_0[0 + i_0 | 0] - sum * window_0[9 + i_0 | 0]);
            grbuf_0.ekw(17 - i_0 | 0, ovl * window_0[9 + i_0 | 0] + sum * window_0[0 + i_0 | 0]);
          }
           while (inductionVariable_1 < 9);
        grbuf_0 = grbuf_0.wkv(18);
        overlap_0 = overlap_0.wkv(9);
      }
       while (inductionVariable < nbands);
  }
  zkr(x0, x1, x2, dst) {
    var m1 = x1 * 0.8660254;
    var a1 = x0 - x2 * 0.5;
    dst[1] = x0 + x2;
    dst[0] = a1 + m1;
    dst[2] = a1 - m1;
  }
  aks(x, dst, overlap) {
    var g_twid3 = Companion_getInstance_10().bku_1;
    var co = this.rkp_1;
    var si = this.skp_1;
    this.zkr(-x.u2(0), x.u2(6) + x.u2(3), x.u2(12) + x.u2(9), co);
    this.zkr(x.u2(15), x.u2(12) - x.u2(9), x.u2(6) - x.u2(3), si);
    si[1] = -si[1];
    var inductionVariable = 0;
    if (inductionVariable < 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ovl = overlap.u2(i);
        var sum = co[i] * g_twid3[3 + i | 0] + si[i] * g_twid3[0 + i | 0];
        overlap.ekw(i, co[i] * g_twid3[0 + i | 0] - si[i] * g_twid3[3 + i | 0]);
        dst.ekw(i, ovl * g_twid3[2 - i | 0] - sum * g_twid3[5 - i | 0]);
        dst.ekw(5 - i | 0, ovl * g_twid3[5 - i | 0] + sum * g_twid3[2 - i | 0]);
      }
       while (inductionVariable < 3);
  }
  bks(grbuf, overlap, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var nbands_0 = nbands;
    while (nbands_0 > 0) {
      var tmp = new FloatArrayPtr(new Float32Array(18));
      this.ukq(tmp, grbuf_0, 18);
      this.ukq(grbuf_0, overlap_0, 6);
      this.aks(tmp, grbuf_0.wkv(6), overlap_0.wkv(6));
      this.aks(tmp.wkv(1), grbuf_0.wkv(12), overlap_0.wkv(6));
      this.aks(tmp.wkv(2), overlap_0, overlap_0.wkv(6));
      nbands_0 = nbands_0 - 1 | 0;
      overlap_0 = overlap_0.wkv(9);
      grbuf_0 = grbuf_0.wkv(18);
    }
  }
  cks(grbuf) {
    var p = 18;
    var progression = step(until(0, 32), 2);
    var inductionVariable = progression.n3_1;
    var last = progression.o3_1;
    var step_0 = progression.p3_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var b = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var progression_0 = step(until(1, 18), 2);
        var inductionVariable_0 = progression_0.n3_1;
        var last_0 = progression_0.o3_1;
        var step_1 = progression_0.p3_1;
        if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var index = p + i | 0;
            grbuf.ekw(index, -grbuf.u2(index));
          }
           while (!(i === last_0));
        p = p + 36 | 0;
      }
       while (!(b === last));
  }
  dks(grbuf, overlap, block_type, n_long_bands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_mdct_window = Companion_getInstance_10().gku_1;
    if (!(n_long_bands === 0)) {
      this.ykr(grbuf_0, overlap_0, g_mdct_window[0], n_long_bands);
      grbuf_0 = grbuf_0.wkv(imul(18, n_long_bands));
      overlap_0 = overlap_0.wkv(imul(9, n_long_bands));
    }
    if (block_type === 2) {
      this.bks(grbuf_0, overlap_0, 32 - n_long_bands | 0);
    } else {
      this.ykr(grbuf_0, overlap_0, g_mdct_window[toInt_0(this, block_type === 3)], 32 - n_long_bands | 0);
    }
  }
  eks(h, s) {
    var pos = (s.kkv_1.ikv_1 + 7 | 0) / 8 | 0;
    var remains = (s.kkv_1.jkv_1 / 8 | 0) - pos | 0;
    if (remains > 511) {
      pos = pos + (remains - 511 | 0) | 0;
      remains = 511;
    }
    if (remains > 0) {
      this.vkq(new UByteArrayIntPtr(h.mkp_1), s.lkv_1.wkv(pos), remains);
    }
    h.jkp_1 = remains;
  }
  fks(h, bs, s, main_data_begin) {
    var frame_bytes = (bs.jkv_1 - bs.ikv_1 | 0) / 8 | 0;
    var bytes_have = h.jkp_1 > main_data_begin ? main_data_begin : h.jkp_1;
    this.vkq(s.lkv_1, (new UByteArrayIntPtr(h.mkp_1)).wkv(0 < (h.jkp_1 - main_data_begin | 0) ? h.jkp_1 - main_data_begin | 0 : 0), h.jkp_1 > main_data_begin ? main_data_begin : h.jkp_1);
    this.vkq(s.lkv_1.wkv(bytes_have), bs.hkv_1.wkv(bs.ikv_1 / 8 | 0), frame_bytes);
    this.wkq(s.kkv_1, s.lkv_1, bytes_have + frame_bytes | 0);
    return toInt_0(this, h.jkp_1 >= main_data_begin);
  }
  gks(h, s, gr_info, nch) {
    var gr_info_0 = gr_info;
    var inductionVariable = 0;
    if (inductionVariable < nch)
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var layer3gr_limit = s.kkv_1.ikv_1 + gr_info_0.u2(ch).lkw_1 | 0;
        this.nkr(h.lkp_1, s.qkv_1[ch].ab2_1, s.kkv_1, gr_info_0.wkv(ch), s.okv_1, ch);
        this.pkr(s.nkv_1[ch], s.kkv_1, gr_info_0.wkv(ch), s.okv_1, layer3gr_limit);
      }
       while (inductionVariable < nch);
    if (!((UByteArrayInt__get_impl_px6q8a(h.lkp_1, 3) & 16) === 0)) {
      this.ukr(s.nkv_1[0], s.qkv_1[1].ab2_1, gr_info_0, h.lkp_1);
    } else if ((UByteArrayInt__get_impl_px6q8a(h.lkp_1, 3) & 224) === 96) {
      this.qkr(s.nkv_1[0], 576);
    }
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < nch)
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var aa_bands = 31;
        var n_long_bands = (!(gr_info_0.k3().qkw_1 === 0) ? 2 : 0) << toInt_0(this, ((UByteArrayInt__get_impl_px6q8a(h.lkp_1, 2) >> 2 & 3) + imul((UByteArrayInt__get_impl_px6q8a(h.lkp_1, 1) >> 3 & 1) + (UByteArrayInt__get_impl_px6q8a(h.lkp_1, 1) >> 4 & 1) | 0, 3) | 0) === 2);
        if (!(gr_info_0.k3().skw_1 === 0)) {
          aa_bands = n_long_bands - 1 | 0;
          this.vkr(s.nkv_1[ch_0].wkv(imul(n_long_bands, 18)), s.pkv_1[0], gr_info_0.k3().kkw_1.wkv(gr_info_0.k3().rkw_1));
        }
        this.wkr(s.nkv_1[ch_0], aa_bands);
        this.dks(s.nkv_1[ch_0], new FloatArrayPtr(h.hkp_1[ch_0]), gr_info_0.k3().pkw_1, n_long_bands);
        this.cks(s.nkv_1[ch_0]);
        gr_info_0 = gr_info_0.wkv(1);
      }
       while (inductionVariable_0 < nch);
  }
  hks(grbuf, n) {
    var g_sec = Companion_getInstance_10().cku_1;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(4);
    while (tmp < 4) {
      tmp_0[tmp] = new Float32Array(8);
      tmp = tmp + 1 | 0;
    }
    var t = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = grbuf.wkv(k);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 8)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var x0 = y.u2(imul(i, 18));
            var x1 = y.u2(imul(15 - i | 0, 18));
            var x2 = y.u2(imul(16 + i | 0, 18));
            var x3 = y.u2(imul(31 - i | 0, 18));
            var t0 = x0 + x3;
            var t1 = x1 + x2;
            var t2 = (x1 - x2) * g_sec[imul(3, i) + 0 | 0];
            var t3 = (x0 - x3) * g_sec[imul(3, i) + 1 | 0];
            t[0][i] = t0 + t1;
            t[1][i] = (t0 - t1) * g_sec[imul(3, i) + 2 | 0];
            t[2][i] = t3 + t2;
            t[3][i] = (t3 - t2) * g_sec[imul(3, i) + 2 | 0];
          }
           while (inductionVariable_0 < 8);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 4)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var x = t[i_0];
            var x0_0 = x[0];
            var x1_0 = x[1];
            var x2_0 = x[2];
            var x3_0 = x[3];
            var x4 = x[4];
            var x5 = x[5];
            var x6 = x[6];
            var x7 = x[7];
            var xt = x0_0 - x7;
            x0_0 = x0_0 + x7;
            x7 = x1_0 - x6;
            x1_0 = x1_0 + x6;
            x6 = x2_0 - x5;
            x2_0 = x2_0 + x5;
            x5 = x3_0 - x4;
            x3_0 = x3_0 + x4;
            x4 = x0_0 - x3_0;
            x0_0 = x0_0 + x3_0;
            x3_0 = x1_0 - x2_0;
            x1_0 = x1_0 + x2_0;
            x[0] = x0_0 + x1_0;
            x[4] = (x0_0 - x1_0) * 0.70710677;
            x5 = x5 + x6;
            x6 = (x6 + x7) * 0.70710677;
            x7 = x7 + xt;
            x3_0 = (x3_0 + x4) * 0.70710677;
            x5 = x5 - x7 * 0.19891237;
            x7 = x7 + x5 * 0.38268343;
            x5 = x5 - x7 * 0.19891237;
            x0_0 = xt - x6;
            xt = xt + x6;
            x[1] = (xt + x7) * 0.5097956;
            x[2] = (x4 + x3_0) * 0.5411961;
            x[3] = (x0_0 - x5) * 0.6013449;
            x[5] = (x0_0 + x5) * 0.8999762;
            x[6] = (x4 - x3_0) * 1.306563;
            x[7] = (xt - x7) * 2.5629156;
          }
           while (inductionVariable_1 < 4);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 7)
          do {
            var i_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            y.ekw(0, t[0][i_1]);
            y.ekw(18, t[2][i_1] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y.ekw(36, t[1][i_1] + t[1][i_1 + 1 | 0]);
            y.ekw(54, t[2][i_1 + 1 | 0] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y = y.wkv(72);
          }
           while (inductionVariable_2 < 7);
        y.ekw(0, t[0][7]);
        y.ekw(18, t[2][7] + t[3][7]);
        y.ekw(36, t[1][7]);
        y.ekw(54, t[3][7]);
      }
       while (inductionVariable < n);
  }
  iks(sample) {
    if (sample >= 32766.5)
      return 32767;
    if (sample <= -32767.5)
      return -32768;
    var s = toShort(numberToInt(sample + 0.5));
    return toShort(s - toInt_0(this, s < 0) | 0);
  }
  jks(pcm, nch, z) {
    var z_0 = z;
    var a = 0.0;
    a = a + (z_0.u2(896) - z_0.u2(0)) * 29.0;
    a = a + (z_0.u2(64) + z_0.u2(832)) * 213.0;
    a = a + (z_0.u2(768) - z_0.u2(128)) * 459.0;
    a = a + (z_0.u2(192) + z_0.u2(704)) * 2037.0;
    a = a + (z_0.u2(640) - z_0.u2(256)) * 5153.0;
    a = a + (z_0.u2(320) + z_0.u2(576)) * 6574.0;
    a = a + (z_0.u2(512) - z_0.u2(384)) * 37489.0;
    a = a + z_0.u2(448) * 75038.0;
    pcm.jkw(0, this.iks(a));
    z_0 = z_0.wkv(2);
    a = z_0.u2(896) * 104.0;
    a = a + z_0.u2(768) * 1567.0;
    a = a + z_0.u2(640) * 9727.0;
    a = a + z_0.u2(512) * 64019.0;
    a = a + z_0.u2(384) * -9975.0;
    a = a + z_0.u2(256) * -45.0;
    a = a + z_0.u2(128) * 146.0;
    a = a + z_0.u2(0) * -5.0;
    pcm.jkw(imul(16, nch), this.iks(a));
  }
  kks(xl, dstl, nch, lins) {
    var xr = xl.wkv(imul(576, nch - 1 | 0));
    var dstr = dstl.wkv(nch - 1 | 0);
    var g_win = Companion_getInstance_10().eku_1;
    var zlin = lins.wkv(960);
    var w = 0;
    zlin.ekw(60, xl.u2(288));
    zlin.ekw(61, xr.u2(288));
    zlin.ekw(62, xl.u2(0));
    zlin.ekw(63, xr.u2(0));
    zlin.ekw(124, xl.u2(289));
    zlin.ekw(125, xr.u2(289));
    zlin.ekw(126, xl.u2(1));
    zlin.ekw(127, xr.u2(1));
    this.jks(dstr, nch, lins.wkv(60).wkv(1));
    this.jks(dstr.wkv(imul(32, nch)), nch, lins.wkv(60).wkv(64).wkv(1));
    this.jks(dstl, nch, lins.wkv(60));
    this.jks(dstl.wkv(imul(32, nch)), nch, lins.wkv(60).wkv(64));
    var inductionVariable = 14;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var a = this.rkp_1;
        var b = this.skp_1;
        zlin.ekw(imul(4, i), xl.u2(imul(18, 31 - i | 0)));
        zlin.ekw(imul(4, i) + 1 | 0, xr.u2(imul(18, 31 - i | 0)));
        zlin.ekw(imul(4, i) + 2 | 0, xl.u2(1 + imul(18, 31 - i | 0) | 0));
        zlin.ekw(imul(4, i) + 3 | 0, xr.u2(1 + imul(18, 31 - i | 0) | 0));
        zlin.ekw(imul(4, i + 16 | 0), xl.u2(1 + imul(18, 1 + i | 0) | 0));
        zlin.ekw(imul(4, i + 16 | 0) + 1 | 0, xr.u2(1 + imul(18, 1 + i | 0) | 0));
        zlin.ekw(imul(4, i - 16 | 0) + 2 | 0, xl.u2(imul(18, 1 + i | 0)));
        zlin.ekw(imul(4, i - 16 | 0) + 3 | 0, xr.u2(imul(18, 1 + i | 0)));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            b[j] = 0.0;
            a[j] = 0.0;
          }
           while (inductionVariable_0 < 4);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 8)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = w;
            w = _unary__edvuaz + 1 | 0;
            var w0 = g_win[_unary__edvuaz];
            var _unary__edvuaz_0 = w;
            w = _unary__edvuaz_0 + 1 | 0;
            var w1 = g_win[_unary__edvuaz_0];
            var vz = zlin.wkv(imul(4, i) - imul(n, 64) | 0);
            var vy = zlin.wkv(imul(4, i) - imul(15 - n | 0, 64) | 0);
            if ((n % 2 | 0) === 0) {
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < 4)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  b[j_0] = b[j_0] + vz.u2(j_0) * w1 + vy.u2(j_0) * w0;
                  a[j_0] = a[j_0] + vz.u2(j_0) * w0 - vy.u2(j_0) * w1;
                }
                 while (inductionVariable_2 < 4);
            } else {
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < 4)
                do {
                  var j_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  b[j_1] = b[j_1] + (vz.u2(j_1) * w1 + vy.u2(j_1) * w0);
                  a[j_1] = a[j_1] + (vy.u2(j_1) * w1 - vz.u2(j_1) * w0);
                }
                 while (inductionVariable_3 < 4);
            }
          }
           while (inductionVariable_1 < 8);
        dstr.jkw(imul(15 - i | 0, nch), this.iks(a[1]));
        dstr.jkw(imul(17 + i | 0, nch), this.iks(b[1]));
        dstl.jkw(imul(15 - i | 0, nch), this.iks(a[0]));
        dstl.jkw(imul(17 + i | 0, nch), this.iks(b[0]));
        dstr.jkw(imul(47 - i | 0, nch), this.iks(a[3]));
        dstr.jkw(imul(49 + i | 0, nch), this.iks(b[3]));
        dstl.jkw(imul(47 - i | 0, nch), this.iks(a[2]));
        dstl.jkw(imul(49 + i | 0, nch), this.iks(b[2]));
      }
       while (0 <= inductionVariable);
  }
  lks(qmf_state, grbuf, nbands, nch, pcm, lins) {
    var i = 0;
    i = 0;
    while (i < nch) {
      this.hks(grbuf.wkv(imul(576, i)), nbands);
      i = i + 1 | 0;
    }
    this.ukq(lins, qmf_state, 960);
    i = 0;
    while (i < nbands) {
      this.kks(grbuf.wkv(i), pcm.wkv(imul(32, imul(nch, i))), nch, lins.wkv(imul(i, 64)));
      i = i + 2 | 0;
    }
    if (nch === 1) {
      i = 0;
      while (i < 960) {
        qmf_state.ekw(i, lins.u2(imul(nbands, 64) + i | 0));
        i = i + 2 | 0;
      }
    } else {
      this.ukq(qmf_state, lins.wkv(imul(nbands, 64)), 960);
    }
  }
  mks(hdr, mp3_bytes, frame_bytes) {
    var i = 0;
    var inductionVariable = 0;
    if (inductionVariable < 10)
      do {
        var nmatch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        i = i + (this.dkr(hdr.wkv(i), frame_bytes) + this.ekr(hdr.wkv(i)) | 0) | 0;
        if ((i + 4 | 0) > mp3_bytes)
          return toInt_0(this, nmatch > 0);
        if (this.zkq(hdr, hdr.wkv(i)) === 0)
          return 0;
      }
       while (inductionVariable < 10);
    return 1;
  }
  nks(mp3, mp3_bytes, free_format_bytes, ptr_frame_bytes) {
    var mp3_0 = mp3;
    var i = 0;
    var k = 0;
    i = 0;
    while (i < (mp3_bytes - 4 | 0)) {
      if (this.ykq(mp3_0)) {
        var frame_bytes = this.dkr(mp3_0, free_format_bytes[0]);
        var frame_and_padding = frame_bytes + this.ekr(mp3_0) | 0;
        k = 4;
        $l$loop: while (frame_bytes === 0 && k < 2304 && !((i + imul(2, toInt_0(this, k < (mp3_bytes - 4 | 0))) | 0) === 0)) {
          if (!(this.zkq(mp3_0, mp3_0.wkv(k)) === 0)) {
            var fb = k - this.ekr(mp3_0) | 0;
            var nextfb = fb + this.ekr(mp3_0.wkv(k)) | 0;
            if ((((i + k | 0) + nextfb | 0) + 4 | 0) > mp3_bytes || this.zkq(mp3_0, mp3_0.wkv(k).wkv(nextfb)) === 0) {
              k = k + 1 | 0;
              continue $l$loop;
            }
            frame_and_padding = k;
            frame_bytes = fb;
            free_format_bytes[0] = fb;
          }
          k = k + 1 | 0;
        }
        if (!(frame_bytes === 0) && !((i + toInt_0(this, frame_and_padding <= mp3_bytes) | 0) === 0) && !(this.mks(mp3_0, mp3_bytes - i | 0, frame_bytes) === 0) || (i === 0 && frame_and_padding === mp3_bytes)) {
          ptr_frame_bytes[0] = frame_and_padding;
          return i;
        }
        free_format_bytes[0] = 0;
      }
      i = i + 1 | 0;
      mp3_0 = mp3_0.wkv(1);
    }
    ptr_frame_bytes[0] = 0;
    return mp3_bytes;
  }
  vkp(dec) {
    UByteArrayInt__set_impl_gn4532(dec.lkp_1, 0, 0);
  }
  nkq(dec, mp3, mp3_bytes, pcm, info) {
    var pcm_0 = pcm;
    var i = 0;
    var frame_size = new Int32Array(1);
    var success = 1;
    var bs_frame = this.ukp_1;
    var scratch = this.tkp_1;
    if (mp3_bytes > 4 && UByteArrayInt__get_impl_px6q8a(dec.lkp_1, 0) === 255 && !(this.zkq(new UByteArrayIntPtr(dec.lkp_1), mp3) === 0)) {
      frame_size[0] = this.dkr(mp3, dec.kkp_1[0]) + this.ekr(mp3) | 0;
      if (!(frame_size[0] === mp3_bytes) && ((frame_size[0] + 4 | 0) > mp3_bytes || this.zkq(mp3, mp3.wkv(frame_size[0])) === 0)) {
        frame_size[0] = 0;
      }
    }
    if (frame_size[0] === 0) {
      dec.jkp_1 = 0;
      dec.kkp_1[0] = 0;
      UByteArrayInt__fill$default_impl_mdydxi(dec.mkp_1, 0);
      UByteArrayInt__fill$default_impl_mdydxi(dec.lkp_1, 0);
      fill_0(dec.ikp_1, 0.0);
      fill_0(dec.hkp_1[0], 0.0);
      fill_0(dec.hkp_1[1], 0.0);
      i = this.nks(mp3, mp3_bytes, dec.kkp_1, frame_size);
      if (frame_size[0] === 0 || !((i + toInt_0(this, frame_size[0] > mp3_bytes) | 0) === 0)) {
        info.k3().okq_1 = i;
        return 0;
      }
    }
    var hdr = mp3.wkv(i);
    this.vkq(new UByteArrayIntPtr(dec.lkp_1), hdr, 4);
    info.k3().okq_1 = i + frame_size[0] | 0;
    info.k3().pkq_1 = i;
    info.k3().qkq_1 = (hdr.u2(3) & 192) === 192 ? 1 : 2;
    info.k3().rkq_1 = this.bkr(hdr);
    info.k3().skq_1 = 4 - (hdr.u2(1) >> 1 & 3) | 0;
    info.k3().tkq_1 = this.akr(hdr);
    // Inline function 'kotlin.collections.isEmpty' call
    if (pcm_0.hkw_1.length === 0) {
      return this.ckr(hdr);
    }
    this.wkq(bs_frame, hdr.wkv(4), frame_size[0] - 4 | 0);
    if ((hdr.u2(1) & 1) === 0) {
      this.xkq(bs_frame, 16);
    }
    if (info.k3().skq_1 === 3) {
      var main_data_begin = this.kkr(bs_frame, scratch.mkv_1, hdr);
      if (main_data_begin < 0 || bs_frame.ikv_1 > bs_frame.jkv_1) {
        this.vkp(dec);
        return 0;
      }
      success = this.fks(dec, bs_frame, scratch, main_data_begin);
      if (!(success === 0)) {
        var igr = 0;
        while (igr < (!((hdr.u2(1) & 8) === 0) ? 2 : 1)) {
          scratch.nkv_1[0].gkw(0.0, 0, 1152);
          this.gks(dec, scratch, scratch.mkv_1.wkv(imul(igr, info.k3().qkq_1)), info.k3().qkq_1);
          this.lks(new FloatArrayPtr(dec.ikp_1), scratch.nkv_1[0], 18, info.k3().qkq_1, pcm_0, scratch.pkv_1[0]);
          igr = igr + 1 | 0;
          pcm_0 = pcm_0.wkv(imul(576, info.k3().qkq_1));
        }
      }
      this.eks(dec, scratch);
    } else {
      var sci = new ScaleInfo();
      this.hkr(hdr, bs_frame, sci);
      scratch.nkv_1[0].gkw(0.0, 0, 1152);
      i = 0;
      var igr_0 = 0;
      while (igr_0 < 3) {
        i = i + this.ikr(scratch.nkv_1[0].wkv(i), bs_frame, sci, info.k3().skq_1 | 1) | 0;
        if (12 === i) {
          i = 0;
          this.jkr(sci, (new FloatArrayPtr(sci.akx_1)).wkv(igr_0), scratch.nkv_1[0]);
          this.lks(new FloatArrayPtr(dec.ikp_1), scratch.nkv_1[0], 12, info.k3().qkq_1, pcm_0, scratch.pkv_1[0]);
          scratch.nkv_1[0].gkw(0.0, 0, 1152);
          pcm_0 = pcm_0.wkv(imul(384, info.k3().qkq_1));
        }
        if (bs_frame.ikv_1 > bs_frame.jkv_1) {
          this.vkp(dec);
          return 0;
        }
        igr_0 = igr_0 + 1 | 0;
      }
    }
    return imul(success, this.ckr(new UByteArrayIntPtr(dec.lkp_1)));
  }
}
class Minimp3Decoder extends MiniMp3Program {
  constructor() {
    super();
    this.dkp_1 = new Int16Array(9216);
    this.ekp_1 = Mp3Dec.nkp();
    this.fkp_1 = new Mp3FrameInfo();
    this.vkp(this.ekp_1);
    this.gkp_1 = new BaseMp3DecoderInfo();
  }
  wkp() {
    return this.gkp_1;
  }
  xkp(availablePeek) {
    var samples = this.nkq(this.ekp_1, new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu(this.gkp_1.ykp_1)), availablePeek, new ShortArrayPtr(this.dkp_1), this.fkp_1);
    var struct = this.fkp_1;
    this.gkp_1.dkq_1 = struct.qkq_1;
    this.gkp_1.bkq_1 = struct.rkq_1;
    this.gkp_1.ckq_1 = struct.tkq_1;
    this.gkp_1.fkq_1 = struct.okq_1;
    this.gkp_1.ekq_1 = samples;
    if (this.gkp_1.dkq_1 === 0 || samples <= 0)
      return null;
    return copyOf(this.dkp_1, imul(samples, this.gkp_1.dkq_1));
  }
  f7() {
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_9();
    super(['mp3']);
  }
  *tkm(data, props, $completion) {
    return yield* Companion_getInstance_5().tkm(data, props, $completion);
  }
  *ukm(data, props, $completion) {
    return yield* /*#__NOINLINE__*/createDecoderStream(this, data, props, null, $completion);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
  pks() {
    return new Minimp3Decoder();
  }
}
class BaseMp3DecoderInfo {
  constructor() {
    this.ykp_1 = new Int8Array(4608);
    this.zkp_1 = new ByteArrayDeque();
    this.akq_1 = null;
    this.bkq_1 = 0;
    this.ckq_1 = 0;
    this.dkq_1 = 0;
    this.ekq_1 = 0;
    this.fkq_1 = 0;
    this.gkq_1 = 0;
    this.hkq_1 = 0;
    this.ikq_1 = 0;
    this.jkq_1 = 0;
    this.kkq_1 = 0;
    this.lkq_1 = 0;
    this.mkq_1 = 0;
  }
  ra8() {
    var tmp11_safe_receiver = this.akq_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.a5();
    }
    this.zkp_1.a5();
    this.gkq_1 = 0;
    this.hkq_1 = -1;
    this.jkq_1 = 0;
  }
  sks(decoder) {
    var availablePeek = this.zkp_1.da1(this.ykp_1, 0, this.ykp_1.length);
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(this.ykp_1, Companion_getInstance_9().tks_1);
    var tmp;
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var xingIndex = tmp0_elvis_lhs == null ? this.ykp_1.length : tmp0_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(this.ykp_1, Companion_getInstance_9().uks_1);
    var tmp_0;
    if (this_1 >= 0) {
      tmp_0 = this_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var infoIndex = tmp1_elvis_lhs == null ? this.ykp_1.length : tmp1_elvis_lhs;
    if (xingIndex < this.ykp_1.length || infoIndex < this.ykp_1.length) {
      try {
        // Inline function 'kotlin.math.min' call
        var index = Math.min(xingIndex, infoIndex);
        var data = new FastByteArrayInputStream(this.ykp_1, index);
        data.kb5(7);
        if (data.ab5() >= 1) {
          var flags = data.fb7();
          var FRAMES_FLAG = 1;
          var BYTES_FLAG = 2;
          var TOC_FLAG = 4;
          var VBR_SCALE_FLAG = 8;
          if (hasFlags(flags, FRAMES_FLAG) && data.ab5() >= 4) {
            this.kkq_1 = data.jb7();
            if (hasFlags(flags, BYTES_FLAG)) {
              data.kb5(4);
            }
            if (hasFlags(flags, TOC_FLAG)) {
              data.kb5(100);
            }
            if (hasFlags(flags, VBR_SCALE_FLAG)) {
              data.kb5(4);
            }
            if (data.ab5() >= 1) {
              var info = data.fb7();
              if (!(info === 0)) {
                data.kb5(20);
                if (data.ab5() >= 3) {
                  var t0 = data.fb7();
                  var t1 = data.fb7();
                  var t2 = data.fb7();
                  this.lkq_1 = (t0 << 4 | (t1 >>> 4 | 0)) + 529 | 0;
                  this.mkq_1 = ((t1 & 15) << 8 | t2) - 529 | 0;
                }
              }
            }
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    var buf = decoder.xkp(availablePeek);
    if (!(this.dkq_1 === 0) && (!(this.kkq_1 === 0) || !(this.lkq_1 === 0) || !(this.mkq_1 === 0))) {
      var rpadding = imul(this.mkq_1, this.dkq_1);
      var to_skip = imul(this.lkq_1, this.dkq_1);
      var detected_samples = imul(imul(this.ekq_1, this.kkq_1), this.dkq_1);
      if (detected_samples >= to_skip)
        detected_samples = detected_samples - to_skip | 0;
      if (1 <= rpadding ? rpadding <= detected_samples : false)
        detected_samples = detected_samples - rpadding | 0;
      this.gkq_1 = to_skip + imul(this.ekq_1, this.dkq_1) | 0;
      this.hkq_1 = detected_samples;
      this.ikq_1 = detected_samples / this.dkq_1 | 0;
      this.kkq_1 = 0;
      this.lkq_1 = 0;
      this.mkq_1 = 0;
    }
    if (!(this.dkq_1 === 0) && this.akq_1 == null) {
      this.akq_1 = new AudioSamplesDeque(this.dkq_1);
    }
    if (this.ekq_1 > 0) {
      var offset = 0;
      var toRead = imul(this.ekq_1, this.dkq_1);
      if (this.gkq_1 > 0) {
        var tmp0 = this.gkq_1;
        // Inline function 'kotlin.math.min' call
        var b = toRead;
        var skipNow = Math.min(tmp0, b);
        offset = offset + skipNow | 0;
        toRead = toRead - skipNow | 0;
        this.gkq_1 = this.gkq_1 - skipNow | 0;
      }
      if (this.hkq_1 >= 0) {
        var tmp0_0 = toRead;
        // Inline function 'kotlin.math.min' call
        var b_0 = this.hkq_1;
        toRead = Math.min(tmp0_0, b_0);
        this.hkq_1 = this.hkq_1 - toRead | 0;
      }
      ensureNotNull(this.akq_1).vks(_AudioSampleArray___init__impl__qpxoq0(ensureNotNull(buf)), offset, toRead);
    }
    this.zkp_1.ca1(this.fkq_1);
    if (this.fkq_1 === 0 && this.ekq_1 === 0) {
      return false;
    }
    if (!(this.akq_1 == null) && ensureNotNull(this.akq_1).za0() > 0) {
      return true;
    }
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(88);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    var tmp_0 = toByte(tmp$ret$0);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(105);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    var tmp_1 = toByte(tmp$ret$1);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(110);
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
    var tmp_2 = toByte(tmp$ret$2);
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(103);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
    // Inline function 'kotlin.byteArrayOf' call
    tmp.tks_1 = new Int8Array([tmp_0, tmp_1, tmp_2, toByte(tmp$ret$3)]);
    var tmp_3 = this;
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(73);
    var tmp$ret$5 = Char__toInt_impl_vasixd(this_4);
    var tmp_4 = toByte(tmp$ret$5);
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(110);
    var tmp$ret$6 = Char__toInt_impl_vasixd(this_5);
    var tmp_5 = toByte(tmp$ret$6);
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(102);
    var tmp$ret$7 = Char__toInt_impl_vasixd(this_6);
    var tmp_6 = toByte(tmp$ret$7);
    // Inline function 'kotlin.code' call
    var this_7 = _Char___init__impl__6a9atx(111);
    var tmp$ret$8 = Char__toInt_impl_vasixd(this_7);
    // Inline function 'kotlin.byteArrayOf' call
    tmp_3.uks_1 = new Int8Array([tmp_4, tmp_5, tmp_6, toByte(tmp$ret$8)]);
  }
}
class AudioStream {
  constructor(rate, channels, name, $box) {
    name = name === VOID ? null : name;
    boxApply(this, $box);
    this.okt_1 = rate;
    this.pkt_1 = channels;
    this.qkt_1 = name;
    this.rkt_1 = false;
    this.skt_1 = null;
    this.tkt_1 = new Long(0, 0);
  }
  mkt() {
    return this.rkt_1;
  }
  ukt(time) {
    return numberToLong(get_seconds(time) * this.okt_1);
  }
  *vkt(out, offset, length, $completion) {
    return 0;
  }
  f7() {
    return Unit_instance;
  }
}
class BaseMinimp3AudioFormat$createDecoderStream$2 extends AudioStream {
  constructor($decoder, $mp3SeekingTable, $data, $table, this$0, $dataStartPosition, $props, $box) {
    if ($box === VOID)
      $box = {};
    $box.fkt_1 = $decoder;
    $box.gkt_1 = $mp3SeekingTable;
    $box.hkt_1 = $data;
    $box.ikt_1 = $table;
    $box.jkt_1 = this$0;
    $box.kkt_1 = $dataStartPosition;
    $box.lkt_1 = $props;
    super($decoder.wkp().bkq_1, $decoder.wkp().dkq_1, VOID, $box);
    this.ckt_1 = false;
    var tmp = this;
    // Inline function 'kotlin.takeIf' call
    var this_0 = fromInt($decoder.wkp().ikq_1);
    var tmp_0;
    if (!equalsLong(this_0, new Long(0, 0))) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp10_safe_receiver = $mp3SeekingTable._v;
      tmp_1 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.oko($decoder.wkp().bkq_1);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.dkt_1 = tmp_1;
    this.ekt_1 = new Long(0, 0);
  }
  mkt() {
    return this.ckt_1;
  }
  *nkt(position, $completion) {
    this.ckt_1 = false;
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(0.0, DurationUnit_SECONDS_getInstance());
    if (equals(position, tmp$ret$0)) {
      this.hkt_1.yb8_1 = new Long(0, 0);
      this.ekt_1 = new Long(0, 0);
    } else {
      if (this.gkt_1._v == null) {
        var tmp0_elvis_lhs = this.ikt_1;
        this.gkt_1._v = tmp0_elvis_lhs == null ? (yield* this.hkt_1.qb8($completion)) ? (yield* (new Parser(this.hkt_1, yield* this.hkt_1.pb8($completion))).sko($completion)) : null : tmp0_elvis_lhs;
      }
      if (!(this.gkt_1._v == null)) {
        var offset = ensureNotNull(this.gkt_1._v).pko(position);
        this.hkt_1.yb8_1 = offset;
        this.ekt_1 = this.ukt(position);
      } else {
        println("Couldn't create mp3SeekingTable");
      }
    }
    this.fkt_1.wkp().ra8();
    return Unit_instance;
  }
  *vkt(out, offset, length, $completion) {
    var noMoreSamples = false;
    $l$loop: while (ensureNotNull(this.fkt_1.wkp().akq_1).za0() < length) {
      if (!(yield* /*#__NOINLINE__*/createDecoderStream$readMoreSamples(this.fkt_1, this.hkt_1, $completion))) {
        noMoreSamples = true;
        break $l$loop;
      }
    }
    var tmp;
    if (noMoreSamples && ensureNotNull(this.fkt_1.wkp().akq_1).za0() === 0) {
      this.ckt_1 = true;
      tmp = 0;
    } else {
      tmp = ensureNotNull(this.fkt_1.wkp().akq_1).wkt(out, offset, length);
    }
    // Inline function 'kotlin.also' call
    var this_0 = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.plus' call
    var this_1 = this.ekt_1;
    tmp_0.ekt_1 = add(this_1, fromInt(this_0));
    return this_0;
  }
  f7() {
    this.fkt_1.f7();
  }
  *xkt($completion) {
    // Inline function 'kotlin.also' call
    var this_0 = this.hkt_1.ub9();
    this_0.yb8_1 = this.kkt_1;
    return yield* /*#__NOINLINE__*/createDecoderStream(this.jkt_1, this_0, this.lkt_1, this.ikt_1, $completion);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_7 = this;
    this.ykt_1 = 2304;
    this.zkt_1 = 511;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.aku_1 = new Float32Array([0.7372773, 0.7933533, 0.8433915, 0.8870108, 0.9238795, 0.95371693, 0.976296, 0.9914449, 0.99904823, 0.6755902, 0.6087614, 0.53729963, 0.4617486, 0.38268343, 0.3007058, 0.2164396, 0.13052619, 0.04361938]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.bku_1 = new Float32Array([0.7933533, 0.9238795, 0.9914449, 0.6087614, 0.38268343, 0.13052619]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.cku_1 = new Float32Array([10.190008, 0.500603, 0.5024193, 3.4076085, 0.50547093, 0.5224986, 2.057781, 0.5154473, 0.56694406, 1.4841646, 0.5310426, 0.6468218, 1.1694399, 0.5531039, 0.7881546, 0.9725682, 0.582935, 1.0606776, 0.8393496, 0.6225041, 1.7224472, 0.7445363, 0.6748083, 5.1011486]);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.dku_1 = new Float32Array([0.0, 1.0, 0.21132487, 0.7886751, 0.3660254, 0.6339746, 0.5, 0.5, 0.6339746, 0.3660254, 0.7886751, 0.21132487, 1.0, 0.0]);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_3.eku_1 = new Float32Array([-1.0, 26.0, -31.0, 208.0, 218.0, 401.0, -519.0, 2063.0, 2000.0, 4788.0, -5517.0, 7134.0, 5959.0, 35640.0, -39336.0, 74992.0, -1.0, 24.0, -35.0, 202.0, 222.0, 347.0, -581.0, 2080.0, 1952.0, 4425.0, -5879.0, 7640.0, 5288.0, 33791.0, -41176.0, 74856.0, -1.0, 21.0, -38.0, 196.0, 225.0, 294.0, -645.0, 2087.0, 1893.0, 4063.0, -6237.0, 8092.0, 4561.0, 31947.0, -43006.0, 74630.0, -1.0, 19.0, -41.0, 190.0, 227.0, 244.0, -711.0, 2085.0, 1822.0, 3705.0, -6589.0, 8492.0, 3776.0, 30112.0, -44821.0, 74313.0, -1.0, 17.0, -45.0, 183.0, 228.0, 197.0, -779.0, 2075.0, 1739.0, 3351.0, -6935.0, 8840.0, 2935.0, 28289.0, -46617.0, 73908.0, -1.0, 16.0, -49.0, 176.0, 228.0, 153.0, -848.0, 2057.0, 1644.0, 3004.0, -7271.0, 9139.0, 2037.0, 26482.0, -48390.0, 73415.0, -2.0, 14.0, -53.0, 169.0, 227.0, 111.0, -919.0, 2032.0, 1535.0, 2663.0, -7597.0, 9389.0, 1082.0, 24694.0, -50137.0, 72835.0, -2.0, 13.0, -58.0, 161.0, 224.0, 72.0, -991.0, 2001.0, 1414.0, 2330.0, -7910.0, 9592.0, 70.0, 22929.0, -51853.0, 72169.0, -2.0, 11.0, -63.0, 154.0, 221.0, 36.0, -1064.0, 1962.0, 1280.0, 2006.0, -8209.0, 9750.0, -998.0, 21189.0, -53534.0, 71420.0, -2.0, 10.0, -68.0, 147.0, 215.0, 2.0, -1137.0, 1919.0, 1131.0, 1692.0, -8491.0, 9863.0, -2122.0, 19478.0, -55178.0, 70590.0, -3.0, 9.0, -73.0, 139.0, 208.0, -29.0, -1210.0, 1870.0, 970.0, 1388.0, -8755.0, 9935.0, -3300.0, 17799.0, -56778.0, 69679.0, -3.0, 8.0, -79.0, 132.0, 200.0, -57.0, -1283.0, 1817.0, 794.0, 1095.0, -8998.0, 9966.0, -4533.0, 16155.0, -58333.0, 68692.0, -4.0, 7.0, -85.0, 125.0, 189.0, -83.0, -1356.0, 1759.0, 605.0, 814.0, -9219.0, 9959.0, -5818.0, 14548.0, -59838.0, 67629.0, -4.0, 7.0, -91.0, 117.0, 177.0, -106.0, -1428.0, 1698.0, 402.0, 545.0, -9416.0, 9916.0, -7154.0, 12980.0, -61289.0, 66494.0, -5.0, 6.0, -97.0, 111.0, 163.0, -127.0, -1498.0, 1634.0, 185.0, 288.0, -9585.0, 9838.0, -8540.0, 11455.0, -62684.0, 65290.0]);
    var tmp_4 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_5 = new Float32Array([0.8574929, 0.881742, 0.94962865, 0.9833146, 0.9955178, 0.9991606, 0.9998992, 0.99999315]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.fku_1 = [tmp_5, new Float32Array([0.51449573, 0.47173196, 0.31337744, 0.1819132, 0.09457419, 0.04096558, 0.01419856, 0.00369997])];
    var tmp_6 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_7 = new Float32Array([0.99904823, 0.9914449, 0.976296, 0.95371693, 0.9238795, 0.8870108, 0.8433915, 0.7933533, 0.7372773, 0.04361938, 0.13052619, 0.2164396, 0.3007058, 0.38268343, 0.4617486, 0.53729963, 0.6087614, 0.6755902]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.gku_1 = [tmp_7, new Float32Array([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.9914449, 0.9238795, 0.7933533, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.13052619, 0.38268343, 0.6087614])];
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_8.hku_1 = new Float32Array([9.313226E-10, 7.831458E-10, 6.585445E-10, 5.537677E-10]);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_9.iku_1 = new Float32Array([9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 7.0, 7.569318E-7 / 7.0, 6.007772E-7 / 7.0, 9.536743E-7 / 15.0, 7.569318E-7 / 15.0, 6.007772E-7 / 15.0, 9.536743E-7 / 31.0, 7.569318E-7 / 31.0, 6.007772E-7 / 31.0, 9.536743E-7 / 63.0, 7.569318E-7 / 63.0, 6.007772E-7 / 63.0, 9.536743E-7 / 127.0, 7.569318E-7 / 127.0, 6.007772E-7 / 127.0, 9.536743E-7 / 255.0, 7.569318E-7 / 255.0, 6.007772E-7 / 255.0, 9.536743E-7 / 511.0, 7.569318E-7 / 511.0, 6.007772E-7 / 511.0, 9.536743E-7 / 1023.0, 7.569318E-7 / 1023.0, 6.007772E-7 / 1023.0, 9.536743E-7 / 2047.0, 7.569318E-7 / 2047.0, 6.007772E-7 / 2047.0, 9.536743E-7 / 4095.0, 7.569318E-7 / 4095.0, 6.007772E-7 / 4095.0, 9.536743E-7 / 8191.0, 7.569318E-7 / 8191.0, 6.007772E-7 / 8191.0, 9.536743E-7 / 16383.0, 7.569318E-7 / 16383.0, 6.007772E-7 / 16383.0, 9.536743E-7 / 32767.0, 7.569318E-7 / 32767.0, 6.007772E-7 / 32767.0, 9.536743E-7 / 65535.0, 7.569318E-7 / 65535.0, 6.007772E-7 / 65535.0, 9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 5.0, 7.569318E-7 / 5.0, 6.007772E-7 / 5.0, 9.536743E-7 / 9.0, 7.569318E-7 / 9.0, 6.007772E-7 / 9.0]);
    var tmp_10 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_10.jku_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_11 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [new UByteArrayInt(arrayOfUByte(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte(this, '\x00\x10\x18\x1C (08@HPX`p\x80'))];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_11.kku_1 = [tmp_12, [new UByteArrayInt(arrayOfUByte(this, '\x00\x10\x14\x18\x1C (08@P`p\x80\xA0')), new UByteArrayInt(arrayOfUByte(this, '\x00\x10\x18\x1C (08@P`p\x80\xA0\xC0')), new UByteArrayInt(arrayOfUByte(this, '\x00\x10 0@P`p\x80\x90\xA0\xB0\xC0\xD0\xE0'))]];
    this.lku_1 = arrayOfUByte(this, '\x00\x01\x02\x03\f\x05\x06\x07\t\n\x0B\r\x0E\x0F\x12\x13');
    this.mku_1 = arrayOfUByte(this, '\x05\x05\x04\x04\x05\x05\x04\x01\x04\x03\x01\x01\x05\x06\x06\x01\x04\x04\x04\x01\x04\x03\x01\x01');
    this.nku_1 = arrayOfUByte(this, '\x01\x01\x01\x01\x02\x02\x03\x03\x03\x02');
    this.oku_1 = arrayOfShort(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFF01\u0521\u0512\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0122\u0120\uFF01\u0521\u0512\u0502\u0301\u0301\u0301\u0301\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0122\u0120\uFF03\uFEC2\uFEA1\uFE91\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0333\u0332\u0223\u0223\u0113\u0113\u0113\u0113\u0231\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF02\uFEE1\u0531\u0513\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0310\u0310\u0310\u0310\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\u0233\u0230\u0132\u0132\u0123\u0103\uFF04\uFE63\uFE23\uFDE2\u0512\uFDC1\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE81\uFE71\u0453\u0444\u0452\u0425\u0351\u0351\u0315\u0315\u0450\u0443\u0305\u0305\u0434\u0433\u0155\u0154\u0145\u0135\u0342\u0324\u0241\u0241\u0214\u0214\u0204\u0204\u0340\u0332\u0323\u0330\u0231\u0231\u0213\u0213\u0203\u0222\u0121\u0121\u0120\u0102\uFF04\uFE53\uFE13\uFDD1\u0421\u0421\u0412\u0412\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\uFE82\u0435\uFE61\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0433\u0342\u0342\u0255\u0245\u0154\u0154\u0153\u0144\u0324\u0341\u0214\u0214\u0340\u0304\u0332\u0323\u0331\u0313\u0330\u0303\u0122\u0122\u0122\u0122\u0120\u0102\uFF03\uFEA3\uFE62\uFE41\uFE31\u0531\u0513\uFE21\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\uFEC1\u0353\u0335\uFEB1\u0344\u0352\u0325\u0351\u0155\u0154\u0145\u0150\u0215\u0215\u0243\u0243\u0234\u0234\u0305\u0340\u0242\u0224\u0233\u0204\u0141\u0114\u0132\u0123\u0130\u0103\uFF05\uFDC4\uFD23\uFCC2\uFCA1\uFC91\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\u0574\u0547\u0565\u0556\u0573\u0537\u0564\uFDD1\u0536\u0472\u0472\u0427\u0427\u0546\u0570\u0407\u0407\u0426\u0426\u0554\u0553\u0460\u0460\u0535\u0544\u0371\u0371\u0371\u0371\u0177\u0176\u0167\u0175\u0157\u0166\u0155\u0145\u0317\u0317\u0463\u0462\uFD41\u0451\u0415\uFD31\u0361\u0361\u0316\u0316\u0306\u0306\u0450\u0405\u0152\u0125\u0143\u0134\uFCE1\uFCD1\u0341\u0314\u0304\u0332\u0323\u0330\u0142\u0124\u0133\u0140\u0231\u0213\u0203\u0222\u0121\u0112\u0120\u0102\uFF05\uFDF3\uFDA3\uFD53\uFD03\uFCC1\uFCB2\u0512\u0421\u0421\u0520\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0577\u0576\u0567\u0557\u0566\u0574\u0547\uFE01\u0565\u0556\u0473\u0473\u0437\u0437\u0464\u0464\u0554\u0545\u0553\u0535\u0372\u0372\u0372\u0372\u0327\u0327\u0327\u0327\u0446\u0446\u0470\u0470\u0175\u0155\u0217\u0217\u0371\u0307\u0363\u0336\u0306\uFDB1\u0144\u0152\uFD61\u0351\u0226\u0226\u0362\u0360\u0261\u0261\u0125\u0150\u0216\u0216\u0315\u0343\u0305\uFD11\u0342\u0324\u0134\u0133\u0341\u0314\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\uFF04\uFE73\uFE23\uFDD3\uFD92\uFD73\uFD31\uFD21\uFD12\u0531\u0513\u0522\u0421\u0421\u0412\u0412\u0520\u0502\u0400\u0400\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\uFE81\u0467\u0475\u0457\u0466\u0474\u0447\u0456\u0365\u0365\u0373\u0373\u0437\u0455\u0372\u0372\u0177\u0176\u0327\u0364\u0346\u0371\u0317\uFE31\u0363\u0336\u0170\u0107\u0354\u0345\u0344\uFDE1\u0262\u0262\u0226\u0226\u0160\u0150\u0216\u0216\u0361\u0306\u0353\u0335\u0352\u0325\u0251\u0215\u0243\u0234\u0305\u0340\u0242\u0242\u0224\u0224\u0241\u0241\u0133\u0114\u0132\u0123\u0204\u0230\u0103\u0103\uFF06\uF7C5\uF635\uF534\uF4A3\uF462\uF441\uF431\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFD01\uFBE4\uFB43\uFB03\uFAB2\uFA83\uFA43\uFA01\uF9F2\uF9D2\uF9B2\uF991\uF982\uF962\uF942\uF921\uF912\uF8F1\uF8E2\uF8C2\uF8A2\u061D\uF881\uF871\uF861\uF851\u06C3\u06C2\u062C\u06B5\uF841\u06C1\u061C\uF831\u060C\uF821\uF811\u06B3\u063B\uF801\u06B2\uF7F1\u064A\uF7E1\u0649\uF7D1\u052B\u052B\u05B1\u05B1\u051B\u051B\u06B0\u060B\u0669\u06A4\u06A3\u063A\u0695\u0659\u05A2\u05A2\u052A\u052A\uFCF4\uFC33\uFC72\u04FF\u04FE\u04FD\u04EE\u04FC\u04ED\u04FB\u04BF\u04EC\u04CD\uFC41\u03CE\u03CE\u03DD\u03DD\uFC51\u02DF\u01DE\u01DE\u01EF\u01CF\u01FA\u019E\uFBF1\u03EB\u03BE\u03F9\u039F\u03AE\u03DB\u03BD\u01AF\u01DC\u04F8\u048F\u04CC\uFB61\u04E8\uFB51\u037F\u037F\u03AD\u03AD\u04DA\u04CB\u04BC\u046F\u03F6\u03F6\u01EA\u01E9\u01F7\u01E7\u038E\u03F5\u03D9\u039D\u035F\u037E\u03CA\u03BB\u03F4\u034F\uFAC1\u033F\u02F3\u02F3\u03D8\u038D\u01AC\u016E\u02F2\u022F\uFA91\u02F0\u01E6\u01C9\u039C\u03E5\u02BA\u02BA\u03D7\u037D\u02E4\u02E4\u038C\u036D\u02E3\u02E3\u029B\u029B\u03B9\u03AA\u01F1\u011F\u010F\u010F\u02AB\u025E\u024E\u02C8\u02D6\u023E\u012E\u012E\u02E2\u02E0\u01E1\u011E\u020E\u02D5\u025D\u02C7\u027C\u02D4\u02B8\u028B\u024D\u02A9\u029A\u02C6\u016C\u01D3\u023D\u02B7\u01D2\u01D2\u012D\u01D1\u017B\u017B\u02C5\u025C\u0299\u02A7\u013C\u013C\u027A\u0279\u01B4\u01B4\u01D0\u010D\u01A8\u018A\u01C4\u014C\u01B6\u016B\u015B\u0198\u0189\u01C0\u014B\u01A6\u016A\u0197\u0188\u01A5\u015A\u0196\u0187\u0178\u0177\u0167\u05A1\u051A\uF6C1\u050A\uF6B1\u0539\uF6A1\uF691\u0592\u0529\uF681\u0583\u0538\uF671\uF661\uF651\u0491\u0491\u0419\u0419\u0590\u0509\u0584\u0548\u0527\uF641\u0482\u0482\u0428\u0428\u0481\u0481\u01A0\u0186\u0168\u0194\u0193\u0185\u0158\u0176\u0175\u0157\u0166\u0174\u0147\u0165\u0156\u0137\u0164\u0146\u0573\u0572\u0471\u0471\u0417\u0417\u0555\u0570\u0507\u0563\u0536\u0554\u0545\u0562\u0526\u0553\u0318\u0318\u0318\u0318\u0480\u0480\u0408\u0408\u0461\u0461\u0416\u0416\u0460\u0460\u0406\u0406\uF4B1\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0135\u0144\u0214\u0214\u0340\u0304\u0332\u0323\u0231\u0231\u0213\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF06\uFB65\uF9D5\uF8D4\uF834\uF7B4\uF733\uF6E3\uF693\uF653\uF612\uF5F2\uF5D1\uF5C2\uF5A1\u0522\u0521\u0512\u0520\u0502\u0311\u0311\u0311\u0311\u0410\u0410\u0401\u0401\u0300\u0300\u0300\u0300\uFD02\uFCE2\uFCC2\uFCA2\uFC81\uFC71\uFC61\uFC51\uFC41\uFC31\uFC21\uFC11\uFC01\uFBF1\uFBE1\uFBD2\u06BC\u066F\uFBB1\uFBA1\u065F\u06E7\u067E\u06CA\u06AC\u06BB\uFB91\u06F4\u064F\u06F3\u063F\u068D\u066E\u06F2\u062F\uFB81\u06F1\u061F\u06C9\u069C\u06E5\u06BA\u06AB\u065E\u06D7\u067D\u06E4\u064E\u06C8\u068C\u06E3\u06D6\u066D\u063E\u06B9\u069B\u06E2\u06AA\u062E\u06E1\u061E\uFB71\u06D5\u065D\u02FF\u02FE\u02EF\u02FD\u01EE\u01EE\u02DF\u02FC\u02CF\u02ED\u02DE\u02FB\u01BF\u01BF\u02EC\u02CE\u01DD\u01FA\u01AF\u01EB\u01BE\u01DC\u01CD\u01F9\u019F\u01AE\u01DB\u01BD\u01F8\u018F\u01CC\u01E9\u019E\u01F7\u017F\u01DA\u01AD\u01CB\u01F6\u01F6\u02EA\u02F0\u01E8\u018E\u01F5\u01D9\u019D\u01D8\u01E6\u010F\u01E0\u010E\uFA61\uFA51\u054D\uFA41\uFA31\uFA21\u053D\u052D\uFA11\u05D1\u05B7\u057B\u051D\uFA01\u055C\u05A8\u058A\u05C4\u054C\u05B6\u056B\uF9F1\u05C3\u053C\u05A7\u057A\u056A\uF9E1\u042C\u042C\u05C2\u05B5\u01C7\u017C\u01D4\u01B8\u018B\u01A9\u019A\u01C6\u016C\u01D3\u01D2\u01D0\u01C5\u010D\u0199\u01C0\u010C\u01B0\u055B\u05C1\u0598\u0589\u051C\u05B4\u054B\u05A6\u05B3\u0597\u043B\u043B\u0579\u0588\u05B2\u05A5\u042B\u042B\u055A\u05B1\u041B\u041B\u050B\u0596\u0569\u05A4\u054A\u0587\u0578\u05A3\u043A\u043A\u0495\u0459\u04A2\u042A\u04A1\u041A\uF851\u0486\u0468\u0494\u0449\u0493\u0439\uF841\u0485\u0458\u01A0\u010A\u0177\u0190\u0492\u0476\u0467\u0429\u0319\u0319\u0491\u0409\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0474\u0382\u0382\u0328\u0328\u0381\u0381\u0318\u0318\u0447\u0480\u0408\u0465\u0456\u0473\u0437\u0464\u0372\u0327\u0346\u0371\u0355\u0317\uF6F1\u0363\u0170\u0107\u0336\u0354\u0345\u0362\u0326\u0361\uF6A1\u0353\u0160\u0106\u0216\u0216\u0335\u0344\u0252\u0252\u0225\u0225\u0251\u0251\u0215\u0215\u0350\u0305\u0243\u0243\u0234\u0242\u0224\u0233\u0114\u0114\u0241\u0240\u0132\u0123\u0204\u0230\u0131\u0131\u0113\u0103\uFF05\uFC84\uF7F6\uF5C4\uF4F4\uF473\uF431\uF421\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\uFDD1\u05FA\uFDC1\uFDB1\u05F8\u05F7\u057F\u05F6\u056F\u03FF\u03FF\u03FF\u03FF\u05F5\u055F\u04F4\u04F4\u044F\u044F\u043F\u043F\u040F\u040F\u05F3\uFDA4\u032F\u032F\u032F\u032F\u01FE\u01EF\u01FD\u01DF\u01FC\u01CF\u01FB\u01BF\u01AF\u01F9\u019F\u018F\uFD22\uFCF2\u04EE\uFCD1\u04EB\u04DC\uFCC1\u04EA\u04CC\uFCB1\uFCA1\u04AC\uFC91\u04E5\u03DB\u03DB\u02EC\uFD01\u01ED\u01ED\u01CE\u01DD\u019E\u019E\u02AE\u029D\u01DE\u01BE\u01CD\u01BD\u01DA\u01AD\u01E7\u01CA\u019C\u01D7\u04F2\u04F0\u03F1\u03F1\u031F\u031F\uFC05\uFB04\uFA54\uF9D3\uF973\uF923\uF8E3\uF8A2\uF873\uF833\u04E9\u04E9\u05CB\u05BC\u05E8\u058E\u05D9\u057E\u05BB\u05D8\u058D\u05E6\u046E\u046E\u04C9\u04C9\u05BA\u05AB\u055E\u057D\u04E4\u04E4\u054E\u05C8\u048C\u048C\u04E3\u04E3\u04D6\u04D6\u056D\u05B9\uFA81\u041E\u044D\uFA71\u04B7\uFA61\u033E\u033E\u04E0\u040E\u04D5\u045D\u04C7\u047C\u04D4\u04B8\u019B\u01AA\u018B\u019A\u017B\u010D\u04A9\u04C6\u046C\u04D3\u04C5\u045C\u03D0\u03D0\u04A8\u048A\u0499\u04C4\u046B\u04A7\u03C3\u03C3\uF991\u03C1\u030C\uF981\u022E\u022E\u03E2\u03E1\u01B5\u0198\u0189\u0197\u033D\u03D2\u032D\u031D\u03B3\uF931\u02D1\u02D1\u0179\u0188\u034C\u03B6\u033C\u037A\u02C2\u02C2\u032C\u035B\u031C\u03C0\u03B4\u034B\u03A6\u036A\u023B\u023B\uF881\u02B2\u022B\u02B1\u01A5\u015A\u021B\u021B\u03B0\u030B\u0396\u0369\u03A4\u034A\u0387\u0378\u023A\u023A\u03A3\u0395\u02A2\u02A2\uF5F1\u061A\uF5E1\u0649\uF5D1\u0676\u052A\u052A\u05A1\u05A1\u06A0\u060A\u0693\u0639\u0685\u0658\u0592\u0592\u0529\u0529\u0667\u0690\u0591\u0591\u0519\u0519\u0609\u0684\u0648\u0657\u0683\u0638\u0666\u0682\u0528\u0528\u0674\u0647\u0581\u0581\u0518\u0518\u0508\u0508\u0680\u0665\u0573\u0573\u0537\u0537\u0656\u0664\u0572\u0572\u0527\u0527\u0646\u0655\u0570\u0570\u0471\u0471\u0471\u0471\u0159\u0186\u0168\u0177\u0194\u0175\u0417\uF541\uF531\uF521\u0426\u0461\u0416\uF511\u0435\uF501\u0452\u0425\u0315\u0315\u0451\u0450\u0107\u0163\u0136\u0154\u0145\u0162\u0160\u0106\u0153\u0144\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0314\u0314\u0440\u0404\u0332\u0332\u0323\u0323\u0231\u0231\u0213\u0213\u0330\u0303\u0222\u0222\u0121\u0112\u0120\u0102\uFF03\uFEC3\uFE83\uFE42\uFE22\uFE03\u04FF\u04FF\uFCD5\uFB65\uFA55\uF924\uF894\uF814\uF773\uF733\uF6E3\uF692\uF673\uF631\uF622\u0521\u0512\uF601\u0411\u0411\u0410\u0410\u0401\u0401\u0400\u0400\u03FE\u03EF\u03FD\u03DF\u03FC\u03CF\u03FB\u03BF\u02AF\u02AF\u03FA\u03F9\u029F\u029F\u028F\u028F\u03F8\u03F7\u027F\u027F\u02F6\u02F6\u026F\u026F\u02F5\u025F\u02F4\u024F\u02F3\u023F\u02F2\u022F\u021F\u021F\u03F1\u030F\uFDC1\uFD93\uFD53\uFD13\u01F0\uFDB2\u02EE\u02ED\u02DE\u02EC\u03CE\u03DD\u03EB\u03BE\u03DC\u03CD\u03EA\u03AE\u03DB\u03BD\u03CC\u03E9\u039E\u03DA\u03AD\u03CB\u03BC\u03E8\u038E\u03D9\u039D\u03E7\u037E\u03CA\uFBD1\uFBC1\uFBB2\u056E\uFB91\u059C\u05E5\u05AB\u055E\uFB81\u057D\u054E\u05C8\u058C\uFB71\u05E3\u05D6\u056D\u053E\u05B9\u059B\u05AA\u052E\u05E1\u051E\u05D5\u055D\u05C7\u057C\u05D4\u05B8\u058B\u01AC\u01BB\u01D8\u018D\u02E0\u020E\u01D0\u01D0\u01E6\u01C9\u01BA\u01D7\u01E4\u01E2\u054D\u05A9\u059A\u05C6\u056C\u05D3\u053D\u05D2\u052D\u05D1\u05B7\u057B\u051D\u05C5\u055C\u05A8\u058A\u0599\u05C4\u054C\u05B6\u056B\uFA61\u05C3\u053C\u05A7\u057A\u05C2\u052C\u05B5\u055B\u05C1\u010D\u01C0\u0598\u0589\u051C\u05B4\uF951\u05B3\uF941\u05A1\u044B\u044B\u05A6\u056A\u0597\u0579\uF931\u0509\u043B\u043B\u0488\u0488\u05B2\u05A5\u042B\u042B\u055A\u05B1\u051B\u0596\u0469\u0469\u044A\u044A\u010C\u01B0\u010B\u01A0\u010A\u0190\uF8A1\u0478\u04A3\u043A\u0495\u0459\u04A2\u042A\u041A\u0486\u0468\u0477\u0494\u0449\u0493\u0439\u01A4\u0187\u0485\u0458\u0492\u0476\u0467\u0429\u0491\u0419\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0482\u0428\u0481\u0474\u0447\u0418\uF791\u0465\u0456\u0471\uF781\u0337\u0337\u0473\u0472\u0327\u0327\u0180\u0108\u0170\u0107\u0364\u0346\u0355\u0317\u0363\u0336\u0354\u0345\u0362\u0326\u0361\u0316\uF6F1\u0353\u0335\u0344\u0160\u0106\u0352\u0325\u0351\uF6A1\u0215\u0215\u0343\u0334\u0150\u0105\u0242\u0224\u0233\u0241\u0214\u0214\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\u0120\u0102');
    this.pku_1 = arrayOfUByte(this, '\x82\xA2\xC1\xD1,\x1CL\x8C\t\t\t\t\t\t\t\t\xBE\xFE\xDE\xEE~^\x9D\x9Dm=\xAD\xCD');
    this.qku_1 = arrayOfUByte(this, '\xFC\xEC\xDC\xCC\xBC\xAC\x9C\x8C|l\\L<,\x1C\f');
    this.rku_1 = arrayOfShort(this, '\x00 @b\x00\x84\xB4\xDA\u0124\u016C\u01AA\u021A\u0288\u02EA\x00\u0466\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u0732\u0732\u0732\u0732\u0732\u0732\u0732\u0732');
    this.sku_1 = arrayOfUByte(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x01\x02\x03\x04\x06\b\n\r\x04\x05\x06\x07\b\t\x0B\r');
    this.tku_1 = arrayOfUByte(this, '\x00\x11\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x10\x00\x11\x12\x03\x13\x04\x05\x10\x00\x11\x12\x10\x00\x11\x12\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x00\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10');
    var tmp_13 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_13.uku_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte(this, '\f\f\f\f\f\f\x10\x14\x18\x1C (08@LZ\x02\x02\x02\x02\x02\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x12\x16\x1A &.6>FL$\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\b\n\f\x10\x14\x18\x1C"*26L\x9E\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\n\f\x10\x12\x16\x1C"(.66\xC0\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\n\f\x10\x14\x18\x1E&.8DTf\x1A\x00'))];
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.vku_1 = [new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte(this, '\b\b\b\b\b\b\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00')), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00'))];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.wku_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\f\f\f\x04\x04\x04\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00', 40))];
    var tmp_16 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_16.xku_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x05\x05\x05\x06\x05\x05\x05\x06\x05\x07\x03\x0B\n\x00\x00\x07\x07\x07\x00\x06\x06\x06\x03\b\b\x05\x00')), new UByteArrayInt(arrayOfUByte(this, '\b\t\x06\f\x06\t\t\t\x06\t\f\x06\x0F\x12\x00\x00\x06\x0F\f\x00\x06\f\t\x06\x06\x12\t\x00')), new UByteArrayInt(arrayOfUByte(this, '\t\t\x06\f\t\t\t\t\t\t\f\x06\x12\x12\x00\x00\f\f\f\x00\f\t\t\x06\x0F\f\t\x00'))];
    var tmp_17 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_17.yku_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(76), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(32))];
    var tmp_18 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_18.zku_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(60), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(4)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(7)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(19))];
    var tmp_19 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_19.akv_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(0), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(3)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(16), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(8)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(32), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(12)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(40), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(7))];
    var tmp_20 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_20.bkv_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(2)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(10))];
    var tmp_21 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_21.ckv_1 = new Float32Array([0.0, -1.0, -2.519842, -4.326749, -6.349604, -8.54988, -10.902724, -13.390518, -16.0, -18.720755, -21.544348, -24.463781, -27.473143, -30.56735, -33.741993, -36.99318, 0.0, 1.0, 2.519842, 4.326749, 6.349604, 8.54988, 10.902724, 13.390518, 16.0, 18.720755, 21.544348, 24.463781, 27.473143, 30.56735, 33.741993, 36.99318, 40.317474, 43.71179, 47.173344, 50.69963, 54.288353, 57.93741, 61.644863, 65.40894, 69.22798, 73.10044, 77.024895, 81.0, 85.02449, 89.09719, 93.21697, 97.3828, 101.593666, 105.84863, 110.146805, 114.48732, 118.869385, 123.292206, 127.755066, 132.25725, 136.79808, 141.3769, 145.99312, 150.64612, 155.33533, 160.0602, 164.8202, 169.61482, 174.44357, 179.30598, 184.20157, 189.12991, 194.09058, 199.08315, 204.10721, 209.16238, 214.24829, 219.36456, 224.51085, 229.68678, 234.89206, 240.12633, 245.38928, 250.6806, 256.0, 261.34717, 266.72183, 272.12372, 277.55255, 283.00806, 288.48996, 293.99805, 299.53207, 305.09177, 310.6769, 316.28726, 321.92258, 327.5827, 333.26736, 338.97638, 344.70956, 350.46664, 356.24747, 362.05188, 367.8796, 373.73053, 379.60443, 385.50113, 391.4205, 397.3623, 403.32642, 409.31268, 415.3209, 421.3509, 427.4026, 433.47574, 439.57028, 445.68597, 451.82275, 457.98044, 464.15887, 470.35797, 476.57755, 482.81744, 489.0776, 495.35788, 501.65808, 507.97815, 514.31793, 520.6773, 527.0562, 533.4544, 539.8719, 546.3085, 552.76404, 559.2386, 565.7319, 572.2439, 578.7744, 585.3235, 591.89087, 598.47656, 605.08044, 611.70233, 618.3422, 625.0, 631.67554, 638.3688, 645.0796]);
  }
}
class L12_subband_alloc_tStruct {
  constructor(tab_offset, code_tab_width, band_count) {
    this.dkv_1 = tab_offset;
    this.ekv_1 = code_tab_width;
    this.fkv_1 = band_count;
  }
  toString() {
    return 'L12_subband_alloc_tStruct(tab_offset=' + new UByte(this.dkv_1) + ', code_tab_width=' + new UByte(this.ekv_1) + ', band_count=' + new UByte(this.fkv_1) + ')';
  }
  hashCode() {
    var result = UByte__hashCode_impl_mmczcb(this.dkv_1);
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.ekv_1) | 0;
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.fkv_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof L12_subband_alloc_tStruct))
      return false;
    var tmp0_other_with_cast = other instanceof L12_subband_alloc_tStruct ? other : THROW_CCE();
    if (!(this.dkv_1 === tmp0_other_with_cast.dkv_1))
      return false;
    if (!(this.ekv_1 === tmp0_other_with_cast.ekv_1))
      return false;
    if (!(this.fkv_1 === tmp0_other_with_cast.fkv_1))
      return false;
    return true;
  }
}
class Mp3Dec {
  constructor(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    return new.target.gkv(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf);
  }
  static gkv(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    var $this = createThis(this);
    $this.hkp_1 = mdct_overlap;
    $this.ikp_1 = qmf_state;
    $this.jkp_1 = reserv;
    $this.kkp_1 = free_format_bytes_array;
    $this.lkp_1 = header;
    $this.mkp_1 = reserv_buf;
    return $this;
  }
  static nkp() {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(2);
    while (tmp < 2) {
      tmp_0[tmp] = new Float32Array(288);
      tmp = tmp + 1 | 0;
    }
    return this.gkv(tmp_0, new Float32Array(960), 0, new Int32Array(1), _UByteArrayInt___init__impl__xif7bu_1(4), _UByteArrayInt___init__impl__xif7bu_1(511));
  }
}
class Bs {
  constructor(buf, pos, limit) {
    buf = buf === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : buf;
    pos = pos === VOID ? 0 : pos;
    limit = limit === VOID ? 0 : limit;
    this.hkv_1 = buf;
    this.ikv_1 = pos;
    this.jkv_1 = limit;
  }
}
class Mp3Scratch {
  constructor(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    return new.target.rkv(bs, maindata, gr_info, grbuf, scf, syn, ist_pos);
  }
  static rkv(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    var $this = createThis(this);
    $this.kkv_1 = bs;
    $this.lkv_1 = maindata;
    $this.mkv_1 = gr_info;
    $this.nkv_1 = grbuf;
    $this.okv_1 = scf;
    $this.pkv_1 = syn;
    $this.qkv_1 = ist_pos;
    return $this;
  }
  static skv() {
    var tmp = new Bs();
    var tmp_0 = new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(2815));
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(4);
    while (tmp_1 < 4) {
      tmp_2[tmp_1] = new GrInfo();
      tmp_1 = tmp_1 + 1 | 0;
    }
    var tmp_3 = new ArrayPtr(tmp_2, 0);
    // Inline function 'kotlin.run' call
    var CSIZE = 576;
    var data = new Float32Array(imul(2, CSIZE));
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = Array(2);
    while (tmp_4 < 2) {
      var tmp_6 = tmp_4;
      tmp_5[tmp_6] = new FloatArrayPtr(data, imul(CSIZE, tmp_6));
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = new FloatArrayPtr(new Float32Array(40));
    // Inline function 'kotlin.run' call
    var CSIZE_0 = 64;
    var data_0 = new Float32Array(imul(33, CSIZE_0));
    var tmp_9 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = Array(33);
    while (tmp_9 < 33) {
      var tmp_11 = tmp_9;
      tmp_10[tmp_11] = new FloatArrayPtr(data_0, imul(CSIZE_0, tmp_11));
      tmp_9 = tmp_9 + 1 | 0;
    }
    var tmp_12 = tmp_10;
    var tmp_13 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = Array(2);
    while (tmp_13 < 2) {
      var tmp_15 = tmp_13;
      var tmp$ret$11 = _UByteArrayInt___init__impl__xif7bu_1(39);
      tmp_14[tmp_15] = new UByteArrayInt(tmp$ret$11);
      tmp_13 = tmp_13 + 1 | 0;
    }
    return this.rkv(tmp, tmp_0, tmp_3, tmp_7, tmp_8, tmp_12, tmp_14);
  }
}
class Mp3FrameInfo {
  constructor(frame_bytes, frame_offset, channels, hz, layer, bitrate_kbps) {
    frame_bytes = frame_bytes === VOID ? 0 : frame_bytes;
    frame_offset = frame_offset === VOID ? 0 : frame_offset;
    channels = channels === VOID ? 0 : channels;
    hz = hz === VOID ? 0 : hz;
    layer = layer === VOID ? 0 : layer;
    bitrate_kbps = bitrate_kbps === VOID ? 0 : bitrate_kbps;
    this.okq_1 = frame_bytes;
    this.pkq_1 = frame_offset;
    this.qkq_1 = channels;
    this.rkq_1 = hz;
    this.skq_1 = layer;
    this.tkq_1 = bitrate_kbps;
  }
  k3() {
    return this;
  }
}
class ArrayPtr {
  constructor(array, pos) {
    this.tkv_1 = array;
    this.ukv_1 = pos;
  }
  k3() {
    return this.tkv_1[this.ukv_1];
  }
  u2(index) {
    return this.tkv_1[this.ukv_1 + index | 0];
  }
  vkv() {
    return new ArrayPtr(this.tkv_1, this.ukv_1 + 1 | 0);
  }
  wkv(other) {
    return new ArrayPtr(this.tkv_1, this.ukv_1 + other | 0);
  }
}
class UByteArrayIntPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.xkv_1 = array;
    this.ykv_1 = pos;
  }
  k3() {
    return UByteArrayInt__get_impl_px6q8a(this.xkv_1, this.ykv_1);
  }
  u2(index) {
    return UByteArrayInt__get_impl_px6q8a(this.xkv_1, this.ykv_1 + index | 0);
  }
  s7x(index, value) {
    UByteArrayInt__set_impl_gn4532(this.xkv_1, this.ykv_1 + index | 0, value);
  }
  vkv() {
    return new UByteArrayIntPtr(this.xkv_1, this.ykv_1 + 1 | 0);
  }
  wkv(other) {
    return new UByteArrayIntPtr(this.xkv_1, this.ykv_1 + other | 0);
  }
  zkv(other) {
    return this.ykv_1 - other.ykv_1 | 0;
  }
  akw(value, from, to) {
    var tmp = _UByteArrayInt___get_bytes__impl__pj0ilc(this.xkv_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    fill(tmp, tmp$ret$0, this.ykv_1 + from | 0, this.ykv_1 + to | 0);
  }
}
class FloatArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.bkw_1 = array;
    this.ckw_1 = pos;
  }
  dkw(value) {
    this.bkw_1[this.ckw_1] = value;
  }
  k3() {
    return this.bkw_1[this.ckw_1];
  }
  u2(index) {
    return this.bkw_1[this.ckw_1 + index | 0];
  }
  ekw(index, value) {
    this.bkw_1[this.ckw_1 + index | 0] = value;
  }
  vkv() {
    return new FloatArrayPtr(this.bkw_1, this.ckw_1 + 1 | 0);
  }
  wkv(other) {
    return new FloatArrayPtr(this.bkw_1, this.ckw_1 + other | 0);
  }
  fkw(other) {
    return this.ckw_1 - other.ckw_1 | 0;
  }
  gkw(value, from, to) {
    fill_0(this.bkw_1, value, this.ckw_1 + from | 0, this.ckw_1 + to | 0);
  }
}
class ShortArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.hkw_1 = array;
    this.ikw_1 = pos;
  }
  jkw(index, value) {
    this.hkw_1[this.ikw_1 + index | 0] = value;
  }
  wkv(other) {
    return new ShortArrayPtr(this.hkw_1, this.ikw_1 + other | 0);
  }
}
class GrInfo {
  constructor(sfbtab, part_23_length, big_values, scalefac_compress, global_gain, block_type, mixed_block_flag, n_long_sfb, n_short_sfb, table_select, region_count, subblock_gain, preflag, scalefac_scale, count1_table, scfsi) {
    sfbtab = sfbtab === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : sfbtab;
    part_23_length = part_23_length === VOID ? 0 : part_23_length;
    big_values = big_values === VOID ? 0 : big_values;
    scalefac_compress = scalefac_compress === VOID ? 0 : scalefac_compress;
    global_gain = global_gain === VOID ? 0 : global_gain;
    block_type = block_type === VOID ? 0 : block_type;
    mixed_block_flag = mixed_block_flag === VOID ? 0 : mixed_block_flag;
    n_long_sfb = n_long_sfb === VOID ? 0 : n_long_sfb;
    n_short_sfb = n_short_sfb === VOID ? 0 : n_short_sfb;
    table_select = table_select === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : table_select;
    region_count = region_count === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : region_count;
    subblock_gain = subblock_gain === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : subblock_gain;
    preflag = preflag === VOID ? 0 : preflag;
    scalefac_scale = scalefac_scale === VOID ? 0 : scalefac_scale;
    count1_table = count1_table === VOID ? 0 : count1_table;
    scfsi = scfsi === VOID ? 0 : scfsi;
    this.kkw_1 = sfbtab;
    this.lkw_1 = part_23_length;
    this.mkw_1 = big_values;
    this.nkw_1 = scalefac_compress;
    this.okw_1 = global_gain;
    this.pkw_1 = block_type;
    this.qkw_1 = mixed_block_flag;
    this.rkw_1 = n_long_sfb;
    this.skw_1 = n_short_sfb;
    this.tkw_1 = table_select;
    this.ukw_1 = region_count;
    this.vkw_1 = subblock_gain;
    this.wkw_1 = preflag;
    this.xkw_1 = scalefac_scale;
    this.ykw_1 = count1_table;
    this.zkw_1 = scfsi;
  }
}
class ScaleInfo {
  constructor(scf, total_bands, stereo_bands, bitalloc, scfcod) {
    scf = scf === VOID ? new Float32Array(192) : scf;
    total_bands = total_bands === VOID ? 0 : total_bands;
    stereo_bands = stereo_bands === VOID ? 0 : stereo_bands;
    bitalloc = bitalloc === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : bitalloc;
    scfcod = scfcod === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : scfcod;
    this.akx_1 = scf;
    this.bkx_1 = total_bands;
    this.ckx_1 = stereo_bands;
    this.dkx_1 = bitalloc;
    this.ekx_1 = scfcod;
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_11();
    super(['wav']);
  }
  *tkm(data, props, $completion) {
    var tmp;
    try {
      tmp = yield* this.gkx(data, WAV$tryReadInfo$lambda, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          tmp_0 = null;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  *ukm(data, props, $completion) {
    var fmt = {_v: new Fmt()};
    var buffer = {_v: toAsync(MemorySyncStream())};
    yield* this.gkx(data, WAV$decodeStreamInternal$lambda(fmt, buffer), $completion);
    return new WavAudioStream(fmt._v, buffer._v, yield* buffer._v.pb8($completion), data, props);
  }
  *gkx(data, handle, $completion) {
    var fmt = new Fmt();
    var dataSize = {_v: new Long(0, 0)};
    yield* this.hkx(data, WAV$parse$slambda(fmt, dataSize, handle), $completion);
    if (fmt.nkx_1 < 0) {
      invalidOp("Couldn't find RIFF 'fmt ' chunk");
    }
    // Inline function 'kotlin.Long.times' call
    var this_0 = dataSize._v;
    // Inline function 'kotlin.Long.times' call
    var this_1 = multiply(this_0, fromInt(1000));
    var tmp$ret$1 = multiply(this_1, fromInt(1000));
    // Inline function 'korlibs.time.microseconds' call
    var this_2 = divide(tmp$ret$1, fmt.qkx_1);
    var tmp$ret$2 = toDuration_0(this_2, DurationUnit_MICROSECONDS_getInstance());
    return new Info(tmp$ret$2, fmt.okx_1);
  }
  *hkx(data, handler, $completion) {
    var s2 = data.ub9();
    if (compare(yield* s2.wb9($completion), new Long(12, 0)) < 0) {
      // Inline function 'kotlin.error' call
      var message = 'Not enough data for a RIFF file';
      throw IllegalStateException.o(toString(message));
    }
    var magic = yield* readString_0(s2, 4, VOID, $completion);
    var length = yield* readS32LE(s2, $completion);
    var magic2 = yield* readString_0(s2, 4, VOID, $completion);
    if (!(magic === 'RIFF')) {
      invalidAudioFormat("Not a RIFF file but '" + magic + "'");
    }
    if (!(magic2 === 'WAVE')) {
      invalidAudioFormat('Not a RIFF + WAVE file');
    }
    var s = yield* readStream(s2, length - 4 | 0, $completion);
    $l$loop_0: while (!(yield* s.xb9($completion)) && compare(yield* s.wb9($completion), new Long(8, 0)) >= 0) {
      var type = yield* readString_0(s, 4, VOID, $completion);
      var size = yield* readS32LE(s, $completion);
      if (compare(yield* s.wb9($completion), fromInt(size)) < 0)
        break $l$loop_0;
      var d = yield* readStream(s, size, $completion);
      yield* handler(new Chunk(type, d), $completion);
    }
    return Unit_instance;
  }
}
class Companion_7 extends WAV {
  constructor() {
    Companion_instance_8 = null;
    super();
    Companion_instance_8 = this;
  }
}
class Chunk {
  constructor(type, data) {
    this.ikx_1 = type;
    this.jkx_1 = data;
  }
  jm() {
    return this.ikx_1;
  }
  km() {
    return this.jkx_1;
  }
  toString() {
    return 'Chunk(type=' + this.ikx_1 + ', data=' + this.jkx_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.ikx_1);
    result = imul(result, 31) + hashCode(this.jkx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this.ikx_1 === tmp0_other_with_cast.ikx_1))
      return false;
    if (!equals(this.jkx_1, tmp0_other_with_cast.jkx_1))
      return false;
    return true;
  }
}
class ProcessedChunk {
  constructor(type, data, extra) {
    this.kkx_1 = type;
    this.lkx_1 = data;
    this.mkx_1 = extra;
  }
  toString() {
    return 'ProcessedChunk(type=' + this.kkx_1 + ', data=' + this.lkx_1.toString() + ', extra=' + toString(this.mkx_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.kkx_1);
    result = imul(result, 31) + hashCode(this.lkx_1) | 0;
    result = imul(result, 31) + hashCode(this.mkx_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this.kkx_1 === tmp0_other_with_cast.kkx_1))
      return false;
    if (!equals(this.lkx_1, tmp0_other_with_cast.lkx_1))
      return false;
    if (!equals(this.mkx_1, tmp0_other_with_cast.mkx_1))
      return false;
    return true;
  }
}
class WavAudioStream extends AudioStream {
  constructor(fmt, buffer, bufferLength, data, props) {
    super(fmt.pkx_1, fmt.okx_1);
    this.zkx_1 = fmt;
    this.aky_1 = buffer;
    this.bky_1 = bufferLength;
    this.cky_1 = data;
    this.dky_1 = props;
    this.eky_1 = this.zkx_1.gky();
    this.fky_1 = false;
  }
  mkt() {
    return this.fky_1;
  }
  *nkt(position, $completion) {
    this.fky_1 = false;
    var tmp = this.aky_1;
    var tmp0 = this.ukt(position);
    // Inline function 'kotlin.Long.times' call
    var other = this.eky_1;
    tmp.yb8_1 = multiply(tmp0, fromInt(other));
    return Unit_instance;
  }
  *vkt(out, offset, length, $completion) {
    var bytes = yield* readBytesUpTo(this.aky_1, imul(imul(length, this.eky_1), this.pkt_1), $completion);
    this.fky_1 = yield* this.aky_1.xb9($completion);
    var availableSamples = (bytes.length / this.eky_1 | 0) / this.pkt_1 | 0;
    var inductionVariable = 0;
    var last = this.pkt_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        switch (this.eky_1) {
          case 1:
            Companion_getInstance_11();
            var tmp4 = this.pkt_1;
            // Inline function 'korlibs.audio.format.WAV.readBlock' call

            var bytesPerSample = this.eky_1;
            var increment = imul(tmp4, bytesPerSample);
            var index = imul(channel, bytesPerSample);
            var outc = out.qhh(channel);
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < availableSamples)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp = offset + n | 0;
                var it = index;
                var tmp$ret$1 = _AudioSample___init__impl__s54gd5(toShortClamped(imul(getU8(bytes, it) - 128 | 0, 255)));
                AudioSampleArray__set_impl_tqgfwk(outc, tmp, tmp$ret$1);
                index = index + increment | 0;
              }
               while (inductionVariable_0 < availableSamples);
            break;
          case 2:
            Companion_getInstance_11();
            var tmp4_0 = this.pkt_1;
            // Inline function 'korlibs.audio.format.WAV.readBlock' call

            var bytesPerSample_0 = this.eky_1;
            var increment_0 = imul(tmp4_0, bytesPerSample_0);
            var index_0 = imul(channel, bytesPerSample_0);
            var outc_0 = out.qhh(channel);
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < availableSamples)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var tmp_0 = offset + n_0 | 0;
                var it_0 = index_0;
                var tmp$ret$3 = _AudioSample___init__impl__s54gd5(toShort(getS16LE(bytes, it_0)));
                AudioSampleArray__set_impl_tqgfwk(outc_0, tmp_0, tmp$ret$3);
                index_0 = index_0 + increment_0 | 0;
              }
               while (inductionVariable_1 < availableSamples);
            break;
          case 3:
            Companion_getInstance_11();
            var tmp4_1 = this.pkt_1;
            // Inline function 'korlibs.audio.format.WAV.readBlock' call

            var bytesPerSample_1 = this.eky_1;
            var increment_1 = imul(tmp4_1, bytesPerSample_1);
            var index_1 = imul(channel, bytesPerSample_1);
            var outc_1 = out.qhh(channel);
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < availableSamples)
              do {
                var n_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                var tmp_1 = offset + n_1 | 0;
                var it_1 = index_1;
                var tmp$ret$5 = _AudioSample___init__impl__s54gd5(toShort(getS24LE(bytes, it_1) >>> 8 | 0));
                AudioSampleArray__set_impl_tqgfwk(outc_1, tmp_1, tmp$ret$5);
                index_1 = index_1 + increment_1 | 0;
              }
               while (inductionVariable_2 < availableSamples);
            break;
          default:
            invalidOp('Unsupported bytesPerSample=' + this.eky_1);
            break;
        }
      }
       while (inductionVariable < last);
    return availableSamples;
  }
  *xkt($completion) {
    return ensureNotNull(yield* (new WAV()).ukm(this.cky_1.ub9(), this.dky_1, $completion));
  }
}
class Fmt {
  constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    formatTag = formatTag === VOID ? -1 : formatTag;
    channels = channels === VOID ? 2 : channels;
    samplesPerSec = samplesPerSec === VOID ? 44100 : samplesPerSec;
    avgBytesPerSec = avgBytesPerSec === VOID ? new Long(0, 0) : avgBytesPerSec;
    blockAlign = blockAlign === VOID ? 0 : blockAlign;
    bitsPerSample = bitsPerSample === VOID ? 0 : bitsPerSample;
    this.nkx_1 = formatTag;
    this.okx_1 = channels;
    this.pkx_1 = samplesPerSec;
    this.qkx_1 = avgBytesPerSec;
    this.rkx_1 = blockAlign;
    this.skx_1 = bitsPerSample;
  }
  gky() {
    return this.skx_1 / 8 | 0;
  }
  toString() {
    return 'Fmt(formatTag=' + this.nkx_1 + ', channels=' + this.okx_1 + ', samplesPerSec=' + this.pkx_1 + ', avgBytesPerSec=' + this.qkx_1.toString() + ', blockAlign=' + this.rkx_1 + ', bitsPerSample=' + this.skx_1 + ')';
  }
  hashCode() {
    var result = this.nkx_1;
    result = imul(result, 31) + this.okx_1 | 0;
    result = imul(result, 31) + this.pkx_1 | 0;
    result = imul(result, 31) + this.qkx_1.hashCode() | 0;
    result = imul(result, 31) + this.rkx_1 | 0;
    result = imul(result, 31) + this.skx_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this.nkx_1 === tmp0_other_with_cast.nkx_1))
      return false;
    if (!(this.okx_1 === tmp0_other_with_cast.okx_1))
      return false;
    if (!(this.pkx_1 === tmp0_other_with_cast.pkx_1))
      return false;
    if (!equalsLong(this.qkx_1, tmp0_other_with_cast.qkx_1))
      return false;
    if (!(this.rkx_1 === tmp0_other_with_cast.rkx_1))
      return false;
    if (!(this.skx_1 === tmp0_other_with_cast.skx_1))
      return false;
    return true;
  }
}
class Companion_8 {}
class AudioSamplesDeque {
  constructor(channels) {
    this.qks_1 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.qks_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new ShortArrayDeque();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.rks_1 = tmp_2;
  }
  za0() {
    var tmp34_safe_receiver = getOrNull_0(this.rks_1, 0);
    var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.za0();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  hky() {
    var tmp0 = this.rks_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0) {
        tmp$ret$0 = null;
        break $l$block;
      }
      var maxValue = tmp0[0].za0();
      var inductionVariable = 1;
      var last = get_lastIndex(tmp0);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var v = tmp0[i].za0();
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$0 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  iky(channel) {
    return _AudioSample___init__impl__s54gd5(this.rks_1[channel].va1());
  }
  jky(channel, sample) {
    this.rks_1[channel].wa1(_AudioSample___get_short__impl__uk8ygu(sample));
  }
  kky(samples, offset, len) {
    var inductionVariable = 0;
    var last = this.qks_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.lky(channel, samples.qhh(channel % samples.zhf_1 | 0), offset, len);
      }
       while (inductionVariable < last);
  }
  lky(channel, data, offset, len) {
    this.rks_1[channel].ua1(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
  }
  mky(data, offset, len, channels) {
    switch (channels) {
      case 1:
        var inductionVariable = 0;
        var last = this.qks_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.rks_1[n].ua1(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
          }
           while (inductionVariable < last);
        break;
      case 2:
        var inductionVariable_0 = 0;
        var last_0 = len / 2 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.jky(0, AudioSampleArray__get_impl_w0l0xc(data, imul(n_0, 2) + 0 | 0));
          }
           while (inductionVariable_0 < last_0);
        var inductionVariable_1 = 0;
        var last_1 = len / 2 | 0;
        if (inductionVariable_1 < last_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this.jky(1, AudioSampleArray__get_impl_w0l0xc(data, imul(n_1, 2) + 1 | 0));
          }
           while (inductionVariable_1 < last_1);
        break;
      default:
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < channels)
          do {
            var c = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var inductionVariable_3 = 0;
            var last_2 = len / channels | 0;
            if (inductionVariable_3 < last_2)
              do {
                var n_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                this.jky(c, AudioSampleArray__get_impl_w0l0xc(data, imul(n_2, channels) + c | 0));
              }
               while (inductionVariable_3 < last_2);
          }
           while (inductionVariable_2 < channels);
        break;
    }
  }
  vks(data, offset, len, channels, $super) {
    len = len === VOID ? _AudioSampleArray___get_size__impl__8l8tm8(data) - offset | 0 : len;
    channels = channels === VOID ? this.qks_1 : channels;
    var tmp;
    if ($super === VOID) {
      this.mky(data, offset, len, channels);
      tmp = Unit_instance;
    } else {
      tmp = $super.mky.call(this, new AudioSampleArray(data), offset, len, channels);
    }
    return tmp;
  }
  wkt(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.za0();
    var rlen = Math.min(len, b);
    var inductionVariable = 0;
    var last = out.zhf_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.rks_1[channel % this.qks_1 | 0].ta1(AudioSampleArray__asShortArray_impl_iyd0md(out.qhh(channel)), offset, rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  nky(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.ahg_1 - offset | 0 : len;
    return $super === VOID ? this.wkt(out, offset, len) : $super.wkt.call(this, out, offset, len);
  }
  oky(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.za0();
    var rlen = Math.min(len, b);
    var channels = this.qks_1;
    var inductionVariable = 0;
    var last = out.whg_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inChannel = channel % channels | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < rlen)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.rhh(channel, offset + n | 0, this.iky(inChannel));
          }
           while (inductionVariable_0 < rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  pky(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.xhg_1 - offset | 0 : len;
    return $super === VOID ? this.oky(out, offset, len) : $super.oky.call(this, out, offset, len);
  }
  a5() {
    var inductionVariable = 0;
    var last = this.rks_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.rks_1[c].a5();
      }
       while (inductionVariable <= last);
  }
  toString() {
    return 'AudioSamplesDeque(channels=' + this.qks_1 + ', availableRead=' + this.za0() + ')';
  }
}
class Companion_9 {}
class Companion_10 {
  constructor() {
    Companion_instance_11 = this;
    this.qky_1 = _PlaybackTimes___init__impl__rt6rw2(0);
    this.rky_1 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.sky_1 = _PlaybackTimes___init__impl__rt6rw2(-1);
  }
}
class PlaybackTimes {
  constructor(count) {
    Companion_getInstance_14();
    this.tky_1 = count;
  }
  toString() {
    return PlaybackTimes__toString_impl_l4chjq(this.tky_1);
  }
  hashCode() {
    return PlaybackTimes__hashCode_impl_mtf95(this.tky_1);
  }
  equals(other) {
    return PlaybackTimes__equals_impl_suah7n(this.tky_1, other);
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    var tmp_0 = _PlaybackTimes___init__impl__rt6rw2(1);
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    tmp.uky_1 = new PlaybackParameters(tmp_0, tmp$ret$1);
  }
}
class PlaybackParameters {
  constructor(times, startTime, bufferTime, volume, pitch, panning, position, onCancel, onFinish) {
    Companion_getInstance_15();
    var tmp;
    if (times === VOID) {
      // Inline function 'korlibs.audio.sound.playbackTimes' call
      tmp = _PlaybackTimes___init__impl__rt6rw2(1);
    } else {
      tmp = times;
    }
    times = tmp;
    var tmp_0;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = startTime;
    }
    startTime = tmp_0;
    var tmp_1;
    if (bufferTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = bufferTime;
    }
    bufferTime = tmp_1;
    volume = volume === VOID ? 1.0 : volume;
    pitch = pitch === VOID ? 1.0 : pitch;
    panning = panning === VOID ? 0.0 : panning;
    position = position === VOID ? Companion_getInstance_2().v9t_1 : position;
    onCancel = onCancel === VOID ? null : onCancel;
    onFinish = onFinish === VOID ? null : onFinish;
    this.vky_1 = times;
    this.wky_1 = startTime;
    this.xky_1 = bufferTime;
    this.yky_1 = volume;
    this.zky_1 = pitch;
    this.akz_1 = panning;
    this.bkz_1 = position;
    this.ckz_1 = onCancel;
    this.dkz_1 = onFinish;
  }
  bhh() {
    return this.yky_1;
  }
  ihh() {
    return this.zky_1;
  }
  dhh() {
    return this.akz_1;
  }
  wb6() {
    return this.bkz_1;
  }
  toString() {
    return 'PlaybackParameters(times=' + PlaybackTimes__toString_impl_l4chjq(this.vky_1) + ', startTime=' + Duration__toString_impl_8d916b(this.wky_1) + ', bufferTime=' + Duration__toString_impl_8d916b(this.xky_1) + ', volume=' + this.yky_1 + ', pitch=' + this.zky_1 + ', panning=' + this.akz_1 + ', position=' + this.bkz_1.toString() + ', onCancel=' + toString_0(this.ckz_1) + ', onFinish=' + toString_0(this.dkz_1) + ')';
  }
  hashCode() {
    var result = PlaybackTimes__hashCode_impl_mtf95(this.vky_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.wky_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.xky_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.yky_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.zky_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.akz_1) | 0;
    result = imul(result, 31) + this.bkz_1.hashCode() | 0;
    result = imul(result, 31) + (this.ckz_1 == null ? 0 : hashCode(this.ckz_1)) | 0;
    result = imul(result, 31) + (this.dkz_1 == null ? 0 : hashCode(this.dkz_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!(this.vky_1 === tmp0_other_with_cast.vky_1))
      return false;
    if (!equals(this.wky_1, tmp0_other_with_cast.wky_1))
      return false;
    if (!equals(this.xky_1, tmp0_other_with_cast.xky_1))
      return false;
    if (!equals(this.yky_1, tmp0_other_with_cast.yky_1))
      return false;
    if (!equals(this.zky_1, tmp0_other_with_cast.zky_1))
      return false;
    if (!equals(this.akz_1, tmp0_other_with_cast.akz_1))
      return false;
    if (!this.bkz_1.equals(tmp0_other_with_cast.bkz_1))
      return false;
    if (!equals(this.ckz_1, tmp0_other_with_cast.ckz_1))
      return false;
    if (!equals(this.dkz_1, tmp0_other_with_cast.dkz_1))
      return false;
    return true;
  }
}
class SoundPlay {}
function *play(params, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.od();
  return this.nkz(tmp$ret$0, params);
}
function play$default(params, $completion, $super) {
  params = params === VOID ? Companion_getInstance_15().uky_1 : params;
  return $super === VOID ? this.okz(params, $completion) : /*#__NOINLINE__*/play(params, $completion);
}
class Sound {
  constructor(creationCoroutineContext) {
    this.ekz_1 = new Mixin();
    this.fkz_1 = creationCoroutineContext;
    this.gkz_1 = this.fkz_1;
    this.hkz_1 = 'UnknownNativeSound';
    this.ikz_1 = 1.0;
    this.jkz_1 = 0.0;
    this.kkz_1 = 1.0;
    this.lkz_1 = Companion_getInstance_2().v9t_1;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.mkz_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  }
  o9u(_set____db54di) {
    this.ekz_1.o9u(_set____db54di);
  }
  p9u() {
    return this.ekz_1.p9u();
  }
  h1() {
    return this.hkz_1;
  }
  ahh(_set____db54di) {
    this.ikz_1 = _set____db54di;
  }
  bhh() {
    return this.ikz_1;
  }
  chh(_set____db54di) {
    this.jkz_1 = _set____db54di;
  }
  dhh() {
    return this.jkz_1;
  }
  hhh(_set____db54di) {
    this.kkz_1 = _set____db54di;
  }
  ihh() {
    return this.kkz_1;
  }
  wb6() {
    return this.lkz_1;
  }
  nkz(coroutineContext, params) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  toString() {
    return "NativeSound('" + this.h1() + "')";
  }
}
class SoundChannel {
  constructor(sound, $box) {
    boxApply(this, $box);
    this.qkz_1 = new Mixin();
    this.rkz_1 = sound;
    this.skz_1 = Companion_getInstance_0().x9v();
    this.tkz_1 = 1.0;
    this.ukz_1 = 1.0;
    this.vkz_1 = 0.0;
    this.wkz_1 = Companion_getInstance_2().v9t_1;
  }
  o9u(_set____db54di) {
    this.qkz_1.o9u(_set____db54di);
  }
  p9u() {
    return this.qkz_1.p9u();
  }
  ahh(_set____db54di) {
    this.tkz_1 = _set____db54di;
  }
  bhh() {
    return this.tkz_1;
  }
  hhh(_set____db54di) {
    this.ukz_1 = _set____db54di;
  }
  ihh() {
    return this.ukz_1;
  }
  chh(_set____db54di) {
    this.vkz_1 = _set____db54di;
  }
  dhh() {
    return this.vkz_1;
  }
  wb6() {
    return this.wkz_1;
  }
}
class SoundAudioData$play$4 extends SoundChannel {
  constructor($nas, this$0, $pos, $box) {
    if ($box === VOID)
      $box = {};
    $box.hl0_1 = $nas;
    $box.il0_1 = this$0;
    $box.jl0_1 = $pos;
    super(this$0, $box);
    var tmp = this;
    var tmp_0;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_0 = $nas._v;
    }
    var tmp0 = tmp_0;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = AudioPlatformOutput$_get_volume_$ref_pi71ra(tmp0);
    tmp.el0_1 = getPropertyCallableRef('volume', 0, tmp_1, tmp_2, AudioPlatformOutput$_set_volume_$ref_afygm2(tmp0));
    var tmp_3 = this;
    var tmp_4;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_4 = $nas._v;
    }
    var tmp0_0 = tmp_4;
    var tmp_5 = KMutableProperty0;
    var tmp_6 = AudioPlatformOutput$_get_pitch_$ref_ezq4u2(tmp0_0);
    tmp_3.fl0_1 = getPropertyCallableRef('pitch', 0, tmp_5, tmp_6, AudioPlatformOutput$_set_pitch_$ref_qqjgqi(tmp0_0));
    var tmp_7 = this;
    var tmp_8;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_8 = $nas._v;
    }
    var tmp0_1 = tmp_8;
    var tmp_9 = KMutableProperty0;
    var tmp_10 = AudioPlatformOutput$_get_panning_$ref_61be3v(tmp0_1);
    tmp_7.gl0_1 = getPropertyCallableRef('panning', 0, tmp_9, tmp_10, AudioPlatformOutput$_set_panning_$ref_ypehjd(tmp0_1));
  }
  ahh(_set____db54di) {
    var tmp0 = this.el0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_volume_$ref_d7bcs2();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('volume', 1, tmp, tmp_0, SoundAudioData$play$o$_set_volume_$ref_s9jxxa());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  bhh() {
    var tmp0 = this.el0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_volume_$ref_d7bcs2();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('volume', 1, tmp, tmp_0, SoundAudioData$play$o$_set_volume_$ref_s9jxxa());
    return tmp0.get();
  }
  hhh(_set____db54di) {
    var tmp0 = this.fl0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_pitch_$ref_dqrv2q();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('pitch', 1, tmp, tmp_0, SoundAudioData$play$o$_set_pitch_$ref_rzhqhu());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  ihh() {
    var tmp0 = this.fl0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_pitch_$ref_dqrv2q();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pitch', 1, tmp, tmp_0, SoundAudioData$play$o$_set_pitch_$ref_rzhqhu());
    return tmp0.get();
  }
  chh(_set____db54di) {
    var tmp0 = this.gl0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_panning_$ref_dldt1f();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('panning', 1, tmp, tmp_0, SoundAudioData$play$o$_set_panning_$ref_r5c2lt());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  dhh() {
    var tmp0 = this.gl0_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioData$play$o$_get_panning_$ref_dldt1f();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('panning', 1, tmp, tmp_0, SoundAudioData$play$o$_set_panning_$ref_r5c2lt());
    return tmp0.get();
  }
}
class SoundAudioData extends Sound {
  constructor(coroutineContext, audioData, soundProvider, name) {
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = audioData.xhf_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    super(coroutineContext);
    this.tl0_1 = audioData;
    this.ul0_1 = soundProvider;
    this.vl0_1 = name;
  }
  h1() {
    return this.vl0_1;
  }
  nkz(coroutineContext, params) {
    var pos = {_v: 0};
    var times = {_v: new PlaybackTimes(params.vky_1)};
    var nas = {_v: null};
    var tmp = this.ul0_1;
    var tmp_0 = this.tl0_1.yhf();
    nas._v = tmp.zhh(tmp_0, this.tl0_1.vhf_1, SoundAudioData$play$lambda(times, pos, this, nas));
    var tmp_1;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_1 = nas._v;
    }
    copySoundPropsFromCombined(tmp_1, params, this);
    var tmp_2;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = nas._v;
    }
    tmp_2.fhh();
    var tmp_3 = SoundAudioData$play$lambda_0(nas);
    onCancel(coroutineContext, tmp_3, SoundAudioData$play$lambda_1(nas));
    return new SoundAudioData$play$4(nas, this, pos);
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.ml1_1 = ConcurrentPool.za8(VOID, VOID, SoundAudioStream$Companion$ID_POOL$lambda);
  }
}
class SoundAudioStream$play$1 extends SoundChannel {
  constructor($nas, this$0, $currentPositionRequest, $newStream, $playing, $job, $box) {
    if ($box === VOID)
      $box = {};
    $box.gl1_1 = $nas;
    $box.hl1_1 = this$0;
    $box.il1_1 = $currentPositionRequest;
    $box.jl1_1 = $newStream;
    $box.kl1_1 = $playing;
    $box.ll1_1 = $job;
    super(this$0.bl2_1, $box);
    var tmp = this;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = AudioPlatformOutput$_get_volume_$ref_pi71ra($nas);
    tmp.dl1_1 = getPropertyCallableRef('volume', 0, tmp_0, tmp_1, AudioPlatformOutput$_set_volume_$ref_afygm2($nas));
    var tmp_2 = this;
    var tmp_3 = KMutableProperty0;
    var tmp_4 = AudioPlatformOutput$_get_pitch_$ref_ezq4u2($nas);
    tmp_2.el1_1 = getPropertyCallableRef('pitch', 0, tmp_3, tmp_4, AudioPlatformOutput$_set_pitch_$ref_qqjgqi($nas));
    var tmp_5 = this;
    var tmp_6 = KMutableProperty0;
    var tmp_7 = AudioPlatformOutput$_get_panning_$ref_61be3v($nas);
    tmp_5.fl1_1 = getPropertyCallableRef('panning', 0, tmp_6, tmp_7, AudioPlatformOutput$_set_panning_$ref_ypehjd($nas));
  }
  ahh(_set____db54di) {
    var tmp0 = this.dl1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_volume_$ref_rofwy0();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('volume', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_volume_$ref_safjvw());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  bhh() {
    var tmp0 = this.dl1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_volume_$ref_rofwy0();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('volume', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_volume_$ref_safjvw());
    return tmp0.get();
  }
  hhh(_set____db54di) {
    var tmp0 = this.el1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_pitch_$ref_isv0ns();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('pitch', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_pitch_$ref_ahzfqs());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  ihh() {
    var tmp0 = this.el1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_pitch_$ref_isv0ns();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pitch', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_pitch_$ref_ahzfqs());
    return tmp0.get();
  }
  chh(_set____db54di) {
    var tmp0 = this.fl1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_panning_$ref_8yv887();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('panning', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_panning_$ref_lbiy3p());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  dhh() {
    var tmp0 = this.fl1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SoundAudioStream$play$o$_get_panning_$ref_8yv887();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('panning', 1, tmp, tmp_0, SoundAudioStream$play$o$_set_panning_$ref_lbiy3p());
    return tmp0.get();
  }
}
class SoundAudioStream extends Sound {
  constructor(coroutineContext, stream, soundProvider, closeStream, name, onComplete) {
    Companion_getInstance_16();
    closeStream = closeStream === VOID ? false : closeStream;
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = stream.qkt_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.wl1_1 = stream;
    this.xl1_1 = soundProvider;
    this.yl1_1 = closeStream;
    this.zl1_1 = name;
    this.al2_1 = onComplete;
    this.bl2_1 = this;
  }
  h1() {
    return this.zl1_1;
  }
  cl2() {
    return this.wl1_1.pkt_1;
  }
  nkz(coroutineContext, params) {
    var dequeLock = new Lock();
    var deque = new AudioSamplesDeque(this.cl2());
    var playing = {_v: true};
    var flushing = {_v: false};
    var newStream = {_v: null};
    var channelId = Companion_getInstance_16().ml1_1.ja8();
    var dispatcherName = 'SoundChannel-SoundAudioStream-' + channelId;
    var times = {_v: new PlaybackTimes(params.vky_1)};
    var BUFFER_SAMPLES = nextMultipleOf(numberToInt(this.wl1_1.okt_1 * get_seconds(params.xky_1)), Companion_instance.fhg_1);
    var tmp = this.xl1_1;
    var tmp_0 = this.cl2();
    var nas = tmp.zhh(tmp_0, this.wl1_1.okt_1, SoundAudioStream$play$lambda(dequeLock, flushing, deque, BUFFER_SAMPLES));
    copySoundPropsFromCombined(nas, params, this);
    var currentPositionRequest = {_v: null};
    var tmp_1 = CoroutineScope(coroutineContext);
    var job = launch(tmp_1, coroutineContext, VOID, SoundAudioStream$play$slambda(this, newStream, params, playing, times, nas, currentPositionRequest, dequeLock, deque, BUFFER_SAMPLES, flushing, channelId));
    return new SoundAudioStream$play$1(nas, this, currentPositionRequest, newStream, playing, job);
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  var tmp0 = defaultAudioFormats$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('defaultAudioFormats', 0, tmp, _get_defaultAudioFormats_$ref_wud6mx(), null);
  return tmp0.k3();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.qkm_1 = null;
  return $this;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.nkm([Companion_getInstance_11(), Companion_getInstance_8()]);
}
function AudioFormat$decodeStream$slambda(this$0, $data, $props) {
  return constructCallableReference(function *($this$withContext, $completion) {
    return yield* this$0.ukm($data, $props, $completion);
  }, 1);
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function invalidAudioFormat(message) {
  message = message === VOID ? 'invalid audio format' : message;
  _init_properties_AudioFormat_kt__9os7np();
  throw InvalidAudioFormatException.nkn(message);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function _get_defaultAudioFormats_$ref_wud6mx() {
  return constructCallableReference(() => get_defaultAudioFormats(), 0, 0, 514);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var ChannelMode_STEREO_instance;
var ChannelMode_JOINT_STEREO_instance;
var ChannelMode_DUAL_CHANNEL_instance;
var ChannelMode_SINGLE_CHANNEL_instance;
var Companion_instance_3;
function Companion_getInstance_6() {
  ChannelMode_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
function values() {
  return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
}
var ChannelMode_entriesInitialized;
function ChannelMode_initEntries() {
  if (ChannelMode_entriesInitialized)
    return Unit_instance;
  ChannelMode_entriesInitialized = true;
  ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
  ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
  ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
  ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
  Companion_getInstance_6();
}
function framesize($this, layer, bitrate, sample_rate, padding_bit) {
  if (sample_rate === 0) {
    // Inline function 'kotlin.error' call
    var message = 'division by 0';
    throw IllegalStateException.o(toString(message));
  }
  var tmp;
  if (layer === 1) {
    tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
  } else {
    tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
  }
  return tmp;
}
function ChannelMode_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_STEREO_instance;
}
function ChannelMode_JOINT_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_JOINT_STEREO_instance;
}
function ChannelMode_DUAL_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_DUAL_CHANNEL_instance;
}
function ChannelMode_SINGLE_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_SINGLE_CHANNEL_instance;
}
function *_getDuration($this, use_cbr_estimate, emit, $completion) {
  emit = emit === VOID ? null : emit;
  $this.bko_1.yb8_1 = new Long(0, 0);
  var fd = $this.bko_1.ub9();
  var len = yield* fd.pb8($completion);
  var durationMicroseconds = 0.0;
  var offset = yield* skipID3v2Tag($this, yield* readStream(fd, 100, $completion), $completion);
  var pos = offset;
  var info = null;
  var nframes = 0;
  var block2 = _UByteArrayInt___init__impl__xif7bu(new Int8Array(10));
  var fdbase = fd.xb8_1;
  var fdsync = toSyncOrNull(fdbase);
  var nreads = 0;
  var nskips = 0;
  var nasync = 0;
  try {
    $l$loop: while (compare(pos, len) < 0) {
      var tmp;
      if (!(fdsync == null)) {
        tmp = fdsync.kb8(pos, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10);
      } else {
        nasync = nasync + 1 | 0;
        fd.yb8_1 = pos;
        tmp = yield* readBytesUpTo_0(fd, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10, $completion);
      }
      var block2Size = tmp;
      nreads = nreads + 1 | 0;
      if (block2Size < 10)
        break $l$loop;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = pos;
      pos = add(this_0, fromInt(block2Size));
      if (UByteArrayInt__get_impl_px6q8a(block2, 0) === 255 && !((UByteArrayInt__get_impl_px6q8a(block2, 1) & 224) === 0)) {
        info = Companion_getInstance_7().jko(block2);
        if (emit == null)
          null;
        else
          emit(pos, durationMicroseconds, info);
        nframes = nframes + 1 | 0;
        $this.dko_1 = info;
        if (info.zkn_1 === 0) {
          // Inline function 'korlibs.time.microseconds' call
          var this_1 = durationMicroseconds;
          var tmp$ret$1 = toDuration(this_1, DurationUnit_MICROSECONDS_getInstance());
          return new Duration(tmp$ret$1);
        }
        var tmp0 = pos;
        // Inline function 'kotlin.Long.plus' call
        var other = info.zkn_1 - 10 | 0;
        pos = add(tmp0, fromInt(other));
        var tmp_0 = durationMicroseconds;
        var tmp0_0 = multiply(numberToLong(info.ako_1), new Long(1000000, 0));
        // Inline function 'kotlin.Long.div' call
        var other_0 = info.xkn_1;
        var tmp$ret$3 = divide(tmp0_0, fromInt(other_0));
        durationMicroseconds = tmp_0 + toNumber(tmp$ret$3);
      } else if (readString(openSync(_UByteArrayInt___get_bytes__impl__pj0ilc(block2)), 3) === 'TAG') {
        // Inline function 'kotlin.Long.plus' call
        var this_2 = pos;
        pos = add(this_2, fromInt(118));
      } else {
        // Inline function 'kotlin.Long.minus' call
        var this_3 = pos;
        pos = subtract(this_3, fromInt(9));
        nskips = nskips + 1 | 0;
      }
      if (!(info == null) && use_cbr_estimate) {
        // Inline function 'korlibs.time.microseconds' call
        var this_4 = yield* estimateDuration($this, info.wkn_1, info.ykn_1.skn_1, convertToInt(offset), $completion);
        var tmp$ret$6 = toDuration_0(this_4, DurationUnit_MICROSECONDS_getInstance());
        return new Duration(tmp$ret$6);
      }
    }
  }finally {
  }
  // Inline function 'korlibs.time.microseconds' call
  var this_5 = durationMicroseconds;
  var tmp$ret$7 = toDuration(this_5, DurationUnit_MICROSECONDS_getInstance());
  return new Duration(tmp$ret$7);
}
function *estimateDuration($this, bitrate, channels, offset, $completion) {
  var kbps = imul(bitrate, 1000) / 8 | 0;
  // Inline function 'kotlin.Long.minus' call
  var this_0 = $this.cko_1;
  var dataSize = subtract(this_0, fromInt(offset));
  // Inline function 'kotlin.Long.times' call
  var other = 2 / channels | 0;
  var tmp$ret$1 = multiply(dataSize, fromInt(other));
  // Inline function 'kotlin.Long.div' call
  var this_1 = multiply(tmp$ret$1, new Long(1000000, 0));
  return divide(this_1, fromInt(kbps));
}
function *skipID3v2Tag($this, block, $completion) {
  var b = block.ub9();
  if ((yield* readString_0(b, 3, Charsets_instance.ub4(), $completion)) === 'ID3') {
    var bb = yield* readBytesExact(b, 7, $completion);
    var id3v2_major_version = getU8(bb, 0);
    var id3v2_minor_version = getU8(bb, 1);
    var id3v2_flags = getU8(bb, 2);
    var z0 = getU8(bb, 3);
    var z1 = getU8(bb, 4);
    var z2 = getU8(bb, 5);
    var z3 = getU8(bb, 6);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_unsynchronisation = !(((id3v2_flags >>> 7 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_extended_header = !(((id3v2_flags >>> 6 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_experimental_ind = !(((id3v2_flags >>> 5 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_footer_present = !(((id3v2_flags >>> 4 | 0) & 1) === 0);
    if ((z0 & 128) === 0 && (z1 & 128) === 0 && (z2 & 128) === 0 && (z3 & 128) === 0) {
      var header_size = 10;
      var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
      var footer_size = flag_footer_present ? 10 : 0;
      return fromInt((header_size + tag_size | 0) + footer_size | 0);
    }
  }
  return new Long(0, 0);
}
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function MP3Base$Parser$getSeekingTable$lambda($times, $filePositions) {
  return (filePos, totalMicro, info) => {
    $times.la3(totalMicro);
    $filePositions.la3(toNumber(filePos));
    return Unit_instance;
  };
}
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 === VOID)
    new Companion_4();
  return Companion_instance_5;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
function *createDecoderStream($this, data, props, table, $completion) {
  table = table === VOID ? null : table;
  var dataStartPosition = data.yb8_1;
  var decoder = $this.pks();
  decoder.wkp().ra8();
  var tmp;
  if (props.fkn_1 === true) {
    tmp = table == null ? (yield* data.qb8($completion)) ? (yield* (new Parser(data, yield* data.pb8($completion))).sko($completion)) : null : table;
  } else {
    tmp = null;
  }
  var mp3SeekingTable = {_v: tmp};
  yield* createDecoderStream$readMoreSamples(decoder, data, $completion);
  return new BaseMinimp3AudioFormat$createDecoderStream$2(decoder, mp3SeekingTable, data, table, $this, dataStartPosition, props);
}
var Companion_instance_6;
function Companion_getInstance_9() {
  if (Companion_instance_6 === VOID)
    new Companion_5();
  return Companion_instance_6;
}
function *createDecoderStream$readMoreSamples(decoder, $data, $completion) {
  $l$loop: while (true) {
    if (decoder.wkp().zkp_1.za0() < decoder.wkp().ykp_1.length && (yield* $data.vb9($completion))) {
      decoder.wkp().zkp_1.ba1(yield* readBytesUpTo($data, 4096, $completion));
    }
    var result = decoder.wkp().sks(decoder);
    if (decoder.wkp().bkq_1 === 0 || decoder.wkp().dkq_1 === 0)
      continue $l$loop;
    return result;
  }
}
function arrayOfUByte($this, values, size) {
  size = size === VOID ? values.length : size;
  return _UByteArrayInt___init__impl__xif7bu_0(size, MiniMp3Program$Companion$arrayOfUByte$lambda(values));
}
function arrayOfShort($this, values, size) {
  size = size === VOID ? values.length : size;
  var tmp = 0;
  var tmp_0 = new Int16Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    // Inline function 'kotlin.text.getOrElse' call
    var tmp_2;
    if (0 <= tmp_1 ? tmp_1 <= (charSequenceLength(values) - 1 | 0) : false) {
      tmp_2 = charSequenceGet(values, tmp_1);
    } else {
      tmp_2 = _Char___init__impl__6a9atx(0);
    }
    // Inline function 'kotlin.code' call
    var this_0 = tmp_2;
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
    tmp_0[tmp_1] = toShort(tmp$ret$3);
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function MiniMp3Program$Companion$arrayOfUByte$lambda($values) {
  return (it) => {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = $values;
    var tmp;
    if (0 <= it ? it <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, it);
    } else {
      tmp = _Char___init__impl__6a9atx(0);
    }
    // Inline function 'kotlin.code' call
    var this_1 = tmp;
    return Char__toInt_impl_vasixd(this_1);
  };
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function toInt_0($this, $receiver) {
  return $receiver ? 1 : 0;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function WAV$tryReadInfo$lambda(it) {
  return Unit_instance;
}
function WAV$decodeStreamInternal$lambda($fmt, $buffer) {
  return (it) => {
    var extra = it.mkx_1;
    var tmp;
    if (extra instanceof Fmt) {
      $fmt._v = extra;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (it.kkx_1 === 'data') {
      $buffer._v = it.lkx_1;
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function WAV$parse$slambda($fmt, $dataSize, $handle) {
  return constructCallableReference(function *($this$riff, $completion) {
    var type = $this$riff.jm();
    var d2 = $this$riff.km();
    var d = d2.ub9();
    var cdata = Unit_instance;
    var tmp;
    switch (type) {
      case 'fmt ':
        $fmt.nkx_1 = yield* readS16LE(d, $completion);
        $fmt.okx_1 = yield* readS16LE(d, $completion);
        $fmt.pkx_1 = yield* readS32LE(d, $completion);
        $fmt.qkx_1 = yield* readU32LE(d, $completion);
        $fmt.rkx_1 = yield* readS16LE(d, $completion);
        $fmt.skx_1 = yield* readS16LE(d, $completion);
        cdata = $fmt;
        tmp = Unit_instance;
        break;
      case 'data':
        $dataSize._v = add($dataSize._v, yield* d.pb8($completion));
        cdata = d;
        tmp = Unit_instance;
        break;
      default:
        tmp = Unit_instance;
        break;
    }
    $handle(new ProcessedChunk($this$riff.ikx_1, $this$riff.jkx_1, cdata));
    return Unit_instance;
  }, 1);
}
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
var DEFAULT_MAX_SAMPLES;
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function *toData(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  var out = new AudioSamplesDeque(_this__u8e3s4.pkt_1);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(maxSamples, 65536);
  var buffer = new AudioSamples(_this__u8e3s4.pkt_1, tmp$ret$0);
  try {
    $l$loop_0: while (!_this__u8e3s4.mkt()) {
      var tmp0 = maxSamples - out.za0() | 0;
      // Inline function 'kotlin.math.min' call
      var b = buffer.ahg_1;
      var tmp$ret$1 = Math.min(tmp0, b);
      var read = yield* _this__u8e3s4.vkt(buffer, 0, tmp$ret$1, $completion);
      if (read <= 0)
        break $l$loop_0;
      // Inline function 'kotlin.math.min' call
      var b_0 = maxSamples - out.za0() | 0;
      var mread = Math.min(read, b_0);
      out.kky(buffer, 0, mread);
      if (out.za0() >= maxSamples)
        break $l$loop_0;
    }
  }finally {
    _this__u8e3s4.f7();
  }
  var maxOutSamples = out.hky();
  // Inline function 'kotlin.apply' call
  var this_0 = new AudioSamples(_this__u8e3s4.pkt_1, maxOutSamples);
  out.nky(this_0);
  return new AudioData(_this__u8e3s4.okt_1, this_0);
}
function get_audioFormats(_this__u8e3s4) {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  var tmp0 = audioFormats$delegate;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('audioFormats', 1, tmp, _get_audioFormats_$ref_gdsvdg(), null);
  return tmp0.k3();
}
var audioFormats$delegate;
function *createSound(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().vkm_1 : props;
  return yield* createSound_0(_this__u8e3s4, yield* getUnderlyingUnscapedFile(file, $completion), streaming, props, $completion);
}
function *createSound_0(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().vkm_1 : props;
  return yield* createSound_1(_this__u8e3s4, file.ibf(), file.obf(), streaming, props, $completion);
}
function *createSound_1(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().vkm_1 : props;
  var tmp;
  if (streaming) {
    var vfsFile = vfs.cbg(path);
    var stream = props.gkn_1 ? openAsync(yield* vfsFile.pbh($completion)) : (yield* vfsFile.nbh(VOID, $completion));
    var tmp0_elvis_lhs = props.hkn_1;
    var tmp_0 = yield* (tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs).ykm(stream, props, $completion);
    var tmp_1 = get_baseName(vfsFile);
    tmp = yield* createStreamingSound(_this__u8e3s4, tmp_0, VOID, tmp_1, createSound$slambda(stream), $completion);
  } else {
    tmp = yield* createSound_2(_this__u8e3s4, yield* vfs.cbg(path).qbh($completion), streaming, props, get_baseName(vfs.wi(path)), $completion);
  }
  return tmp;
}
function *createStreamingSound(_this__u8e3s4, stream, closeStream, name, onComplete, $completion) {
  closeStream = closeStream === VOID ? false : closeStream;
  name = name === VOID ? 'Unknown' : name;
  onComplete = onComplete === VOID ? null : onComplete;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.od();
  return new SoundAudioStream(tmp$ret$0, stream, _this__u8e3s4, closeStream, name, onComplete);
}
function *createSound_2(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().vkm_1 : props;
  name = name === VOID ? 'Unknown' : name;
  var tmp0_elvis_lhs = props.hkn_1;
  var format = tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs;
  var stream = yield* format.ykm(openAsync(data), props, $completion);
  var tmp;
  if (streaming) {
    tmp = yield* /*#__NOINLINE__*/createStreamingSound(_this__u8e3s4, stream, true, name, VOID, $completion);
  } else {
    tmp = yield* createNonStreamingSound(_this__u8e3s4, yield* toData(stream, VOID, $completion), name, $completion);
  }
  return tmp;
}
function *createNonStreamingSound(_this__u8e3s4, data, name, $completion) {
  name = name === VOID ? 'Unknown' : name;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp = $completion.od();
  var tmp0_elvis_lhs = data.xhf_1;
  return new SoundAudioData(tmp, data, _this__u8e3s4, tmp0_elvis_lhs == null ? name : tmp0_elvis_lhs);
}
function audioFormats$delegate$lambda() {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  return get_defaultAudioFormats();
}
function _get_audioFormats_$ref_gdsvdg() {
  return constructCallableReference((p0) => get_audioFormats(p0), 1, 0, 515);
}
function createSound$slambda($stream) {
  return constructCallableReference(function *($completion) {
    yield* $stream.lb6($completion);
    return Unit_instance;
  }, 0);
}
var properties_initialized_NativeSoundProviderExt_kt_zegpk6;
function _init_properties_NativeSoundProviderExt_kt__owf0qw() {
  if (!properties_initialized_NativeSoundProviderExt_kt_zegpk6) {
    properties_initialized_NativeSoundProviderExt_kt_zegpk6 = true;
    audioFormats$delegate = lazy(audioFormats$delegate$lambda);
  }
}
function _PlaybackTimes___init__impl__rt6rw2(count) {
  return count;
}
function _PlaybackTimes___get_count__impl__ll6dcs($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  if (Companion_instance_11 === VOID)
    new Companion_10();
  return Companion_instance_11;
}
function _PlaybackTimes___get_hasMore__impl__ei8boc($this) {
  return !($this === Companion_getInstance_14().qky_1);
}
function _PlaybackTimes___get_oneLess__impl__ea0jl8($this) {
  return $this === Companion_getInstance_14().sky_1 ? Companion_getInstance_14().sky_1 : _PlaybackTimes___init__impl__rt6rw2(_PlaybackTimes___get_count__impl__ll6dcs($this) - 1 | 0);
}
function PlaybackTimes__toString_impl_l4chjq($this) {
  return _PlaybackTimes___get_count__impl__ll6dcs($this) >= 0 ? '' + _PlaybackTimes___get_count__impl__ll6dcs($this) + ' times' : 'Infinite times';
}
function PlaybackTimes__hashCode_impl_mtf95($this) {
  return $this;
}
function PlaybackTimes__equals_impl_suah7n($this, other) {
  if (!(other instanceof PlaybackTimes))
    return false;
  if (!($this === (other instanceof PlaybackTimes ? other.tky_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
function *readSound(_this__u8e3s4, props, streaming, $completion) {
  props = props === VOID ? Companion_getInstance_4().vkm_1 : props;
  streaming = streaming === VOID ? false : streaming;
  return yield* createSound(get_nativeSoundProvider(), _this__u8e3s4, streaming, props, $completion);
}
function copySoundPropsFromCombined(_this__u8e3s4, l, r) {
  _this__u8e3s4.ahh(l.bhh() * r.bhh());
  _this__u8e3s4.hhh(l.ihh() * r.ihh());
  _this__u8e3s4.chh(r.dhh());
}
function AudioPlatformOutput$_get_volume_$ref_pi71ra(p0) {
  return constructCallableReference(() => p0.phg_1, 0, 0, 516, VOID, [p0]);
}
function AudioPlatformOutput$_set_volume_$ref_afygm2(p0) {
  return constructCallableReference((p0_0) => {
    p0.phg_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 517, VOID, [p0]);
}
function SoundAudioData$play$o$_get_volume_$ref_d7bcs2() {
  return constructCallableReference((p0) => p0.bhh(), 1, 0, 518);
}
function SoundAudioData$play$o$_set_volume_$ref_s9jxxa() {
  return constructCallableReference((p0, p1) => {
    p0.ahh(p1);
    return Unit_instance;
  }, 2, 0, 519);
}
function AudioPlatformOutput$_get_pitch_$ref_ezq4u2(p0) {
  return constructCallableReference(() => p0.ihh(), 0, 0, 520, VOID, [p0]);
}
function AudioPlatformOutput$_set_pitch_$ref_qqjgqi(p0) {
  return constructCallableReference((p0_0) => {
    p0.hhh(p0_0);
    return Unit_instance;
  }, 1, 0, 521, VOID, [p0]);
}
function SoundAudioData$play$o$_get_pitch_$ref_dqrv2q() {
  return constructCallableReference((p0) => p0.ihh(), 1, 0, 522);
}
function SoundAudioData$play$o$_set_pitch_$ref_rzhqhu() {
  return constructCallableReference((p0, p1) => {
    p0.hhh(p1);
    return Unit_instance;
  }, 2, 0, 523);
}
function AudioPlatformOutput$_get_panning_$ref_61be3v(p0) {
  return constructCallableReference(() => p0.qhg_1, 0, 0, 524, VOID, [p0]);
}
function AudioPlatformOutput$_set_panning_$ref_ypehjd(p0) {
  return constructCallableReference((p0_0) => {
    p0.qhg_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 525, VOID, [p0]);
}
function SoundAudioData$play$o$_get_panning_$ref_dldt1f() {
  return constructCallableReference((p0) => p0.dhh(), 1, 0, 526);
}
function SoundAudioData$play$o$_set_panning_$ref_r5c2lt() {
  return constructCallableReference((p0, p1) => {
    p0.chh(p1);
    return Unit_instance;
  }, 2, 0, 527);
}
function SoundAudioData$play$lambda($times, $pos, this$0, $nas) {
  return (buffer) => {
    var tmp;
    if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().qky_1))) {
      return Unit_instance;
    }
    var inductionVariable = 0;
    var last = buffer.xhg_1;
    var tmp_0;
    if (inductionVariable < last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $pos._v;
        $pos._v = _unary__edvuaz + 1 | 0;
        var audioDataPos = _unary__edvuaz;
        if (audioDataPos >= this$0.tl0_1.chg() || $times._v.equals(new PlaybackTimes(Companion_getInstance_14().qky_1))) {
          $pos._v = 0;
          audioDataPos = 0;
          $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.tky_1));
          if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().qky_1))) {
            var tmp_1;
            if ($nas._v == null) {
              throwUninitializedPropertyAccessException('nas');
            } else {
              tmp_1 = $nas._v;
            }
            tmp_1.ghh();
            break $l$loop;
          }
        }
        var inductionVariable_0 = 0;
        var last_0 = buffer.whg_1;
        if (inductionVariable_0 < last_0)
          do {
            var ch = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var sample = audioDataPos < this$0.tl0_1.chg() ? this$0.tl0_1.dhg(ch, audioDataPos) : Companion_getInstance_1().zhg_1;
            buffer.rhh(ch, n, sample);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function SoundAudioData$play$lambda_0($nas) {
  return () => {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    return tmp.shg_1;
  };
}
function SoundAudioData$play$lambda_1($nas) {
  return (it) => {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    tmp.ghh();
    return Unit_instance;
  };
}
function SoundAudioStream$Companion$ID_POOL$lambda(it) {
  return it;
}
function SoundAudioStream$play$o$_get_volume_$ref_rofwy0() {
  return constructCallableReference((p0) => p0.bhh(), 1, 0, 528);
}
function SoundAudioStream$play$o$_set_volume_$ref_safjvw() {
  return constructCallableReference((p0, p1) => {
    p0.ahh(p1);
    return Unit_instance;
  }, 2, 0, 529);
}
function SoundAudioStream$play$o$_get_pitch_$ref_isv0ns() {
  return constructCallableReference((p0) => p0.ihh(), 1, 0, 530);
}
function SoundAudioStream$play$o$_set_pitch_$ref_ahzfqs() {
  return constructCallableReference((p0, p1) => {
    p0.hhh(p1);
    return Unit_instance;
  }, 2, 0, 531);
}
function SoundAudioStream$play$o$_get_panning_$ref_8yv887() {
  return constructCallableReference((p0) => p0.dhh(), 1, 0, 532);
}
function SoundAudioStream$play$o$_set_panning_$ref_lbiy3p() {
  return constructCallableReference((p0, p1) => {
    p0.chh(p1);
    return Unit_instance;
  }, 2, 0, 533);
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
function SoundAudioStream$play$lambda($dequeLock, $flushing, $deque, $BUFFER_SAMPLES) {
  return (it) => {
    AudioSampleArray__fill$default_impl_gh9lh0(it.yhg_1, Companion_getInstance_1().zhg_1);
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var tmp0 = $dequeLock;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      tmp0.n9w();
      try {
        if ($flushing._v || $deque.za0() >= $BUFFER_SAMPLES) {
          $deque.pky(it);
        }
        break $l$block;
      }finally {
        tmp0.p9w();
      }
    }
    return Unit_instance;
  };
}
function SoundAudioStream$play$slambda(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
  return constructCallableReference(function *($this$launch, $completion) {
    var stream = yield* this$0.wl1_1.xkt($completion);
    $newStream._v = stream;
    yield* stream.nkt($params.wky_1, $completion);
    $playing._v = true;
    try {
      var temp = new AudioSamples(stream.pkt_1, 2048);
      var started = false;
      while (_PlaybackTimes___get_hasMore__impl__ei8boc($times._v.tky_1)) {
        // Inline function 'korlibs.time.seconds' call
        // Inline function 'korlibs.time.seconds' call
        var tmp$ret$0 = toDuration(0, DurationUnit_SECONDS_getInstance());
        yield* stream.nkt(tmp$ret$0, $completion);
        $l$loop: while (true) {
          while ($nas.nhg_1) {
            // Inline function 'korlibs.time.milliseconds' call
            // Inline function 'kotlin.time.Companion.milliseconds' call
            Companion_getInstance();
            var tmp$ret$2 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
            yield* delay(tmp$ret$2, $completion);
          }
          if (!($currentPositionRequest._v == null)) {
            // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
            var tmp0 = $dequeLock;
            $l$block: {
              // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
              tmp0.n9w();
              try {
                $deque.a5();
                break $l$block;
              }finally {
                tmp0.p9w();
              }
            }
            yield* stream.nkt(ensureNotNull($currentPositionRequest._v).ik_1, $completion);
            $currentPositionRequest._v = null;
          }
          var read = yield* stream.vkt(temp, 0, temp.ahg_1, $completion);
          // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
          var tmp0_0 = $dequeLock;
          $l$block_0: {
            // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
            tmp0_0.n9w();
            try {
              $deque.kky(temp, 0, read);
              break $l$block_0;
            }finally {
              tmp0_0.p9w();
            }
          }
          if (stream.mkt() || $deque.za0() >= $BUFFER_SAMPLES) {
            if (!started) {
              started = true;
              $nas.fhh();
            } else if ($deque.za0() >= imul($BUFFER_SAMPLES, 2)) {
              while ($deque.za0() >= $BUFFER_SAMPLES) {
                // Inline function 'korlibs.time.milliseconds' call
                // Inline function 'kotlin.time.Companion.milliseconds' call
                Companion_getInstance();
                var tmp$ret$10 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
                yield* delay(tmp$ret$10, $completion);
              }
            }
          }
          yield* yield_0($completion);
          if (stream.mkt())
            break $l$loop;
        }
        yield* yield_0($completion);
        $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.tky_1));
      }
      $flushing._v = true;
      var n = 0;
      $l$loop_0: while (true) {
        var tmp;
        if ($nas.shg_1 && $deque.za0() > 0) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          tmp = _unary__edvuaz < 8;
        } else {
          tmp = false;
        }
        if (!tmp) {
          break $l$loop_0;
        }
        yield* delay_0(new Long(10, 0), $completion);
      }
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var e = $p;
        var tmp42_safe_receiver = $params.ckz_1;
        if (tmp42_safe_receiver == null)
          null;
        else
          tmp42_safe_receiver();
      } else {
        throw $p;
      }
    }
    finally {
      $nas.ghh();
      if (this$0.yl1_1) {
        stream.f7();
      }
      $playing._v = false;
      Companion_getInstance_16().ml1_1.ka8($channelId);
      var tmp43_safe_receiver = $params.dkz_1;
      if (tmp43_safe_receiver == null)
        null;
      else
        tmp43_safe_receiver();
      var tmp44_safe_receiver = this$0.al2_1;
      if (tmp44_safe_receiver == null)
        null;
      else
        yield* tmp44_safe_receiver($completion);
    }
    return Unit_instance;
  }, 1);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AudioDecodingProps, 'AudioDecodingProps', AudioDecodingProps);
initMetadataForClass(InvalidAudioFormatException, 'InvalidAudioFormatException');
initMetadataForClass(MP3Base, 'MP3Base', MP3Base, VOID, VOID, [2, 4]);
initMetadataForClass(MP3, 'MP3', MP3, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(ChannelMode, 'ChannelMode');
initMetadataForClass(Mp3Info, 'Mp3Info');
initMetadataForCompanion(Companion_3, VOID, VOID, [1]);
initMetadataForClass(SeekingTable, 'SeekingTable');
initMetadataForClass(Parser, 'Parser', VOID, VOID, VOID, [0, 2, 3, 1]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 4]);
initMetadataForClass(MiniMp3Program, 'MiniMp3Program', MiniMp3Program);
initMetadataForClass(Minimp3Decoder, 'Minimp3Decoder', Minimp3Decoder, VOID, [AutoCloseable]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMp3DecoderInfo, 'BaseMp3DecoderInfo', BaseMp3DecoderInfo);
initMetadataForCompanion(Companion_5);
initMetadataForClass(AudioStream, 'AudioStream', VOID, VOID, [AutoCloseable], [1, 3, 0]);
initMetadataForClass(BaseMinimp3AudioFormat$createDecoderStream$2, VOID, VOID, VOID, VOID, [1, 3, 0]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(L12_subband_alloc_tStruct, 'L12_subband_alloc_tStruct');
initMetadataForClass(Mp3Dec, 'Mp3Dec', Mp3Dec.nkp);
initMetadataForClass(Bs, 'Bs', Bs);
initMetadataForClass(Mp3Scratch, 'Mp3Scratch', Mp3Scratch.skv);
initMetadataForClass(Mp3FrameInfo, 'Mp3FrameInfo', Mp3FrameInfo);
initMetadataForClass(ArrayPtr, 'ArrayPtr');
initMetadataForClass(UByteArrayIntPtr, 'UByteArrayIntPtr');
initMetadataForClass(FloatArrayPtr, 'FloatArrayPtr');
initMetadataForClass(ShortArrayPtr, 'ShortArrayPtr');
initMetadataForClass(GrInfo, 'GrInfo', GrInfo);
initMetadataForClass(ScaleInfo, 'ScaleInfo', ScaleInfo);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_7, VOID, VOID, [2, 4]);
initMetadataForClass(Chunk, 'Chunk');
initMetadataForClass(ProcessedChunk, 'ProcessedChunk');
initMetadataForClass(WavAudioStream, 'WavAudioStream', VOID, VOID, VOID, [1, 3, 0]);
initMetadataForClass(Fmt, 'Fmt', Fmt);
initMetadataForCompanion(Companion_8);
initMetadataForClass(AudioSamplesDeque, 'AudioSamplesDeque');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(PlaybackTimes, 'PlaybackTimes');
initMetadataForCompanion(Companion_11);
initMetadataForClass(PlaybackParameters, 'PlaybackParameters', PlaybackParameters, VOID, [ReadonlySoundProps]);
initMetadataForInterface(SoundPlay, 'SoundPlay', VOID, VOID, VOID, [1, 2, 3]);
protoOf(Sound).okz = play;
protoOf(Sound).pkz = play$default;
initMetadataForClass(Sound, 'Sound', VOID, VOID, [SoundProps, SoundPlay], [1, 0, 2, 3]);
initMetadataForClass(SoundChannel, 'SoundChannel', VOID, VOID, [SoundProps]);
initMetadataForClass(SoundAudioData$play$4);
initMetadataForClass(SoundAudioData, 'SoundAudioData', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(SoundAudioStream$play$1);
initMetadataForClass(SoundAudioStream, 'SoundAudioStream', VOID, VOID, VOID, [1, 0, 2, 3]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_9 = new Companion_8();
DEFAULT_MAX_SAMPLES = 39690000;
Companion_instance_10 = new Companion_9();
//endregion
//region block: exports
export {
  readSound as readSoundsszptn4ctju3,
};
//endregion
